(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref96e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref96e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("j2gUH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ddbb52ea0b145119$export$6503ec6e8aabbaf; }, function (v) { return $ddbb52ea0b145119$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ddbb52ea0b145119$export$f7ad0328861e2f03; }, function (v) { return $ddbb52ea0b145119$export$f7ad0328861e2f03 = v; });
var $ddbb52ea0b145119$export$6503ec6e8aabbaf;
var $ddbb52ea0b145119$export$f7ad0328861e2f03;
"use strict";
var $ddbb52ea0b145119$var$mapping = new Map();
function $ddbb52ea0b145119$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ddbb52ea0b145119$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ddbb52ea0b145119$var$resolve(id) {
    var resolved = $ddbb52ea0b145119$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ddbb52ea0b145119$export$6503ec6e8aabbaf = $ddbb52ea0b145119$var$register;
$ddbb52ea0b145119$export$f7ad0328861e2f03 = $ddbb52ea0b145119$var$resolve;

});

parcelRegister("kZdQl", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $f4743e291daccce3$export$bdfd709ae4826697; }, function (v) { return $f4743e291daccce3$export$bdfd709ae4826697 = v; });
var $f4743e291daccce3$export$bdfd709ae4826697;
var $f4743e291daccce3$export$c9e73fbda7da57b6;
var $f4743e291daccce3$export$5a759dc7a1cfb72a;
"use strict";
var $f4743e291daccce3$var$bundleURL = {};
function $f4743e291daccce3$var$getBundleURLCached(id) {
    var value = $f4743e291daccce3$var$bundleURL[id];
    if (!value) {
        value = $f4743e291daccce3$var$getBundleURL();
        $f4743e291daccce3$var$bundleURL[id] = value;
    }
    return value;
}
function $f4743e291daccce3$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $f4743e291daccce3$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $f4743e291daccce3$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $f4743e291daccce3$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$f4743e291daccce3$export$bdfd709ae4826697 = $f4743e291daccce3$var$getBundleURLCached;
$f4743e291daccce3$export$c9e73fbda7da57b6 = $f4743e291daccce3$var$getBaseURL;
$f4743e291daccce3$export$5a759dc7a1cfb72a = $f4743e291daccce3$var$getOrigin;

});

parcelRegister("5h8v1", function(module, exports) {


module.exports = (parcelRequire("i3CFo"))((parcelRequire("j2gUH")).resolve("3xQXp")).then(()=>parcelRequire("4Spg3"));

});
parcelRegister("i3CFo", function(module, exports) {
"use strict";

var $csvIH = parcelRequire("csvIH");
module.exports = $csvIH(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("csvIH", function(module, exports) {
"use strict";
var $9120b47878b4b977$var$cachedBundles = {};
var $9120b47878b4b977$var$cachedPreloads = {};
var $9120b47878b4b977$var$cachedPrefetches = {};
function $9120b47878b4b977$var$getCache(type) {
    switch(type){
        case "preload":
            return $9120b47878b4b977$var$cachedPreloads;
        case "prefetch":
            return $9120b47878b4b977$var$cachedPrefetches;
        default:
            return $9120b47878b4b977$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $9120b47878b4b977$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $4542b730a1b31207$exports = {};


(parcelRequire("j2gUH")).register((parcelRequire("kZdQl")).getBundleURL("d8N9N"), JSON.parse('["d8N9N","scripts.js","3xQXp","shadow-css.a9e34d43.js"]'));

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/snabbdom/snabbdom/blob/master/LICENSE
 *
 * Modified for Stencil's renderer and slot projection
 */ const $6c97b4542f89f042$export$455dbfd86f20b704 = {
    allRenderFn: false,
    cmpDidLoad: true,
    cmpDidUnload: false,
    cmpDidUpdate: true,
    cmpDidRender: true,
    cmpWillLoad: true,
    cmpWillUpdate: true,
    cmpWillRender: true,
    connectedCallback: true,
    disconnectedCallback: true,
    element: true,
    event: true,
    hasRenderFn: true,
    lifecycle: true,
    hostListener: true,
    hostListenerTargetWindow: true,
    hostListenerTargetDocument: true,
    hostListenerTargetBody: true,
    hostListenerTargetParent: false,
    hostListenerTarget: true,
    member: true,
    method: true,
    mode: true,
    observeAttribute: true,
    prop: true,
    propMutable: true,
    reflect: true,
    scoped: true,
    shadowDom: true,
    slot: true,
    cssAnnotations: true,
    state: true,
    style: true,
    svg: true,
    updatable: true,
    vdomAttribute: true,
    vdomXlink: true,
    vdomClass: true,
    vdomFunctional: true,
    vdomKey: true,
    vdomListener: true,
    vdomRef: true,
    vdomPropOrAttr: true,
    vdomRender: true,
    vdomStyle: true,
    vdomText: true,
    watchCallback: true,
    taskQueue: true,
    hotModuleReplacement: false,
    isDebug: false,
    isDev: false,
    isTesting: false,
    hydrateServerSide: false,
    hydrateClientSide: false,
    lifecycleDOMEvents: false,
    lazyLoad: false,
    profile: false,
    slotRelocation: true,
    appendChildSlotFix: false,
    cloneNodeFix: false,
    hydratedAttribute: false,
    hydratedClass: true,
    safari10: false,
    scriptDataOpts: false,
    scopedSlotTextContentFix: false,
    shadowDomShim: false,
    slotChildNodesFix: false,
    invisiblePrehydration: true,
    propBoolean: true,
    propNumber: true,
    propString: true,
    cssVarShim: false,
    constructableCSS: true,
    cmpShouldUpdate: true,
    devTools: false,
    dynamicImportShim: false,
    shadowDelegatesFocus: true,
    initializeNextTick: false,
    asyncLoading: false,
    asyncQueue: false,
    transformTagName: false,
    attachStyles: true
};
const $6c97b4542f89f042$export$6c0517834721cef7 = {};
const $6c97b4542f89f042$export$6aad947bda0f3f46 = /* default */ "app";


let $8cd96f0f3be295d3$var$scopeId;
let $8cd96f0f3be295d3$var$contentRef;
let $8cd96f0f3be295d3$var$hostTagName;
let $8cd96f0f3be295d3$var$customError;
let $8cd96f0f3be295d3$var$i = 0;
let $8cd96f0f3be295d3$var$useNativeShadowDom = false;
let $8cd96f0f3be295d3$var$checkSlotFallbackVisibility = false;
let $8cd96f0f3be295d3$var$checkSlotRelocate = false;
let $8cd96f0f3be295d3$var$isSvgMode = false;
let $8cd96f0f3be295d3$var$renderingRef = null;
let $8cd96f0f3be295d3$var$queueCongestion = 0;
let $8cd96f0f3be295d3$var$queuePending = false;
const $8cd96f0f3be295d3$export$77b5f1d340d6466b = {
    isDev: (0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev ? true : false,
    isBrowser: true,
    isServer: false,
    isTesting: (0, $6c97b4542f89f042$export$455dbfd86f20b704).isTesting ? true : false
};
const $8cd96f0f3be295d3$export$841858b892ce1f4c = {};
const $8cd96f0f3be295d3$export$7c3997b47f2311d9 = (path)=>{
    const assetUrl = new URL(path, $8cd96f0f3be295d3$export$2e40610e9d23bca6.$resourcesUrl$);
    return assetUrl.origin !== $8cd96f0f3be295d3$export$10a0f131c0eea21b.location.origin ? assetUrl.href : assetUrl.pathname;
};
const $8cd96f0f3be295d3$export$4d21c79ffe6155ac = (path)=>$8cd96f0f3be295d3$export$2e40610e9d23bca6.$resourcesUrl$ = path;
const $8cd96f0f3be295d3$var$createTime = (fnName, tagName = "")=>{
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).profile && performance.mark) {
        const key = `st:${fnName}:${tagName}:${$8cd96f0f3be295d3$var$i++}`;
        // Start
        performance.mark(key);
        // End
        return ()=>performance.measure(`[Stencil] ${fnName}() <${tagName}>`, key);
    } else return ()=>{
        return;
    };
};
const $8cd96f0f3be295d3$var$uniqueTime = (key, measureText)=>{
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).profile && performance.mark) {
        if (performance.getEntriesByName(key, "mark").length === 0) performance.mark(key);
        return ()=>{
            if (performance.getEntriesByName(measureText, "measure").length === 0) performance.measure(measureText, key);
        };
    } else return ()=>{
        return;
    };
};
const $8cd96f0f3be295d3$var$inspect = (ref)=>{
    const hostRef = $8cd96f0f3be295d3$export$3f84770eccf215d2(ref);
    if (!hostRef) return undefined;
    const flags = hostRef.$flags$;
    const hostElement = hostRef.$hostElement$;
    return {
        renderCount: hostRef.$renderCount$,
        flags: {
            hasRendered: !!(flags & 2 /* HOST_FLAGS.hasRendered */ ),
            hasConnected: !!(flags & 1 /* HOST_FLAGS.hasConnected */ ),
            isWaitingForChildren: !!(flags & 4 /* HOST_FLAGS.isWaitingForChildren */ ),
            isConstructingInstance: !!(flags & 8 /* HOST_FLAGS.isConstructingInstance */ ),
            isQueuedForUpdate: !!(flags & 16 /* HOST_FLAGS.isQueuedForUpdate */ ),
            hasInitializedComponent: !!(flags & 32 /* HOST_FLAGS.hasInitializedComponent */ ),
            hasLoadedComponent: !!(flags & 64 /* HOST_FLAGS.hasLoadedComponent */ ),
            isWatchReady: !!(flags & 128 /* HOST_FLAGS.isWatchReady */ ),
            isListenReady: !!(flags & 256 /* HOST_FLAGS.isListenReady */ ),
            needsRerender: !!(flags & 512 /* HOST_FLAGS.needsRerender */ )
        },
        instanceValues: hostRef.$instanceValues$,
        ancestorComponent: hostRef.$ancestorComponent$,
        hostElement: hostElement,
        lazyInstance: hostRef.$lazyInstance$,
        vnode: hostRef.$vnode$,
        modeName: hostRef.$modeName$,
        onReadyPromise: hostRef.$onReadyPromise$,
        onReadyResolve: hostRef.$onReadyResolve$,
        onInstancePromise: hostRef.$onInstancePromise$,
        onInstanceResolve: hostRef.$onInstanceResolve$,
        onRenderResolve: hostRef.$onRenderResolve$,
        queuedListeners: hostRef.$queuedListeners$,
        rmListeners: hostRef.$rmListeners$,
        ["s-id"]: hostElement["s-id"],
        ["s-cr"]: hostElement["s-cr"],
        ["s-lr"]: hostElement["s-lr"],
        ["s-p"]: hostElement["s-p"],
        ["s-rc"]: hostElement["s-rc"],
        ["s-sc"]: hostElement["s-sc"]
    };
};
const $8cd96f0f3be295d3$var$installDevTools = ()=>{
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).devTools) {
        const stencil = $8cd96f0f3be295d3$export$10a0f131c0eea21b.stencil = $8cd96f0f3be295d3$export$10a0f131c0eea21b.stencil || {};
        const originalInspect = stencil.inspect;
        stencil.inspect = (ref)=>{
            let result = $8cd96f0f3be295d3$var$inspect(ref);
            if (!result && typeof originalInspect === "function") result = originalInspect(ref);
            return result;
        };
    }
};
const $8cd96f0f3be295d3$var$CONTENT_REF_ID = "r";
const $8cd96f0f3be295d3$var$ORG_LOCATION_ID = "o";
const $8cd96f0f3be295d3$var$SLOT_NODE_ID = "s";
const $8cd96f0f3be295d3$var$TEXT_NODE_ID = "t";
const $8cd96f0f3be295d3$var$HYDRATE_ID = "s-id";
const $8cd96f0f3be295d3$var$HYDRATED_STYLE_ID = "sty-id";
const $8cd96f0f3be295d3$var$HYDRATE_CHILD_ID = "c-id";
const $8cd96f0f3be295d3$var$HYDRATED_CSS = "{visibility:hidden}.hydrated{visibility:inherit}";
const $8cd96f0f3be295d3$var$XLINK_NS = "http://www.w3.org/1999/xlink";
/**
 * Default style mode id
 */ /**
 * Reusable empty obj/array
 * Don't add values to these!!
 */ const $8cd96f0f3be295d3$var$EMPTY_OBJ = {};
/**
 * Namespaces
 */ const $8cd96f0f3be295d3$var$SVG_NS = "http://www.w3.org/2000/svg";
const $8cd96f0f3be295d3$var$HTML_NS = "http://www.w3.org/1999/xhtml";
const $8cd96f0f3be295d3$var$isDef = (v)=>v != null;
const $8cd96f0f3be295d3$var$isComplexType = (o)=>{
    // https://jsperf.com/typeof-fn-object/5
    o = typeof o;
    return o === "object" || o === "function";
};
/**
 * Helper method for querying a `meta` tag that contains a nonce value
 * out of a DOM's head.
 *
 * @param doc The DOM containing the `head` to query against
 * @returns The content of the meta tag representing the nonce value, or `undefined` if no tag
 * exists or the tag has no content.
 */ function $8cd96f0f3be295d3$var$queryNonceMetaTagContent(doc) {
    var _a, _b, _c;
    return (_c = (_b = (_a = doc.head) === null || _a === void 0 ? void 0 : _a.querySelector('meta[name="csp-nonce"]')) === null || _b === void 0 ? void 0 : _b.getAttribute("content")) !== null && _c !== void 0 ? _c : undefined;
}
/**
 * Production h() function based on Preact by
 * Jason Miller (@developit)
 * Licensed under the MIT License
 * https://github.com/developit/preact/blob/master/LICENSE
 *
 * Modified for Stencil's compiler and vdom
 */ // export function h(nodeName: string | d.FunctionalComponent, vnodeData: d.PropsType, child?: d.ChildType): d.VNode;
// export function h(nodeName: string | d.FunctionalComponent, vnodeData: d.PropsType, ...children: d.ChildType[]): d.VNode;
const $8cd96f0f3be295d3$export$dda1d9f60106f0e9 = (nodeName, vnodeData, ...children)=>{
    let child = null;
    let key = null;
    let slotName = null;
    let simple = false;
    let lastSimple = false;
    const vNodeChildren = [];
    const walk = (c)=>{
        for(let i = 0; i < c.length; i++){
            child = c[i];
            if (Array.isArray(child)) walk(child);
            else if (child != null && typeof child !== "boolean") {
                if (simple = typeof nodeName !== "function" && !$8cd96f0f3be295d3$var$isComplexType(child)) child = String(child);
                else if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev && typeof nodeName !== "function" && child.$flags$ === undefined) $8cd96f0f3be295d3$export$47b52a6e53fbbc24(`vNode passed as children has unexpected type.
Make sure it's using the correct h() function.
Empty objects can also be the cause, look for JSX comments that became objects.`);
                if (simple && lastSimple) // If the previous child was simple (string), we merge both
                vNodeChildren[vNodeChildren.length - 1].$text$ += child;
                else // Append a new vNode, if it's text, we create a text vNode
                vNodeChildren.push(simple ? $8cd96f0f3be295d3$var$newVNode(null, child) : child);
                lastSimple = simple;
            }
        }
    };
    walk(children);
    if (vnodeData) {
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev && nodeName === "input") $8cd96f0f3be295d3$var$validateInputProperties(vnodeData);
        // normalize class / classname attributes
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomKey && vnodeData.key) key = vnodeData.key;
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation && vnodeData.name) slotName = vnodeData.name;
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomClass) {
            const classData = vnodeData.className || vnodeData.class;
            if (classData) vnodeData.class = typeof classData !== "object" ? classData : Object.keys(classData).filter((k)=>classData[k]).join(" ");
        }
    }
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev && vNodeChildren.some($8cd96f0f3be295d3$var$isHost)) $8cd96f0f3be295d3$export$47b52a6e53fbbc24(`The <Host> must be the single root component. Make sure:
- You are NOT using hostData() and <Host> in the same component.
- <Host> is used once, and it's the single root component of the render() function.`);
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomFunctional && typeof nodeName === "function") // nodeName is a functional component
    return nodeName(vnodeData === null ? {} : vnodeData, vNodeChildren, $8cd96f0f3be295d3$var$vdomFnUtils);
    const vnode = $8cd96f0f3be295d3$var$newVNode(nodeName, null);
    vnode.$attrs$ = vnodeData;
    if (vNodeChildren.length > 0) vnode.$children$ = vNodeChildren;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomKey) vnode.$key$ = key;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation) vnode.$name$ = slotName;
    return vnode;
};
/**
 * A utility function for creating a virtual DOM node from a tag and some
 * possible text content.
 *
 * @param tag the tag for this element
 * @param text possible text content for the node
 * @returns a newly-minted virtual DOM node
 */ const $8cd96f0f3be295d3$var$newVNode = (tag, text)=>{
    const vnode = {
        $flags$: 0,
        $tag$: tag,
        $text$: text,
        $elm$: null,
        $children$: null
    };
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomAttribute) vnode.$attrs$ = null;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomKey) vnode.$key$ = null;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation) vnode.$name$ = null;
    return vnode;
};
const $8cd96f0f3be295d3$export$5d2c872882e2b878 = {};
/**
 * Check whether a given node is a Host node or not
 *
 * @param node the virtual DOM node to check
 * @returns whether it's a Host node or not
 */ const $8cd96f0f3be295d3$var$isHost = (node)=>node && node.$tag$ === $8cd96f0f3be295d3$export$5d2c872882e2b878;
/**
 * Implementation of {@link d.FunctionalUtilities} for Stencil's VDom.
 *
 * Note that these functions convert from {@link d.VNode} to
 * {@link d.ChildNode} to give functional component developers a friendly
 * interface.
 */ const $8cd96f0f3be295d3$var$vdomFnUtils = {
    forEach: (children, cb)=>children.map($8cd96f0f3be295d3$var$convertToPublic).forEach(cb),
    map: (children, cb)=>children.map($8cd96f0f3be295d3$var$convertToPublic).map(cb).map($8cd96f0f3be295d3$var$convertToPrivate)
};
/**
 * Convert a {@link d.VNode} to a {@link d.ChildNode} in order to present a
 * friendlier public interface (hence, 'convertToPublic').
 *
 * @param node the virtual DOM node to convert
 * @returns a converted child node
 */ const $8cd96f0f3be295d3$var$convertToPublic = (node)=>({
        vattrs: node.$attrs$,
        vchildren: node.$children$,
        vkey: node.$key$,
        vname: node.$name$,
        vtag: node.$tag$,
        vtext: node.$text$
    });
/**
 * Convert a {@link d.ChildNode} back to an equivalent {@link d.VNode} in
 * order to use the resulting object in the virtual DOM. The initial object was
 * likely created as part of presenting a public API, so converting it back
 * involved making it 'private' again (hence, `convertToPrivate`).
 *
 * @param node the child node to convert
 * @returns a converted virtual DOM node
 */ const $8cd96f0f3be295d3$var$convertToPrivate = (node)=>{
    if (typeof node.vtag === "function") {
        const vnodeData = Object.assign({}, node.vattrs);
        if (node.vkey) vnodeData.key = node.vkey;
        if (node.vname) vnodeData.name = node.vname;
        return $8cd96f0f3be295d3$export$dda1d9f60106f0e9(node.vtag, vnodeData, ...node.vchildren || []);
    }
    const vnode = $8cd96f0f3be295d3$var$newVNode(node.vtag, node.vtext);
    vnode.$attrs$ = node.vattrs;
    vnode.$children$ = node.vchildren;
    vnode.$key$ = node.vkey;
    vnode.$name$ = node.vname;
    return vnode;
};
/**
 * Validates the ordering of attributes on an input element
 *
 * @param inputElm the element to validate
 */ const $8cd96f0f3be295d3$var$validateInputProperties = (inputElm)=>{
    const props = Object.keys(inputElm);
    const value = props.indexOf("value");
    if (value === -1) return;
    const typeIndex = props.indexOf("type");
    const minIndex = props.indexOf("min");
    const maxIndex = props.indexOf("max");
    const stepIndex = props.indexOf("step");
    if (value < typeIndex || value < minIndex || value < maxIndex || value < stepIndex) $8cd96f0f3be295d3$export$5d385f3b3df7e1b9(`The "value" prop of <input> should be set after "min", "max", "type" and "step"`);
};
const $8cd96f0f3be295d3$var$initializeClientHydrate = (hostElm, tagName, hostId, hostRef)=>{
    const endHydrate = $8cd96f0f3be295d3$var$createTime("hydrateClient", tagName);
    const shadowRoot = hostElm.shadowRoot;
    const childRenderNodes = [];
    const slotNodes = [];
    const shadowRootNodes = (0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDom && shadowRoot ? [] : null;
    const vnode = hostRef.$vnode$ = $8cd96f0f3be295d3$var$newVNode(tagName, null);
    if (!$8cd96f0f3be295d3$export$2e40610e9d23bca6.$orgLocNodes$) $8cd96f0f3be295d3$var$initializeDocumentHydrate($8cd96f0f3be295d3$export$2a111da947c407d2.body, $8cd96f0f3be295d3$export$2e40610e9d23bca6.$orgLocNodes$ = new Map());
    hostElm[$8cd96f0f3be295d3$var$HYDRATE_ID] = hostId;
    hostElm.removeAttribute($8cd96f0f3be295d3$var$HYDRATE_ID);
    $8cd96f0f3be295d3$var$clientHydrate(vnode, childRenderNodes, slotNodes, shadowRootNodes, hostElm, hostElm, hostId);
    childRenderNodes.map((c)=>{
        const orgLocationId = c.$hostId$ + "." + c.$nodeId$;
        const orgLocationNode = $8cd96f0f3be295d3$export$2e40610e9d23bca6.$orgLocNodes$.get(orgLocationId);
        const node = c.$elm$;
        if (orgLocationNode && $8cd96f0f3be295d3$export$b4e7e6d61dbcd813 && orgLocationNode["s-en"] === "") orgLocationNode.parentNode.insertBefore(node, orgLocationNode.nextSibling);
        if (!shadowRoot) {
            node["s-hn"] = tagName;
            if (orgLocationNode) {
                node["s-ol"] = orgLocationNode;
                node["s-ol"]["s-nr"] = node;
            }
        }
        $8cd96f0f3be295d3$export$2e40610e9d23bca6.$orgLocNodes$.delete(orgLocationId);
    });
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDom && shadowRoot) shadowRootNodes.map((shadowRootNode)=>{
        if (shadowRootNode) shadowRoot.appendChild(shadowRootNode);
    });
    endHydrate();
};
const $8cd96f0f3be295d3$var$clientHydrate = (parentVNode, childRenderNodes, slotNodes, shadowRootNodes, hostElm, node, hostId)=>{
    let childNodeType;
    let childIdSplt;
    let childVNode;
    let i;
    if (node.nodeType === 1 /* NODE_TYPE.ElementNode */ ) {
        childNodeType = node.getAttribute($8cd96f0f3be295d3$var$HYDRATE_CHILD_ID);
        if (childNodeType) {
            // got the node data from the element's attribute
            // `${hostId}.${nodeId}.${depth}.${index}`
            childIdSplt = childNodeType.split(".");
            if (childIdSplt[0] === hostId || childIdSplt[0] === "0") {
                childVNode = {
                    $flags$: 0,
                    $hostId$: childIdSplt[0],
                    $nodeId$: childIdSplt[1],
                    $depth$: childIdSplt[2],
                    $index$: childIdSplt[3],
                    $tag$: node.tagName.toLowerCase(),
                    $elm$: node,
                    $attrs$: null,
                    $children$: null,
                    $key$: null,
                    $name$: null,
                    $text$: null
                };
                childRenderNodes.push(childVNode);
                node.removeAttribute($8cd96f0f3be295d3$var$HYDRATE_CHILD_ID);
                // this is a new child vnode
                // so ensure its parent vnode has the vchildren array
                if (!parentVNode.$children$) parentVNode.$children$ = [];
                // add our child vnode to a specific index of the vnode's children
                parentVNode.$children$[childVNode.$index$] = childVNode;
                // this is now the new parent vnode for all the next child checks
                parentVNode = childVNode;
                if (shadowRootNodes && childVNode.$depth$ === "0") shadowRootNodes[childVNode.$index$] = childVNode.$elm$;
            }
        }
        // recursively drill down, end to start so we can remove nodes
        for(i = node.childNodes.length - 1; i >= 0; i--)$8cd96f0f3be295d3$var$clientHydrate(parentVNode, childRenderNodes, slotNodes, shadowRootNodes, hostElm, node.childNodes[i], hostId);
        if (node.shadowRoot) // keep drilling down through the shadow root nodes
        for(i = node.shadowRoot.childNodes.length - 1; i >= 0; i--)$8cd96f0f3be295d3$var$clientHydrate(parentVNode, childRenderNodes, slotNodes, shadowRootNodes, hostElm, node.shadowRoot.childNodes[i], hostId);
    } else if (node.nodeType === 8 /* NODE_TYPE.CommentNode */ ) {
        // `${COMMENT_TYPE}.${hostId}.${nodeId}.${depth}.${index}`
        childIdSplt = node.nodeValue.split(".");
        if (childIdSplt[1] === hostId || childIdSplt[1] === "0") {
            // comment node for either the host id or a 0 host id
            childNodeType = childIdSplt[0];
            childVNode = {
                $flags$: 0,
                $hostId$: childIdSplt[1],
                $nodeId$: childIdSplt[2],
                $depth$: childIdSplt[3],
                $index$: childIdSplt[4],
                $elm$: node,
                $attrs$: null,
                $children$: null,
                $key$: null,
                $name$: null,
                $tag$: null,
                $text$: null
            };
            if (childNodeType === $8cd96f0f3be295d3$var$TEXT_NODE_ID) {
                childVNode.$elm$ = node.nextSibling;
                if (childVNode.$elm$ && childVNode.$elm$.nodeType === 3 /* NODE_TYPE.TextNode */ ) {
                    childVNode.$text$ = childVNode.$elm$.textContent;
                    childRenderNodes.push(childVNode);
                    // remove the text comment since it's no longer needed
                    node.remove();
                    if (!parentVNode.$children$) parentVNode.$children$ = [];
                    parentVNode.$children$[childVNode.$index$] = childVNode;
                    if (shadowRootNodes && childVNode.$depth$ === "0") shadowRootNodes[childVNode.$index$] = childVNode.$elm$;
                }
            } else if (childVNode.$hostId$ === hostId) {
                // this comment node is specifcally for this host id
                if (childNodeType === $8cd96f0f3be295d3$var$SLOT_NODE_ID) {
                    // `${SLOT_NODE_ID}.${hostId}.${nodeId}.${depth}.${index}.${slotName}`;
                    childVNode.$tag$ = "slot";
                    if (childIdSplt[5]) node["s-sn"] = childVNode.$name$ = childIdSplt[5];
                    else node["s-sn"] = "";
                    node["s-sr"] = true;
                    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDom && shadowRootNodes) {
                        // browser support shadowRoot and this is a shadow dom component
                        // create an actual slot element
                        childVNode.$elm$ = $8cd96f0f3be295d3$export$2a111da947c407d2.createElement(childVNode.$tag$);
                        if (childVNode.$name$) // add the slot name attribute
                        childVNode.$elm$.setAttribute("name", childVNode.$name$);
                        // insert the new slot element before the slot comment
                        node.parentNode.insertBefore(childVNode.$elm$, node);
                        // remove the slot comment since it's not needed for shadow
                        node.remove();
                        if (childVNode.$depth$ === "0") shadowRootNodes[childVNode.$index$] = childVNode.$elm$;
                    }
                    slotNodes.push(childVNode);
                    if (!parentVNode.$children$) parentVNode.$children$ = [];
                    parentVNode.$children$[childVNode.$index$] = childVNode;
                } else if (childNodeType === $8cd96f0f3be295d3$var$CONTENT_REF_ID) {
                    // `${CONTENT_REF_ID}.${hostId}`;
                    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDom && shadowRootNodes) // remove the content ref comment since it's not needed for shadow
                    node.remove();
                    else if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation) {
                        hostElm["s-cr"] = node;
                        node["s-cn"] = true;
                    }
                }
            }
        }
    } else if (parentVNode && parentVNode.$tag$ === "style") {
        const vnode = $8cd96f0f3be295d3$var$newVNode(null, node.textContent);
        vnode.$elm$ = node;
        vnode.$index$ = "0";
        parentVNode.$children$ = [
            vnode
        ];
    }
};
const $8cd96f0f3be295d3$var$initializeDocumentHydrate = (node, orgLocNodes)=>{
    if (node.nodeType === 1 /* NODE_TYPE.ElementNode */ ) {
        let i = 0;
        for(; i < node.childNodes.length; i++)$8cd96f0f3be295d3$var$initializeDocumentHydrate(node.childNodes[i], orgLocNodes);
        if (node.shadowRoot) for(i = 0; i < node.shadowRoot.childNodes.length; i++)$8cd96f0f3be295d3$var$initializeDocumentHydrate(node.shadowRoot.childNodes[i], orgLocNodes);
    } else if (node.nodeType === 8 /* NODE_TYPE.CommentNode */ ) {
        const childIdSplt = node.nodeValue.split(".");
        if (childIdSplt[0] === $8cd96f0f3be295d3$var$ORG_LOCATION_ID) {
            orgLocNodes.set(childIdSplt[1] + "." + childIdSplt[2], node);
            node.nodeValue = "";
            // useful to know if the original location is
            // the root light-dom of a shadow dom component
            node["s-en"] = childIdSplt[3];
        }
    }
};
// Private
const $8cd96f0f3be295d3$var$computeMode = (elm)=>$8cd96f0f3be295d3$export$31c64a1f6cd0f6.map((h)=>h(elm)).find((m)=>!!m);
// Public
const $8cd96f0f3be295d3$export$d4f039427a1beff1 = (handler)=>$8cd96f0f3be295d3$export$31c64a1f6cd0f6.push(handler);
const $8cd96f0f3be295d3$export$1fc0f6205829e19c = (ref)=>$8cd96f0f3be295d3$export$3f84770eccf215d2(ref).$modeName$;
/**
 * Parse a new property value for a given property type.
 *
 * While the prop value can reasonably be expected to be of `any` type as far as TypeScript's type checker is concerned,
 * it is not safe to assume that the string returned by evaluating `typeof propValue` matches:
 *   1. `any`, the type given to `propValue` in the function signature
 *   2. the type stored from `propType`.
 *
 * This function provides the capability to parse/coerce a property's value to potentially any other JavaScript type.
 *
 * Property values represented in TSX preserve their type information. In the example below, the number 0 is passed to
 * a component. This `propValue` will preserve its type information (`typeof propValue === 'number'`). Note that is
 * based on the type of the value being passed in, not the type declared of the class member decorated with `@Prop`.
 * ```tsx
 * <my-cmp prop-val={0}></my-cmp>
 * ```
 *
 * HTML prop values on the other hand, will always a string
 *
 * @param propValue the new value to coerce to some type
 * @param propType the type of the prop, expressed as a binary number
 * @returns the parsed/coerced value
 */ const $8cd96f0f3be295d3$export$480b8c8d1e35b434 = (propValue, propType)=>{
    // ensure this value is of the correct prop type
    if (propValue != null && !$8cd96f0f3be295d3$var$isComplexType(propValue)) {
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).propBoolean && propType & 4 /* MEMBER_FLAGS.Boolean */ ) // per the HTML spec, any string value means it is a boolean true value
        // but we'll cheat here and say that the string "false" is the boolean false
        return propValue === "false" ? false : propValue === "" || !!propValue;
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).propNumber && propType & 2 /* MEMBER_FLAGS.Number */ ) // force it to be a number
        return parseFloat(propValue);
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).propString && propType & 1 /* MEMBER_FLAGS.String */ ) // could have been passed as a number or boolean
        // but we still want it as a string
        return String(propValue);
        // redundant return here for better minification
        return propValue;
    }
    // not sure exactly what type we want
    // so no need to change to a different type
    return propValue;
};
const $8cd96f0f3be295d3$export$d16800b7e59a8051 = (ref)=>(0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad ? $8cd96f0f3be295d3$export$3f84770eccf215d2(ref).$hostElement$ : ref;
const $8cd96f0f3be295d3$export$c30017717ce2168e = (ref, name, flags)=>{
    const elm = $8cd96f0f3be295d3$export$d16800b7e59a8051(ref);
    return {
        emit: (detail)=>{
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev && !elm.isConnected) $8cd96f0f3be295d3$export$5d385f3b3df7e1b9(`The "${name}" event was emitted, but the dispatcher node is no longer connected to the dom.`);
            return $8cd96f0f3be295d3$var$emitEvent(elm, name, {
                bubbles: !!(flags & 4 /* EVENT_FLAGS.Bubbles */ ),
                composed: !!(flags & 2 /* EVENT_FLAGS.Composed */ ),
                cancelable: !!(flags & 1 /* EVENT_FLAGS.Cancellable */ ),
                detail: detail
            });
        }
    };
};
/**
 * Helper function to create & dispatch a custom Event on a provided target
 * @param elm the target of the Event
 * @param name the name to give the custom Event
 * @param opts options for configuring a custom Event
 * @returns the custom Event
 */ const $8cd96f0f3be295d3$var$emitEvent = (elm, name, opts)=>{
    const ev = $8cd96f0f3be295d3$export$2e40610e9d23bca6.ce(name, opts);
    elm.dispatchEvent(ev);
    return ev;
};
const $8cd96f0f3be295d3$var$rootAppliedStyles = /*@__PURE__*/ new WeakMap();
const $8cd96f0f3be295d3$var$registerStyle = (scopeId, cssText, allowCS)=>{
    let style = $8cd96f0f3be295d3$export$9dd6ff9ea0189349.get(scopeId);
    if ($8cd96f0f3be295d3$export$27b311cd1cb97100 && allowCS) {
        style = style || new CSSStyleSheet();
        if (typeof style === "string") style = cssText;
        else style.replaceSync(cssText);
    } else style = cssText;
    $8cd96f0f3be295d3$export$9dd6ff9ea0189349.set(scopeId, style);
};
const $8cd96f0f3be295d3$var$addStyle = (styleContainerNode, cmpMeta, mode, hostElm)=>{
    var _a;
    let scopeId = $8cd96f0f3be295d3$var$getScopeId(cmpMeta, mode);
    const style = $8cd96f0f3be295d3$export$9dd6ff9ea0189349.get(scopeId);
    if (!(0, $6c97b4542f89f042$export$455dbfd86f20b704).attachStyles) return scopeId;
    // if an element is NOT connected then getRootNode() will return the wrong root node
    // so the fallback is to always use the document for the root node in those cases
    styleContainerNode = styleContainerNode.nodeType === 11 /* NODE_TYPE.DocumentFragment */  ? styleContainerNode : $8cd96f0f3be295d3$export$2a111da947c407d2;
    if (style) {
        if (typeof style === "string") {
            styleContainerNode = styleContainerNode.head || styleContainerNode;
            let appliedStyles = $8cd96f0f3be295d3$var$rootAppliedStyles.get(styleContainerNode);
            let styleElm;
            if (!appliedStyles) $8cd96f0f3be295d3$var$rootAppliedStyles.set(styleContainerNode, appliedStyles = new Set());
            if (!appliedStyles.has(scopeId)) {
                if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateClientSide && styleContainerNode.host && (styleElm = styleContainerNode.querySelector(`[${$8cd96f0f3be295d3$var$HYDRATED_STYLE_ID}="${scopeId}"]`))) // This is only happening on native shadow-dom, do not needs CSS var shim
                styleElm.innerHTML = style;
                else {
                    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).cssVarShim && $8cd96f0f3be295d3$export$2e40610e9d23bca6.$cssShim$) {
                        styleElm = $8cd96f0f3be295d3$export$2e40610e9d23bca6.$cssShim$.createHostStyle(hostElm, scopeId, style, !!(cmpMeta.$flags$ & 10 /* CMP_FLAGS.needsScopedEncapsulation */ ));
                        const newScopeId = styleElm["s-sc"];
                        if (newScopeId) {
                            scopeId = newScopeId;
                            // we don't want to add this styleID to the appliedStyles Set
                            // since the cssVarShim might need to apply several different
                            // stylesheets for the same component
                            appliedStyles = null;
                        }
                    } else {
                        styleElm = $8cd96f0f3be295d3$export$2a111da947c407d2.createElement("style");
                        styleElm.innerHTML = style;
                    }
                    // Apply CSP nonce to the style tag if it exists
                    const nonce = (_a = $8cd96f0f3be295d3$export$2e40610e9d23bca6.$nonce$) !== null && _a !== void 0 ? _a : $8cd96f0f3be295d3$var$queryNonceMetaTagContent($8cd96f0f3be295d3$export$2a111da947c407d2);
                    if (nonce != null) styleElm.setAttribute("nonce", nonce);
                    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateServerSide || (0, $6c97b4542f89f042$export$455dbfd86f20b704).hotModuleReplacement) styleElm.setAttribute($8cd96f0f3be295d3$var$HYDRATED_STYLE_ID, scopeId);
                    styleContainerNode.insertBefore(styleElm, styleContainerNode.querySelector("link"));
                }
                if (appliedStyles) appliedStyles.add(scopeId);
            }
        } else if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).constructableCSS && !styleContainerNode.adoptedStyleSheets.includes(style)) styleContainerNode.adoptedStyleSheets = [
            ...styleContainerNode.adoptedStyleSheets,
            style
        ];
    }
    return scopeId;
};
const $8cd96f0f3be295d3$var$attachStyles = (hostRef)=>{
    const cmpMeta = hostRef.$cmpMeta$;
    const elm = hostRef.$hostElement$;
    const flags = cmpMeta.$flags$;
    const endAttachStyles = $8cd96f0f3be295d3$var$createTime("attachStyles", cmpMeta.$tagName$);
    const scopeId = $8cd96f0f3be295d3$var$addStyle((0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDom && $8cd96f0f3be295d3$export$b4e7e6d61dbcd813 && elm.shadowRoot ? elm.shadowRoot : elm.getRootNode(), cmpMeta, hostRef.$modeName$, elm);
    if (((0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDom || (0, $6c97b4542f89f042$export$455dbfd86f20b704).scoped) && (0, $6c97b4542f89f042$export$455dbfd86f20b704).cssAnnotations && flags & 10 /* CMP_FLAGS.needsScopedEncapsulation */ ) {
        // only required when we're NOT using native shadow dom (slot)
        // or this browser doesn't support native shadow dom
        // and this host element was NOT created with SSR
        // let's pick out the inner content for slot projection
        // create a node to represent where the original
        // content was first placed, which is useful later on
        // DOM WRITE!!
        elm["s-sc"] = scopeId;
        elm.classList.add(scopeId + "-h");
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).scoped && flags & 2 /* CMP_FLAGS.scopedCssEncapsulation */ ) elm.classList.add(scopeId + "-s");
    }
    endAttachStyles();
};
const $8cd96f0f3be295d3$var$getScopeId = (cmp, mode)=>"sc-" + ((0, $6c97b4542f89f042$export$455dbfd86f20b704).mode && mode && cmp.$flags$ & 32 /* CMP_FLAGS.hasMode */  ? cmp.$tagName$ + "-" + mode : cmp.$tagName$);
const $8cd96f0f3be295d3$var$convertScopedToShadow = (css)=>css.replace(/\/\*!@([^\/]+)\*\/[^\{]+\{/g, "$1{");
/**
 * Production setAccessor() function based on Preact by
 * Jason Miller (@developit)
 * Licensed under the MIT License
 * https://github.com/developit/preact/blob/master/LICENSE
 *
 * Modified for Stencil's compiler and vdom
 */ const $8cd96f0f3be295d3$var$setAccessor = (elm, memberName, oldValue, newValue, isSvg, flags)=>{
    if (oldValue !== newValue) {
        let isProp = $8cd96f0f3be295d3$export$304efeaa4c96d4e9(elm, memberName);
        let ln = memberName.toLowerCase();
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomClass && memberName === "class") {
            const classList = elm.classList;
            const oldClasses = $8cd96f0f3be295d3$var$parseClassList(oldValue);
            const newClasses = $8cd96f0f3be295d3$var$parseClassList(newValue);
            classList.remove(...oldClasses.filter((c)=>c && !newClasses.includes(c)));
            classList.add(...newClasses.filter((c)=>c && !oldClasses.includes(c)));
        } else if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomStyle && memberName === "style") {
            // update style attribute, css properties and values
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).updatable) {
                for(const prop in oldValue)if (!newValue || newValue[prop] == null) {
                    if (!(0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateServerSide && prop.includes("-")) elm.style.removeProperty(prop);
                    else elm.style[prop] = "";
                }
            }
            for(const prop in newValue)if (!oldValue || newValue[prop] !== oldValue[prop]) {
                if (!(0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateServerSide && prop.includes("-")) elm.style.setProperty(prop, newValue[prop]);
                else elm.style[prop] = newValue[prop];
            }
        } else if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomKey && memberName === "key") ;
        else if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomRef && memberName === "ref") // minifier will clean this up
        {
            if (newValue) newValue(elm);
        } else if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomListener && ((0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad ? !isProp : !elm.__lookupSetter__(memberName)) && memberName[0] === "o" && memberName[1] === "n") {
            // Event Handlers
            // so if the member name starts with "on" and the 3rd characters is
            // a capital letter, and it's not already a member on the element,
            // then we're assuming it's an event listener
            if (memberName[2] === "-") // on- prefixed events
            // allows to be explicit about the dom event to listen without any magic
            // under the hood:
            // <my-cmp on-click> // listens for "click"
            // <my-cmp on-Click> // listens for "Click"
            // <my-cmp on-ionChange> // listens for "ionChange"
            // <my-cmp on-EVENTS> // listens for "EVENTS"
            memberName = memberName.slice(3);
            else if ($8cd96f0f3be295d3$export$304efeaa4c96d4e9($8cd96f0f3be295d3$export$10a0f131c0eea21b, ln)) // standard event
            // the JSX attribute could have been "onMouseOver" and the
            // member name "onmouseover" is on the window's prototype
            // so let's add the listener "mouseover", which is all lowercased
            memberName = ln.slice(2);
            else // custom event
            // the JSX attribute could have been "onMyCustomEvent"
            // so let's trim off the "on" prefix and lowercase the first character
            // and add the listener "myCustomEvent"
            // except for the first character, we keep the event name case
            memberName = ln[2] + memberName.slice(3);
            if (oldValue) $8cd96f0f3be295d3$export$2e40610e9d23bca6.rel(elm, memberName, oldValue, false);
            if (newValue) $8cd96f0f3be295d3$export$2e40610e9d23bca6.ael(elm, memberName, newValue, false);
        } else if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomPropOrAttr) {
            // Set property if it exists and it's not a SVG
            const isComplex = $8cd96f0f3be295d3$var$isComplexType(newValue);
            if ((isProp || isComplex && newValue !== null) && !isSvg) try {
                if (!elm.tagName.includes("-")) {
                    const n = newValue == null ? "" : newValue;
                    // Workaround for Safari, moving the <input> caret when re-assigning the same valued
                    if (memberName === "list") isProp = false;
                    else if (oldValue == null || elm[memberName] != n) elm[memberName] = n;
                } else elm[memberName] = newValue;
            } catch (e) {}
            /**
             * Need to manually update attribute if:
             * - memberName is not an attribute
             * - if we are rendering the host element in order to reflect attribute
             * - if it's a SVG, since properties might not work in <svg>
             * - if the newValue is null/undefined or 'false'.
             */ let xlink = false;
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomXlink) {
                if (ln !== (ln = ln.replace(/^xlink\:?/, ""))) {
                    memberName = ln;
                    xlink = true;
                }
            }
            if (newValue == null || newValue === false) {
                if (newValue !== false || elm.getAttribute(memberName) === "") {
                    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomXlink && xlink) elm.removeAttributeNS($8cd96f0f3be295d3$var$XLINK_NS, memberName);
                    else elm.removeAttribute(memberName);
                }
            } else if ((!isProp || flags & 4 /* VNODE_FLAGS.isHost */  || isSvg) && !isComplex) {
                newValue = newValue === true ? "" : newValue;
                if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomXlink && xlink) elm.setAttributeNS($8cd96f0f3be295d3$var$XLINK_NS, memberName, newValue);
                else elm.setAttribute(memberName, newValue);
            }
        }
    }
};
const $8cd96f0f3be295d3$var$parseClassListRegex = /\s/;
const $8cd96f0f3be295d3$var$parseClassList = (value)=>!value ? [] : value.split($8cd96f0f3be295d3$var$parseClassListRegex);
const $8cd96f0f3be295d3$var$updateElement = (oldVnode, newVnode, isSvgMode, memberName)=>{
    // if the element passed in is a shadow root, which is a document fragment
    // then we want to be adding attrs/props to the shadow root's "host" element
    // if it's not a shadow root, then we add attrs/props to the same element
    const elm = newVnode.$elm$.nodeType === 11 /* NODE_TYPE.DocumentFragment */  && newVnode.$elm$.host ? newVnode.$elm$.host : newVnode.$elm$;
    const oldVnodeAttrs = oldVnode && oldVnode.$attrs$ || $8cd96f0f3be295d3$var$EMPTY_OBJ;
    const newVnodeAttrs = newVnode.$attrs$ || $8cd96f0f3be295d3$var$EMPTY_OBJ;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).updatable) {
        // remove attributes no longer present on the vnode by setting them to undefined
        for(memberName in oldVnodeAttrs)if (!(memberName in newVnodeAttrs)) $8cd96f0f3be295d3$var$setAccessor(elm, memberName, oldVnodeAttrs[memberName], undefined, isSvgMode, newVnode.$flags$);
    }
    // add new & update changed attributes
    for(memberName in newVnodeAttrs)$8cd96f0f3be295d3$var$setAccessor(elm, memberName, oldVnodeAttrs[memberName], newVnodeAttrs[memberName], isSvgMode, newVnode.$flags$);
};
/**
 * Create a DOM Node corresponding to one of the children of a given VNode.
 *
 * @param oldParentVNode the parent VNode from the previous render
 * @param newParentVNode the parent VNode from the current render
 * @param childIndex the index of the VNode, in the _new_ parent node's
 * children, for which we will create a new DOM node
 * @param parentElm the parent DOM node which our new node will be a child of
 * @returns the newly created node
 */ const $8cd96f0f3be295d3$var$createElm = (oldParentVNode, newParentVNode, childIndex, parentElm)=>{
    // tslint:disable-next-line: prefer-const
    const newVNode = newParentVNode.$children$[childIndex];
    let i = 0;
    let elm;
    let childNode;
    let oldVNode;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation && !$8cd96f0f3be295d3$var$useNativeShadowDom) {
        // remember for later we need to check to relocate nodes
        $8cd96f0f3be295d3$var$checkSlotRelocate = true;
        if (newVNode.$tag$ === "slot") {
            if ($8cd96f0f3be295d3$var$scopeId) // scoped css needs to add its scoped id to the parent element
            parentElm.classList.add($8cd96f0f3be295d3$var$scopeId + "-s");
            newVNode.$flags$ |= newVNode.$children$ ? 2 /* VNODE_FLAGS.isSlotFallback */  : 1 /* VNODE_FLAGS.isSlotReference */ ;
        }
    }
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev && newVNode.$elm$) $8cd96f0f3be295d3$export$47b52a6e53fbbc24(`The JSX ${newVNode.$text$ !== null ? `"${newVNode.$text$}" text` : `"${newVNode.$tag$}" element`} node should not be shared within the same renderer. The renderer caches element lookups in order to improve performance. However, a side effect from this is that the exact same JSX node should not be reused. For more information please see https://stenciljs.com/docs/templating-jsx#avoid-shared-jsx-nodes`);
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomText && newVNode.$text$ !== null) // create text node
    elm = newVNode.$elm$ = $8cd96f0f3be295d3$export$2a111da947c407d2.createTextNode(newVNode.$text$);
    else if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation && newVNode.$flags$ & 1 /* VNODE_FLAGS.isSlotReference */ ) // create a slot reference node
    elm = newVNode.$elm$ = (0, $6c97b4542f89f042$export$455dbfd86f20b704).isDebug || (0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateServerSide ? $8cd96f0f3be295d3$var$slotReferenceDebugNode(newVNode) : $8cd96f0f3be295d3$export$2a111da947c407d2.createTextNode("");
    else {
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).svg && !$8cd96f0f3be295d3$var$isSvgMode) $8cd96f0f3be295d3$var$isSvgMode = newVNode.$tag$ === "svg";
        // create element
        elm = newVNode.$elm$ = (0, $6c97b4542f89f042$export$455dbfd86f20b704).svg ? $8cd96f0f3be295d3$export$2a111da947c407d2.createElementNS($8cd96f0f3be295d3$var$isSvgMode ? $8cd96f0f3be295d3$var$SVG_NS : $8cd96f0f3be295d3$var$HTML_NS, (0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation && newVNode.$flags$ & 2 /* VNODE_FLAGS.isSlotFallback */  ? "slot-fb" : newVNode.$tag$) : $8cd96f0f3be295d3$export$2a111da947c407d2.createElement((0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation && newVNode.$flags$ & 2 /* VNODE_FLAGS.isSlotFallback */  ? "slot-fb" : newVNode.$tag$);
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).svg && $8cd96f0f3be295d3$var$isSvgMode && newVNode.$tag$ === "foreignObject") $8cd96f0f3be295d3$var$isSvgMode = false;
        // add css classes, attrs, props, listeners, etc.
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomAttribute) $8cd96f0f3be295d3$var$updateElement(null, newVNode, $8cd96f0f3be295d3$var$isSvgMode);
        if (((0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDom || (0, $6c97b4542f89f042$export$455dbfd86f20b704).scoped) && $8cd96f0f3be295d3$var$isDef($8cd96f0f3be295d3$var$scopeId) && elm["s-si"] !== $8cd96f0f3be295d3$var$scopeId) // if there is a scopeId and this is the initial render
        // then let's add the scopeId as a css class
        elm.classList.add(elm["s-si"] = $8cd96f0f3be295d3$var$scopeId);
        if (newVNode.$children$) for(i = 0; i < newVNode.$children$.length; ++i){
            // create the node
            childNode = $8cd96f0f3be295d3$var$createElm(oldParentVNode, newVNode, i, elm);
            // return node could have been null
            if (childNode) // append our new node
            elm.appendChild(childNode);
        }
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).svg) {
            if (newVNode.$tag$ === "svg") // Only reset the SVG context when we're exiting <svg> element
            $8cd96f0f3be295d3$var$isSvgMode = false;
            else if (elm.tagName === "foreignObject") // Reenter SVG context when we're exiting <foreignObject> element
            $8cd96f0f3be295d3$var$isSvgMode = true;
        }
    }
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation) {
        elm["s-hn"] = $8cd96f0f3be295d3$var$hostTagName;
        if (newVNode.$flags$ & 3 /* VNODE_FLAGS.isSlotReference */ ) {
            // remember the content reference comment
            elm["s-sr"] = true;
            // remember the content reference comment
            elm["s-cr"] = $8cd96f0f3be295d3$var$contentRef;
            // remember the slot name, or empty string for default slot
            elm["s-sn"] = newVNode.$name$ || "";
            // check if we've got an old vnode for this slot
            oldVNode = oldParentVNode && oldParentVNode.$children$ && oldParentVNode.$children$[childIndex];
            if (oldVNode && oldVNode.$tag$ === newVNode.$tag$ && oldParentVNode.$elm$) // we've got an old slot vnode and the wrapper is being replaced
            // so let's move the old slot content back to it's original location
            $8cd96f0f3be295d3$var$putBackInOriginalLocation(oldParentVNode.$elm$, false);
        }
    }
    return elm;
};
const $8cd96f0f3be295d3$var$putBackInOriginalLocation = (parentElm, recursive)=>{
    $8cd96f0f3be295d3$export$2e40610e9d23bca6.$flags$ |= 1 /* PLATFORM_FLAGS.isTmpDisconnected */ ;
    const oldSlotChildNodes = parentElm.childNodes;
    for(let i = oldSlotChildNodes.length - 1; i >= 0; i--){
        const childNode = oldSlotChildNodes[i];
        if (childNode["s-hn"] !== $8cd96f0f3be295d3$var$hostTagName && childNode["s-ol"]) {
            // // this child node in the old element is from another component
            // // remove this node from the old slot's parent
            // childNode.remove();
            // and relocate it back to it's original location
            $8cd96f0f3be295d3$var$parentReferenceNode(childNode).insertBefore(childNode, $8cd96f0f3be295d3$var$referenceNode(childNode));
            // remove the old original location comment entirely
            // later on the patch function will know what to do
            // and move this to the correct spot in need be
            childNode["s-ol"].remove();
            childNode["s-ol"] = undefined;
            $8cd96f0f3be295d3$var$checkSlotRelocate = true;
        }
        if (recursive) $8cd96f0f3be295d3$var$putBackInOriginalLocation(childNode, recursive);
    }
    $8cd96f0f3be295d3$export$2e40610e9d23bca6.$flags$ &= -2 /* PLATFORM_FLAGS.isTmpDisconnected */ ;
};
/**
 * Create DOM nodes corresponding to a list of {@link d.Vnode} objects and
 * add them to the DOM in the appropriate place.
 *
 * @param parentElm the DOM node which should be used as a parent for the new
 * DOM nodes
 * @param before a child of the `parentElm` which the new children should be
 * inserted before (optional)
 * @param parentVNode the parent virtual DOM node
 * @param vnodes the new child virtual DOM nodes to produce DOM nodes for
 * @param startIdx the index in the child virtual DOM nodes at which to start
 * creating DOM nodes (inclusive)
 * @param endIdx the index in the child virtual DOM nodes at which to stop
 * creating DOM nodes (inclusive)
 */ const $8cd96f0f3be295d3$var$addVnodes = (parentElm, before, parentVNode, vnodes, startIdx, endIdx)=>{
    let containerElm = (0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation && parentElm["s-cr"] && parentElm["s-cr"].parentNode || parentElm;
    let childNode;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDom && containerElm.shadowRoot && containerElm.tagName === $8cd96f0f3be295d3$var$hostTagName) containerElm = containerElm.shadowRoot;
    for(; startIdx <= endIdx; ++startIdx)if (vnodes[startIdx]) {
        childNode = $8cd96f0f3be295d3$var$createElm(null, parentVNode, startIdx, parentElm);
        if (childNode) {
            vnodes[startIdx].$elm$ = childNode;
            containerElm.insertBefore(childNode, (0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation ? $8cd96f0f3be295d3$var$referenceNode(before) : before);
        }
    }
};
/**
 * Remove the DOM elements corresponding to a list of {@link d.VNode} objects.
 * This can be used to, for instance, clean up after a list of children which
 * should no longer be shown.
 *
 * This function also handles some of Stencil's slot relocation logic.
 *
 * @param vnodes a list of virtual DOM nodes to remove
 * @param startIdx the index at which to start removing nodes (inclusive)
 * @param endIdx the index at which to stop removing nodes (inclusive)
 * @param vnode a VNode
 * @param elm an element
 */ const $8cd96f0f3be295d3$var$removeVnodes = (vnodes, startIdx, endIdx, vnode, elm)=>{
    for(; startIdx <= endIdx; ++startIdx)if (vnode = vnodes[startIdx]) {
        elm = vnode.$elm$;
        $8cd96f0f3be295d3$var$callNodeRefs(vnode);
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation) {
            // we're removing this element
            // so it's possible we need to show slot fallback content now
            $8cd96f0f3be295d3$var$checkSlotFallbackVisibility = true;
            if (elm["s-ol"]) // remove the original location comment
            elm["s-ol"].remove();
            else // it's possible that child nodes of the node
            // that's being removed are slot nodes
            $8cd96f0f3be295d3$var$putBackInOriginalLocation(elm, true);
        }
        // remove the vnode's element from the dom
        elm.remove();
    }
};
/**
 * Reconcile the children of a new VNode with the children of an old VNode by
 * traversing the two collections of children, identifying nodes that are
 * conserved or changed, calling out to `patch` to make any necessary
 * updates to the DOM, and rearranging DOM nodes as needed.
 *
 * The algorithm for reconciling children works by analyzing two 'windows' onto
 * the two arrays of children (`oldCh` and `newCh`). We keep track of the
 * 'windows' by storing start and end indices and references to the
 * corresponding array entries. Initially the two 'windows' are basically equal
 * to the entire array, but we progressively narrow the windows until there are
 * no children left to update by doing the following:
 *
 * 1. Skip any `null` entries at the beginning or end of the two arrays, so
 *    that if we have an initial array like the following we'll end up dealing
 *    only with a window bounded by the highlighted elements:
 *
 *    [null, null, VNode1 , ... , VNode2, null, null]
 *                 ^^^^^^         ^^^^^^
 *
 * 2. Check to see if the elements at the head and tail positions are equal
 *    across the windows. This will basically detect elements which haven't
 *    been added, removed, or changed position, i.e. if you had the following
 *    VNode elements (represented as HTML):
 *
 *    oldVNode: `<div><p><span>HEY</span></p></div>`
 *    newVNode: `<div><p><span>THERE</span></p></div>`
 *
 *    Then when comparing the children of the `<div>` tag we check the equality
 *    of the VNodes corresponding to the `<p>` tags and, since they are the
 *    same tag in the same position, we'd be able to avoid completely
 *    re-rendering the subtree under them with a new DOM element and would just
 *    call out to `patch` to handle reconciling their children and so on.
 *
 * 3. Check, for both windows, to see if the element at the beginning of the
 *    window corresponds to the element at the end of the other window. This is
 *    a heuristic which will let us identify _some_ situations in which
 *    elements have changed position, for instance it _should_ detect that the
 *    children nodes themselves have not changed but merely moved in the
 *    following example:
 *
 *    oldVNode: `<div><element-one /><element-two /></div>`
 *    newVNode: `<div><element-two /><element-one /></div>`
 *
 *    If we find cases like this then we also need to move the concrete DOM
 *    elements corresponding to the moved children to write the re-order to the
 *    DOM.
 *
 * 4. Finally, if VNodes have the `key` attribute set on them we check for any
 *    nodes in the old children which have the same key as the first element in
 *    our window on the new children. If we find such a node we handle calling
 *    out to `patch`, moving relevant DOM nodes, and so on, in accordance with
 *    what we find.
 *
 * Finally, once we've narrowed our 'windows' to the point that either of them
 * collapse (i.e. they have length 0) we then handle any remaining VNode
 * insertion or deletion that needs to happen to get a DOM state that correctly
 * reflects the new child VNodes. If, for instance, after our window on the old
 * children has collapsed we still have more nodes on the new children that
 * we haven't dealt with yet then we need to add them, or if the new children
 * collapse but we still have unhandled _old_ children then we need to make
 * sure the corresponding DOM nodes are removed.
 *
 * @param parentElm the node into which the parent VNode is rendered
 * @param oldCh the old children of the parent node
 * @param newVNode the new VNode which will replace the parent
 * @param newCh the new children of the parent node
 */ const $8cd96f0f3be295d3$var$updateChildren = (parentElm, oldCh, newVNode, newCh)=>{
    let oldStartIdx = 0;
    let newStartIdx = 0;
    let idxInOld = 0;
    let i = 0;
    let oldEndIdx = oldCh.length - 1;
    let oldStartVnode = oldCh[0];
    let oldEndVnode = oldCh[oldEndIdx];
    let newEndIdx = newCh.length - 1;
    let newStartVnode = newCh[0];
    let newEndVnode = newCh[newEndIdx];
    let node;
    let elmToMove;
    while(oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx){
        if (oldStartVnode == null) // VNode might have been moved left
        oldStartVnode = oldCh[++oldStartIdx];
        else if (oldEndVnode == null) oldEndVnode = oldCh[--oldEndIdx];
        else if (newStartVnode == null) newStartVnode = newCh[++newStartIdx];
        else if (newEndVnode == null) newEndVnode = newCh[--newEndIdx];
        else if ($8cd96f0f3be295d3$var$isSameVnode(oldStartVnode, newStartVnode)) {
            // if the start nodes are the same then we should patch the new VNode
            // onto the old one, and increment our `newStartIdx` and `oldStartIdx`
            // indices to reflect that. We don't need to move any DOM Nodes around
            // since things are matched up in order.
            $8cd96f0f3be295d3$var$patch(oldStartVnode, newStartVnode);
            oldStartVnode = oldCh[++oldStartIdx];
            newStartVnode = newCh[++newStartIdx];
        } else if ($8cd96f0f3be295d3$var$isSameVnode(oldEndVnode, newEndVnode)) {
            // likewise, if the end nodes are the same we patch new onto old and
            // decrement our end indices, and also likewise in this case we don't
            // need to move any DOM Nodes.
            $8cd96f0f3be295d3$var$patch(oldEndVnode, newEndVnode);
            oldEndVnode = oldCh[--oldEndIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($8cd96f0f3be295d3$var$isSameVnode(oldStartVnode, newEndVnode)) {
            // case: "Vnode moved right"
            //
            // We've found that the last node in our window on the new children is
            // the same VNode as the _first_ node in our window on the old children
            // we're dealing with now. Visually, this is the layout of these two
            // nodes:
            //
            // newCh: [..., newStartVnode , ... , newEndVnode , ...]
            //                                    ^^^^^^^^^^^
            // oldCh: [..., oldStartVnode , ... , oldEndVnode , ...]
            //              ^^^^^^^^^^^^^
            //
            // In this situation we need to patch `newEndVnode` onto `oldStartVnode`
            // and move the DOM element for `oldStartVnode`.
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation && (oldStartVnode.$tag$ === "slot" || newEndVnode.$tag$ === "slot")) $8cd96f0f3be295d3$var$putBackInOriginalLocation(oldStartVnode.$elm$.parentNode, false);
            $8cd96f0f3be295d3$var$patch(oldStartVnode, newEndVnode);
            // We need to move the element for `oldStartVnode` into a position which
            // will be appropriate for `newEndVnode`. For this we can use
            // `.insertBefore` and `oldEndVnode.$elm$.nextSibling`. If there is a
            // sibling for `oldEndVnode.$elm$` then we want to move the DOM node for
            // `oldStartVnode` between `oldEndVnode` and it's sibling, like so:
            //
            // <old-start-node />
            // <some-intervening-node />
            // <old-end-node />
            // <!-- ->              <-- `oldStartVnode.$elm$` should be inserted here
            // <next-sibling />
            //
            // If instead `oldEndVnode.$elm$` has no sibling then we just want to put
            // the node for `oldStartVnode` at the end of the children of
            // `parentElm`. Luckily, `Node.nextSibling` will return `null` if there
            // aren't any siblings, and passing `null` to `Node.insertBefore` will
            // append it to the children of the parent element.
            parentElm.insertBefore(oldStartVnode.$elm$, oldEndVnode.$elm$.nextSibling);
            oldStartVnode = oldCh[++oldStartIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($8cd96f0f3be295d3$var$isSameVnode(oldEndVnode, newStartVnode)) {
            // case: "Vnode moved left"
            //
            // We've found that the first node in our window on the new children is
            // the same VNode as the _last_ node in our window on the old children.
            // Visually, this is the layout of these two nodes:
            //
            // newCh: [..., newStartVnode , ... , newEndVnode , ...]
            //              ^^^^^^^^^^^^^
            // oldCh: [..., oldStartVnode , ... , oldEndVnode , ...]
            //                                    ^^^^^^^^^^^
            //
            // In this situation we need to patch `newStartVnode` onto `oldEndVnode`
            // (which will handle updating any changed attributes, reconciling their
            // children etc) but we also need to move the DOM node to which
            // `oldEndVnode` corresponds.
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation && (oldStartVnode.$tag$ === "slot" || newEndVnode.$tag$ === "slot")) $8cd96f0f3be295d3$var$putBackInOriginalLocation(oldEndVnode.$elm$.parentNode, false);
            $8cd96f0f3be295d3$var$patch(oldEndVnode, newStartVnode);
            // We've already checked above if `oldStartVnode` and `newStartVnode` are
            // the same node, so since we're here we know that they are not. Thus we
            // can move the element for `oldEndVnode` _before_ the element for
            // `oldStartVnode`, leaving `oldStartVnode` to be reconciled in the
            // future.
            parentElm.insertBefore(oldEndVnode.$elm$, oldStartVnode.$elm$);
            oldEndVnode = oldCh[--oldEndIdx];
            newStartVnode = newCh[++newStartIdx];
        } else {
            // Here we do some checks to match up old and new nodes based on the
            // `$key$` attribute, which is set by putting a `key="my-key"` attribute
            // in the JSX for a DOM element in the implementation of a Stencil
            // component.
            //
            // First we check to see if there are any nodes in the array of old
            // children which have the same key as the first node in the new
            // children.
            idxInOld = -1;
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomKey) {
                for(i = oldStartIdx; i <= oldEndIdx; ++i)if (oldCh[i] && oldCh[i].$key$ !== null && oldCh[i].$key$ === newStartVnode.$key$) {
                    idxInOld = i;
                    break;
                }
            }
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomKey && idxInOld >= 0) {
                // We found a node in the old children which matches up with the first
                // node in the new children! So let's deal with that
                elmToMove = oldCh[idxInOld];
                if (elmToMove.$tag$ !== newStartVnode.$tag$) // the tag doesn't match so we'll need a new DOM element
                node = $8cd96f0f3be295d3$var$createElm(oldCh && oldCh[newStartIdx], newVNode, idxInOld, parentElm);
                else {
                    $8cd96f0f3be295d3$var$patch(elmToMove, newStartVnode);
                    // invalidate the matching old node so that we won't try to update it
                    // again later on
                    oldCh[idxInOld] = undefined;
                    node = elmToMove.$elm$;
                }
                newStartVnode = newCh[++newStartIdx];
            } else {
                // We either didn't find an element in the old children that matches
                // the key of the first new child OR the build is not using `key`
                // attributes at all. In either case we need to create a new element
                // for the new node.
                node = $8cd96f0f3be295d3$var$createElm(oldCh && oldCh[newStartIdx], newVNode, newStartIdx, parentElm);
                newStartVnode = newCh[++newStartIdx];
            }
            if (node) {
                // if we created a new node then handle inserting it to the DOM
                if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation) $8cd96f0f3be295d3$var$parentReferenceNode(oldStartVnode.$elm$).insertBefore(node, $8cd96f0f3be295d3$var$referenceNode(oldStartVnode.$elm$));
                else oldStartVnode.$elm$.parentNode.insertBefore(node, oldStartVnode.$elm$);
            }
        }
    }
    if (oldStartIdx > oldEndIdx) // we have some more new nodes to add which don't match up with old nodes
    $8cd96f0f3be295d3$var$addVnodes(parentElm, newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].$elm$, newVNode, newCh, newStartIdx, newEndIdx);
    else if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).updatable && newStartIdx > newEndIdx) // there are nodes in the `oldCh` array which no longer correspond to nodes
    // in the new array, so lets remove them (which entails cleaning up the
    // relevant DOM nodes)
    $8cd96f0f3be295d3$var$removeVnodes(oldCh, oldStartIdx, oldEndIdx);
};
/**
 * Compare two VNodes to determine if they are the same
 *
 * **NB**: This function is an equality _heuristic_ based on the available
 * information set on the two VNodes and can be misleading under certain
 * circumstances. In particular, if the two nodes do not have `key` attrs
 * (available under `$key$` on VNodes) then the function falls back on merely
 * checking that they have the same tag.
 *
 * So, in other words, if `key` attrs are not set on VNodes which may be
 * changing order within a `children` array or something along those lines then
 * we could obtain a false negative and then have to do needless re-rendering
 * (i.e. we'd say two VNodes aren't equal when in fact they should be).
 *
 * @param leftVNode the first VNode to check
 * @param rightVNode the second VNode to check
 * @returns whether they're equal or not
 */ const $8cd96f0f3be295d3$var$isSameVnode = (leftVNode, rightVNode)=>{
    // compare if two vnode to see if they're "technically" the same
    // need to have the same element tag, and same key to be the same
    if (leftVNode.$tag$ === rightVNode.$tag$) {
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation && leftVNode.$tag$ === "slot") return leftVNode.$name$ === rightVNode.$name$;
        // this will be set if components in the build have `key` attrs set on them
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomKey) return leftVNode.$key$ === rightVNode.$key$;
        return true;
    }
    return false;
};
const $8cd96f0f3be295d3$var$referenceNode = (node)=>{
    // this node was relocated to a new location in the dom
    // because of some other component's slot
    // but we still have an html comment in place of where
    // it's original location was according to it's original vdom
    return node && node["s-ol"] || node;
};
const $8cd96f0f3be295d3$var$parentReferenceNode = (node)=>(node["s-ol"] ? node["s-ol"] : node).parentNode;
/**
 * Handle reconciling an outdated VNode with a new one which corresponds to
 * it. This function handles flushing updates to the DOM and reconciling the
 * children of the two nodes (if any).
 *
 * @param oldVNode an old VNode whose DOM element and children we want to update
 * @param newVNode a new VNode representing an updated version of the old one
 */ const $8cd96f0f3be295d3$var$patch = (oldVNode, newVNode)=>{
    const elm = newVNode.$elm$ = oldVNode.$elm$;
    const oldChildren = oldVNode.$children$;
    const newChildren = newVNode.$children$;
    const tag = newVNode.$tag$;
    const text = newVNode.$text$;
    let defaultHolder;
    if (!(0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomText || text === null) {
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).svg) // test if we're rendering an svg element, or still rendering nodes inside of one
        // only add this to the when the compiler sees we're using an svg somewhere
        $8cd96f0f3be295d3$var$isSvgMode = tag === "svg" ? true : tag === "foreignObject" ? false : $8cd96f0f3be295d3$var$isSvgMode;
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomAttribute || (0, $6c97b4542f89f042$export$455dbfd86f20b704).reflect) {
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).slot && tag === "slot") ;
            else // either this is the first render of an element OR it's an update
            // AND we already know it's possible it could have changed
            // this updates the element's css classes, attrs, props, listeners, etc.
            $8cd96f0f3be295d3$var$updateElement(oldVNode, newVNode, $8cd96f0f3be295d3$var$isSvgMode);
        }
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).updatable && oldChildren !== null && newChildren !== null) // looks like there's child vnodes for both the old and new vnodes
        // so we need to call `updateChildren` to reconcile them
        $8cd96f0f3be295d3$var$updateChildren(elm, oldChildren, newVNode, newChildren);
        else if (newChildren !== null) {
            // no old child vnodes, but there are new child vnodes to add
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).updatable && (0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomText && oldVNode.$text$ !== null) // the old vnode was text, so be sure to clear it out
            elm.textContent = "";
            // add the new vnode children
            $8cd96f0f3be295d3$var$addVnodes(elm, null, newVNode, newChildren, 0, newChildren.length - 1);
        } else if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).updatable && oldChildren !== null) // no new child vnodes, but there are old child vnodes to remove
        $8cd96f0f3be295d3$var$removeVnodes(oldChildren, 0, oldChildren.length - 1);
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).svg && $8cd96f0f3be295d3$var$isSvgMode && tag === "svg") $8cd96f0f3be295d3$var$isSvgMode = false;
    } else if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomText && (0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation && (defaultHolder = elm["s-cr"])) // this element has slotted content
    defaultHolder.parentNode.textContent = text;
    else if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomText && oldVNode.$text$ !== text) // update the text content for the text only vnode
    // and also only if the text is different than before
    elm.data = text;
};
const $8cd96f0f3be295d3$var$updateFallbackSlotVisibility = (elm)=>{
    // tslint:disable-next-line: prefer-const
    const childNodes = elm.childNodes;
    let childNode;
    let i;
    let ilen;
    let j;
    let slotNameAttr;
    let nodeType;
    for(i = 0, ilen = childNodes.length; i < ilen; i++){
        childNode = childNodes[i];
        if (childNode.nodeType === 1 /* NODE_TYPE.ElementNode */ ) {
            if (childNode["s-sr"]) {
                // this is a slot fallback node
                // get the slot name for this slot reference node
                slotNameAttr = childNode["s-sn"];
                // by default always show a fallback slot node
                // then hide it if there are other slots in the light dom
                childNode.hidden = false;
                for(j = 0; j < ilen; j++){
                    nodeType = childNodes[j].nodeType;
                    if (childNodes[j]["s-hn"] !== childNode["s-hn"] || slotNameAttr !== "") // this sibling node is from a different component OR is a named fallback slot node
                    {
                        if (nodeType === 1 /* NODE_TYPE.ElementNode */  && slotNameAttr === childNodes[j].getAttribute("slot")) {
                            childNode.hidden = true;
                            break;
                        }
                    } else // this is a default fallback slot node
                    // any element or text node (with content)
                    // should hide the default fallback slot node
                    if (nodeType === 1 /* NODE_TYPE.ElementNode */  || nodeType === 3 /* NODE_TYPE.TextNode */  && childNodes[j].textContent.trim() !== "") {
                        childNode.hidden = true;
                        break;
                    }
                }
            }
            // keep drilling down
            $8cd96f0f3be295d3$var$updateFallbackSlotVisibility(childNode);
        }
    }
};
const $8cd96f0f3be295d3$var$relocateNodes = [];
const $8cd96f0f3be295d3$var$relocateSlotContent = (elm)=>{
    // tslint:disable-next-line: prefer-const
    let childNode;
    let node;
    let hostContentNodes;
    let slotNameAttr;
    let relocateNodeData;
    let j;
    let i = 0;
    const childNodes = elm.childNodes;
    const ilen = childNodes.length;
    for(; i < ilen; i++){
        childNode = childNodes[i];
        if (childNode["s-sr"] && (node = childNode["s-cr"]) && node.parentNode) {
            // first got the content reference comment node
            // then we got it's parent, which is where all the host content is in now
            hostContentNodes = node.parentNode.childNodes;
            slotNameAttr = childNode["s-sn"];
            for(j = hostContentNodes.length - 1; j >= 0; j--){
                node = hostContentNodes[j];
                if (!node["s-cn"] && !node["s-nr"] && node["s-hn"] !== childNode["s-hn"]) {
                    // let's do some relocating to its new home
                    // but never relocate a content reference node
                    // that is suppose to always represent the original content location
                    if ($8cd96f0f3be295d3$var$isNodeLocatedInSlot(node, slotNameAttr)) {
                        // it's possible we've already decided to relocate this node
                        relocateNodeData = $8cd96f0f3be295d3$var$relocateNodes.find((r)=>r.$nodeToRelocate$ === node);
                        // made some changes to slots
                        // let's make sure we also double check
                        // fallbacks are correctly hidden or shown
                        $8cd96f0f3be295d3$var$checkSlotFallbackVisibility = true;
                        node["s-sn"] = node["s-sn"] || slotNameAttr;
                        if (relocateNodeData) // previously we never found a slot home for this node
                        // but turns out we did, so let's remember it now
                        relocateNodeData.$slotRefNode$ = childNode;
                        else // add to our list of nodes to relocate
                        $8cd96f0f3be295d3$var$relocateNodes.push({
                            $slotRefNode$: childNode,
                            $nodeToRelocate$: node
                        });
                        if (node["s-sr"]) $8cd96f0f3be295d3$var$relocateNodes.map((relocateNode)=>{
                            if ($8cd96f0f3be295d3$var$isNodeLocatedInSlot(relocateNode.$nodeToRelocate$, node["s-sn"])) {
                                relocateNodeData = $8cd96f0f3be295d3$var$relocateNodes.find((r)=>r.$nodeToRelocate$ === node);
                                if (relocateNodeData && !relocateNode.$slotRefNode$) relocateNode.$slotRefNode$ = relocateNodeData.$slotRefNode$;
                            }
                        });
                    } else if (!$8cd96f0f3be295d3$var$relocateNodes.some((r)=>r.$nodeToRelocate$ === node)) // so far this element does not have a slot home, not setting slotRefNode on purpose
                    // if we never find a home for this element then we'll need to hide it
                    $8cd96f0f3be295d3$var$relocateNodes.push({
                        $nodeToRelocate$: node
                    });
                }
            }
        }
        if (childNode.nodeType === 1 /* NODE_TYPE.ElementNode */ ) $8cd96f0f3be295d3$var$relocateSlotContent(childNode);
    }
};
const $8cd96f0f3be295d3$var$isNodeLocatedInSlot = (nodeToRelocate, slotNameAttr)=>{
    if (nodeToRelocate.nodeType === 1 /* NODE_TYPE.ElementNode */ ) {
        if (nodeToRelocate.getAttribute("slot") === null && slotNameAttr === "") return true;
        if (nodeToRelocate.getAttribute("slot") === slotNameAttr) return true;
        return false;
    }
    if (nodeToRelocate["s-sn"] === slotNameAttr) return true;
    return slotNameAttr === "";
};
const $8cd96f0f3be295d3$var$callNodeRefs = (vNode)=>{
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomRef) {
        vNode.$attrs$ && vNode.$attrs$.ref && vNode.$attrs$.ref(null);
        vNode.$children$ && vNode.$children$.map($8cd96f0f3be295d3$var$callNodeRefs);
    }
};
/**
 * The main entry point for Stencil's virtual DOM-based rendering engine
 *
 * Given a {@link d.HostRef} container and some virtual DOM nodes, this
 * function will handle creating a virtual DOM tree with a single root, patching
 * the current virtual DOM tree onto an old one (if any), dealing with slot
 * relocation, and reflecting attributes.
 *
 * @param hostRef data needed to root and render the virtual DOM tree, such as
 * the DOM node into which it should be rendered.
 * @param renderFnResults the virtual DOM nodes to be rendered
 */ const $8cd96f0f3be295d3$export$52f8e388858754a = (hostRef, renderFnResults)=>{
    const hostElm = hostRef.$hostElement$;
    const cmpMeta = hostRef.$cmpMeta$;
    const oldVNode = hostRef.$vnode$ || $8cd96f0f3be295d3$var$newVNode(null, null);
    const rootVnode = $8cd96f0f3be295d3$var$isHost(renderFnResults) ? renderFnResults : $8cd96f0f3be295d3$export$dda1d9f60106f0e9(null, null, renderFnResults);
    $8cd96f0f3be295d3$var$hostTagName = hostElm.tagName;
    // <Host> runtime check
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev && Array.isArray(renderFnResults) && renderFnResults.some($8cd96f0f3be295d3$var$isHost)) throw new Error(`The <Host> must be the single root component.
Looks like the render() function of "${$8cd96f0f3be295d3$var$hostTagName.toLowerCase()}" is returning an array that contains the <Host>.

The render() function should look like this instead:

render() {
  // Do not return an array
  return (
    <Host>{content}</Host>
  );
}
  `);
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).reflect && cmpMeta.$attrsToReflect$) {
        rootVnode.$attrs$ = rootVnode.$attrs$ || {};
        cmpMeta.$attrsToReflect$.map(([propName, attribute])=>rootVnode.$attrs$[attribute] = hostElm[propName]);
    }
    rootVnode.$tag$ = null;
    rootVnode.$flags$ |= 4 /* VNODE_FLAGS.isHost */ ;
    hostRef.$vnode$ = rootVnode;
    rootVnode.$elm$ = oldVNode.$elm$ = (0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDom ? hostElm.shadowRoot || hostElm : hostElm;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).scoped || (0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDom) $8cd96f0f3be295d3$var$scopeId = hostElm["s-sc"];
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation) {
        $8cd96f0f3be295d3$var$contentRef = hostElm["s-cr"];
        $8cd96f0f3be295d3$var$useNativeShadowDom = $8cd96f0f3be295d3$export$b4e7e6d61dbcd813 && (cmpMeta.$flags$ & 1 /* CMP_FLAGS.shadowDomEncapsulation */ ) !== 0;
        // always reset
        $8cd96f0f3be295d3$var$checkSlotFallbackVisibility = false;
    }
    // synchronous patch
    $8cd96f0f3be295d3$var$patch(oldVNode, rootVnode);
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation) {
        // while we're moving nodes around existing nodes, temporarily disable
        // the disconnectCallback from working
        $8cd96f0f3be295d3$export$2e40610e9d23bca6.$flags$ |= 1 /* PLATFORM_FLAGS.isTmpDisconnected */ ;
        if ($8cd96f0f3be295d3$var$checkSlotRelocate) {
            $8cd96f0f3be295d3$var$relocateSlotContent(rootVnode.$elm$);
            let relocateData;
            let nodeToRelocate;
            let orgLocationNode;
            let parentNodeRef;
            let insertBeforeNode;
            let refNode;
            let i = 0;
            for(; i < $8cd96f0f3be295d3$var$relocateNodes.length; i++){
                relocateData = $8cd96f0f3be295d3$var$relocateNodes[i];
                nodeToRelocate = relocateData.$nodeToRelocate$;
                if (!nodeToRelocate["s-ol"]) {
                    // add a reference node marking this node's original location
                    // keep a reference to this node for later lookups
                    orgLocationNode = (0, $6c97b4542f89f042$export$455dbfd86f20b704).isDebug || (0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateServerSide ? $8cd96f0f3be295d3$var$originalLocationDebugNode(nodeToRelocate) : $8cd96f0f3be295d3$export$2a111da947c407d2.createTextNode("");
                    orgLocationNode["s-nr"] = nodeToRelocate;
                    nodeToRelocate.parentNode.insertBefore(nodeToRelocate["s-ol"] = orgLocationNode, nodeToRelocate);
                }
            }
            for(i = 0; i < $8cd96f0f3be295d3$var$relocateNodes.length; i++){
                relocateData = $8cd96f0f3be295d3$var$relocateNodes[i];
                nodeToRelocate = relocateData.$nodeToRelocate$;
                if (relocateData.$slotRefNode$) {
                    // by default we're just going to insert it directly
                    // after the slot reference node
                    parentNodeRef = relocateData.$slotRefNode$.parentNode;
                    insertBeforeNode = relocateData.$slotRefNode$.nextSibling;
                    orgLocationNode = nodeToRelocate["s-ol"];
                    while(orgLocationNode = orgLocationNode.previousSibling){
                        refNode = orgLocationNode["s-nr"];
                        if (refNode && refNode["s-sn"] === nodeToRelocate["s-sn"] && parentNodeRef === refNode.parentNode) {
                            refNode = refNode.nextSibling;
                            if (!refNode || !refNode["s-nr"]) {
                                insertBeforeNode = refNode;
                                break;
                            }
                        }
                    }
                    if (!insertBeforeNode && parentNodeRef !== nodeToRelocate.parentNode || nodeToRelocate.nextSibling !== insertBeforeNode) // we've checked that it's worth while to relocate
                    // since that the node to relocate
                    // has a different next sibling or parent relocated
                    {
                        if (nodeToRelocate !== insertBeforeNode) {
                            if (!nodeToRelocate["s-hn"] && nodeToRelocate["s-ol"]) // probably a component in the index.html that doesn't have it's hostname set
                            nodeToRelocate["s-hn"] = nodeToRelocate["s-ol"].parentNode.nodeName;
                            // add it back to the dom but in its new home
                            parentNodeRef.insertBefore(nodeToRelocate, insertBeforeNode);
                        }
                    }
                } else // this node doesn't have a slot home to go to, so let's hide it
                if (nodeToRelocate.nodeType === 1 /* NODE_TYPE.ElementNode */ ) nodeToRelocate.hidden = true;
            }
        }
        if ($8cd96f0f3be295d3$var$checkSlotFallbackVisibility) $8cd96f0f3be295d3$var$updateFallbackSlotVisibility(rootVnode.$elm$);
        // done moving nodes around
        // allow the disconnect callback to work again
        $8cd96f0f3be295d3$export$2e40610e9d23bca6.$flags$ &= -2 /* PLATFORM_FLAGS.isTmpDisconnected */ ;
        // always reset
        $8cd96f0f3be295d3$var$relocateNodes.length = 0;
    }
};
// slot comment debug nodes only created with the `--debug` flag
// otherwise these nodes are text nodes w/out content
const $8cd96f0f3be295d3$var$slotReferenceDebugNode = (slotVNode)=>$8cd96f0f3be295d3$export$2a111da947c407d2.createComment(`<slot${slotVNode.$name$ ? ' name="' + slotVNode.$name$ + '"' : ""}> (host=${$8cd96f0f3be295d3$var$hostTagName.toLowerCase()})`);
const $8cd96f0f3be295d3$var$originalLocationDebugNode = (nodeToRelocate)=>$8cd96f0f3be295d3$export$2a111da947c407d2.createComment(`org-location for ` + (nodeToRelocate.localName ? `<${nodeToRelocate.localName}> (host=${nodeToRelocate["s-hn"]})` : `[${nodeToRelocate.textContent}]`));
const $8cd96f0f3be295d3$var$attachToAncestor = (hostRef, ancestorComponent)=>{
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).asyncLoading && ancestorComponent && !hostRef.$onRenderResolve$ && ancestorComponent["s-p"]) ancestorComponent["s-p"].push(new Promise((r)=>hostRef.$onRenderResolve$ = r));
};
const $8cd96f0f3be295d3$var$scheduleUpdate = (hostRef, isInitialLoad)=>{
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).taskQueue && (0, $6c97b4542f89f042$export$455dbfd86f20b704).updatable) hostRef.$flags$ |= 16 /* HOST_FLAGS.isQueuedForUpdate */ ;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).asyncLoading && hostRef.$flags$ & 4 /* HOST_FLAGS.isWaitingForChildren */ ) {
        hostRef.$flags$ |= 512 /* HOST_FLAGS.needsRerender */ ;
        return;
    }
    $8cd96f0f3be295d3$var$attachToAncestor(hostRef, hostRef.$ancestorComponent$);
    // there is no ancestor component or the ancestor component
    // has already fired off its lifecycle update then
    // fire off the initial update
    const dispatch = ()=>$8cd96f0f3be295d3$var$dispatchHooks(hostRef, isInitialLoad);
    return (0, $6c97b4542f89f042$export$455dbfd86f20b704).taskQueue ? $8cd96f0f3be295d3$export$bbfc1321f142f72c(dispatch) : dispatch();
};
const $8cd96f0f3be295d3$var$dispatchHooks = (hostRef, isInitialLoad)=>{
    const elm = hostRef.$hostElement$;
    const endSchedule = $8cd96f0f3be295d3$var$createTime("scheduleUpdate", hostRef.$cmpMeta$.$tagName$);
    const instance = (0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad ? hostRef.$lazyInstance$ : elm;
    let promise;
    if (isInitialLoad) {
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad && (0, $6c97b4542f89f042$export$455dbfd86f20b704).hostListener) {
            hostRef.$flags$ |= 256 /* HOST_FLAGS.isListenReady */ ;
            if (hostRef.$queuedListeners$) {
                hostRef.$queuedListeners$.map(([methodName, event])=>$8cd96f0f3be295d3$var$safeCall(instance, methodName, event));
                hostRef.$queuedListeners$ = null;
            }
        }
        $8cd96f0f3be295d3$var$emitLifecycleEvent(elm, "componentWillLoad");
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).cmpWillLoad) promise = $8cd96f0f3be295d3$var$safeCall(instance, "componentWillLoad");
    } else {
        $8cd96f0f3be295d3$var$emitLifecycleEvent(elm, "componentWillUpdate");
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).cmpWillUpdate) promise = $8cd96f0f3be295d3$var$safeCall(instance, "componentWillUpdate");
    }
    $8cd96f0f3be295d3$var$emitLifecycleEvent(elm, "componentWillRender");
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).cmpWillRender) promise = $8cd96f0f3be295d3$var$then(promise, ()=>$8cd96f0f3be295d3$var$safeCall(instance, "componentWillRender"));
    endSchedule();
    return $8cd96f0f3be295d3$var$then(promise, ()=>$8cd96f0f3be295d3$var$updateComponent(hostRef, instance, isInitialLoad));
};
const $8cd96f0f3be295d3$var$updateComponent = async (hostRef, instance, isInitialLoad)=>{
    // updateComponent
    const elm = hostRef.$hostElement$;
    const endUpdate = $8cd96f0f3be295d3$var$createTime("update", hostRef.$cmpMeta$.$tagName$);
    const rc = elm["s-rc"];
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).style && isInitialLoad) // DOM WRITE!
    $8cd96f0f3be295d3$var$attachStyles(hostRef);
    const endRender = $8cd96f0f3be295d3$var$createTime("render", hostRef.$cmpMeta$.$tagName$);
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev) hostRef.$flags$ |= 1024 /* HOST_FLAGS.devOnRender */ ;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateServerSide) await $8cd96f0f3be295d3$var$callRender(hostRef, instance, elm);
    else $8cd96f0f3be295d3$var$callRender(hostRef, instance, elm);
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).cssVarShim && $8cd96f0f3be295d3$export$2e40610e9d23bca6.$cssShim$) $8cd96f0f3be295d3$export$2e40610e9d23bca6.$cssShim$.updateHost(elm);
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev) {
        hostRef.$renderCount$++;
        hostRef.$flags$ &= -1025 /* HOST_FLAGS.devOnRender */ ;
    }
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateServerSide) try {
        // manually connected child components during server-side hydrate
        $8cd96f0f3be295d3$var$serverSideConnected(elm);
        if (isInitialLoad) {
            // using only during server-side hydrate
            if (hostRef.$cmpMeta$.$flags$ & 1 /* CMP_FLAGS.shadowDomEncapsulation */ ) elm["s-en"] = "";
            else if (hostRef.$cmpMeta$.$flags$ & 2 /* CMP_FLAGS.scopedCssEncapsulation */ ) elm["s-en"] = "c";
        }
    } catch (e) {
        $8cd96f0f3be295d3$export$bf36f23bad3e1069(e, elm);
    }
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).asyncLoading && rc) {
        // ok, so turns out there are some child host elements
        // waiting on this parent element to load
        // let's fire off all update callbacks waiting
        rc.map((cb)=>cb());
        elm["s-rc"] = undefined;
    }
    endRender();
    endUpdate();
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).asyncLoading) {
        const childrenPromises = elm["s-p"];
        const postUpdate = ()=>$8cd96f0f3be295d3$export$a2fffedced549758(hostRef);
        if (childrenPromises.length === 0) postUpdate();
        else {
            Promise.all(childrenPromises).then(postUpdate);
            hostRef.$flags$ |= 4 /* HOST_FLAGS.isWaitingForChildren */ ;
            childrenPromises.length = 0;
        }
    } else $8cd96f0f3be295d3$export$a2fffedced549758(hostRef);
};
const $8cd96f0f3be295d3$var$callRender = (hostRef, instance, elm)=>{
    // in order for bundlers to correctly treeshake the BUILD object
    // we need to ensure BUILD is not deoptimized within a try/catch
    // https://rollupjs.org/guide/en/#treeshake tryCatchDeoptimization
    const allRenderFn = (0, $6c97b4542f89f042$export$455dbfd86f20b704).allRenderFn ? true : false;
    const lazyLoad = (0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad ? true : false;
    const taskQueue = (0, $6c97b4542f89f042$export$455dbfd86f20b704).taskQueue ? true : false;
    const updatable = (0, $6c97b4542f89f042$export$455dbfd86f20b704).updatable ? true : false;
    try {
        $8cd96f0f3be295d3$var$renderingRef = instance;
        instance = allRenderFn ? instance.render() : instance.render && instance.render();
        if (updatable && taskQueue) hostRef.$flags$ &= -17 /* HOST_FLAGS.isQueuedForUpdate */ ;
        if (updatable || lazyLoad) hostRef.$flags$ |= 2 /* HOST_FLAGS.hasRendered */ ;
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hasRenderFn || (0, $6c97b4542f89f042$export$455dbfd86f20b704).reflect) {
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).vdomRender || (0, $6c97b4542f89f042$export$455dbfd86f20b704).reflect) {
                // looks like we've got child nodes to render into this host element
                // or we need to update the css class/attrs on the host element
                // DOM WRITE!
                if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateServerSide) return Promise.resolve(instance).then((value)=>$8cd96f0f3be295d3$export$52f8e388858754a(hostRef, value));
                else $8cd96f0f3be295d3$export$52f8e388858754a(hostRef, instance);
            } else elm.textContent = instance;
        }
    } catch (e) {
        $8cd96f0f3be295d3$export$bf36f23bad3e1069(e, hostRef.$hostElement$);
    }
    $8cd96f0f3be295d3$var$renderingRef = null;
    return null;
};
const $8cd96f0f3be295d3$export$40c3cc0861cb4611 = ()=>$8cd96f0f3be295d3$var$renderingRef;
const $8cd96f0f3be295d3$export$a2fffedced549758 = (hostRef)=>{
    const tagName = hostRef.$cmpMeta$.$tagName$;
    const elm = hostRef.$hostElement$;
    const endPostUpdate = $8cd96f0f3be295d3$var$createTime("postUpdate", tagName);
    const instance = (0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad ? hostRef.$lazyInstance$ : elm;
    const ancestorComponent = hostRef.$ancestorComponent$;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).cmpDidRender) {
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev) hostRef.$flags$ |= 1024 /* HOST_FLAGS.devOnRender */ ;
        $8cd96f0f3be295d3$var$safeCall(instance, "componentDidRender");
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev) hostRef.$flags$ &= -1025 /* HOST_FLAGS.devOnRender */ ;
    }
    $8cd96f0f3be295d3$var$emitLifecycleEvent(elm, "componentDidRender");
    if (!(hostRef.$flags$ & 64 /* HOST_FLAGS.hasLoadedComponent */ )) {
        hostRef.$flags$ |= 64 /* HOST_FLAGS.hasLoadedComponent */ ;
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).asyncLoading && (0, $6c97b4542f89f042$export$455dbfd86f20b704).cssAnnotations) // DOM WRITE!
        $8cd96f0f3be295d3$var$addHydratedFlag(elm);
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).cmpDidLoad) {
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev) hostRef.$flags$ |= 2048 /* HOST_FLAGS.devOnDidLoad */ ;
            $8cd96f0f3be295d3$var$safeCall(instance, "componentDidLoad");
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev) hostRef.$flags$ &= -2049 /* HOST_FLAGS.devOnDidLoad */ ;
        }
        $8cd96f0f3be295d3$var$emitLifecycleEvent(elm, "componentDidLoad");
        endPostUpdate();
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).asyncLoading) {
            hostRef.$onReadyResolve$(elm);
            if (!ancestorComponent) $8cd96f0f3be295d3$var$appDidLoad(tagName);
        }
    } else {
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).cmpDidUpdate) {
            // we've already loaded this component
            // fire off the user's componentDidUpdate method (if one was provided)
            // componentDidUpdate runs AFTER render() has been called
            // and all child components have finished updating
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev) hostRef.$flags$ |= 1024 /* HOST_FLAGS.devOnRender */ ;
            $8cd96f0f3be295d3$var$safeCall(instance, "componentDidUpdate");
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev) hostRef.$flags$ &= -1025 /* HOST_FLAGS.devOnRender */ ;
        }
        $8cd96f0f3be295d3$var$emitLifecycleEvent(elm, "componentDidUpdate");
        endPostUpdate();
    }
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hotModuleReplacement) elm["s-hmr-load"] && elm["s-hmr-load"]();
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).method && (0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad) hostRef.$onInstanceResolve$(elm);
    // load events fire from bottom to top
    // the deepest elements load first then bubbles up
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).asyncLoading) {
        if (hostRef.$onRenderResolve$) {
            hostRef.$onRenderResolve$();
            hostRef.$onRenderResolve$ = undefined;
        }
        if (hostRef.$flags$ & 512 /* HOST_FLAGS.needsRerender */ ) $8cd96f0f3be295d3$export$bdd553fddd433dcb(()=>$8cd96f0f3be295d3$var$scheduleUpdate(hostRef, false));
        hostRef.$flags$ &= -517;
    }
// ( •_•)
// ( •_•)>⌐■-■
// (⌐■_■)
};
const $8cd96f0f3be295d3$export$98c7f8edae68c30f = (ref)=>{
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).updatable) {
        const hostRef = $8cd96f0f3be295d3$export$3f84770eccf215d2(ref);
        const isConnected = hostRef.$hostElement$.isConnected;
        if (isConnected && (hostRef.$flags$ & 18 /* HOST_FLAGS.isQueuedForUpdate */ ) === 2 /* HOST_FLAGS.hasRendered */ ) $8cd96f0f3be295d3$var$scheduleUpdate(hostRef, false);
        // Returns "true" when the forced update was successfully scheduled
        return isConnected;
    }
    return false;
};
const $8cd96f0f3be295d3$var$appDidLoad = (who)=>{
    // on appload
    // we have finish the first big initial render
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).cssAnnotations) $8cd96f0f3be295d3$var$addHydratedFlag($8cd96f0f3be295d3$export$2a111da947c407d2.documentElement);
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).asyncQueue) $8cd96f0f3be295d3$export$2e40610e9d23bca6.$flags$ |= 2 /* PLATFORM_FLAGS.appLoaded */ ;
    $8cd96f0f3be295d3$export$bdd553fddd433dcb(()=>$8cd96f0f3be295d3$var$emitEvent($8cd96f0f3be295d3$export$10a0f131c0eea21b, "appload", {
            detail: {
                namespace: (0, $6c97b4542f89f042$export$6aad947bda0f3f46)
            }
        }));
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).profile && performance.measure) performance.measure(`[Stencil] ${(0, $6c97b4542f89f042$export$6aad947bda0f3f46)} initial load (by ${who})`, "st:app:start");
};
const $8cd96f0f3be295d3$var$safeCall = (instance, method, arg)=>{
    if (instance && instance[method]) try {
        return instance[method](arg);
    } catch (e) {
        $8cd96f0f3be295d3$export$bf36f23bad3e1069(e);
    }
    return undefined;
};
const $8cd96f0f3be295d3$var$then = (promise, thenFn)=>{
    return promise && promise.then ? promise.then(thenFn) : thenFn();
};
const $8cd96f0f3be295d3$var$emitLifecycleEvent = (elm, lifecycleName)=>{
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).lifecycleDOMEvents) $8cd96f0f3be295d3$var$emitEvent(elm, "stencil_" + lifecycleName, {
        bubbles: true,
        composed: true,
        detail: {
            namespace: (0, $6c97b4542f89f042$export$6aad947bda0f3f46)
        }
    });
};
const $8cd96f0f3be295d3$var$addHydratedFlag = (elm)=>(0, $6c97b4542f89f042$export$455dbfd86f20b704).hydratedClass ? elm.classList.add("hydrated") : (0, $6c97b4542f89f042$export$455dbfd86f20b704).hydratedAttribute ? elm.setAttribute("hydrated", "") : undefined;
const $8cd96f0f3be295d3$var$serverSideConnected = (elm)=>{
    const children = elm.children;
    if (children != null) for(let i = 0, ii = children.length; i < ii; i++){
        const childElm = children[i];
        if (typeof childElm.connectedCallback === "function") childElm.connectedCallback();
        $8cd96f0f3be295d3$var$serverSideConnected(childElm);
    }
};
const $8cd96f0f3be295d3$export$bf7199a9ebcb84a9 = (ref, propName)=>$8cd96f0f3be295d3$export$3f84770eccf215d2(ref).$instanceValues$.get(propName);
const $8cd96f0f3be295d3$export$80746c6bc6142fc8 = (ref, propName, newVal, cmpMeta)=>{
    // check our new property value against our internal value
    const hostRef = $8cd96f0f3be295d3$export$3f84770eccf215d2(ref);
    const elm = (0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad ? hostRef.$hostElement$ : ref;
    const oldVal = hostRef.$instanceValues$.get(propName);
    const flags = hostRef.$flags$;
    const instance = (0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad ? hostRef.$lazyInstance$ : elm;
    newVal = $8cd96f0f3be295d3$export$480b8c8d1e35b434(newVal, cmpMeta.$members$[propName][0]);
    // explicitly check for NaN on both sides, as `NaN === NaN` is always false
    const areBothNaN = Number.isNaN(oldVal) && Number.isNaN(newVal);
    const didValueChange = newVal !== oldVal && !areBothNaN;
    if ((!(0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad || !(flags & 8 /* HOST_FLAGS.isConstructingInstance */ ) || oldVal === undefined) && didValueChange) {
        // gadzooks! the property's value has changed!!
        // set our new value!
        hostRef.$instanceValues$.set(propName, newVal);
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev) {
            if (hostRef.$flags$ & 1024 /* HOST_FLAGS.devOnRender */ ) $8cd96f0f3be295d3$export$5d385f3b3df7e1b9(`The state/prop "${propName}" changed during rendering. This can potentially lead to infinite-loops and other bugs.`, "\nElement", elm, "\nNew value", newVal, "\nOld value", oldVal);
            else if (hostRef.$flags$ & 2048 /* HOST_FLAGS.devOnDidLoad */ ) $8cd96f0f3be295d3$export$5d385f3b3df7e1b9(`The state/prop "${propName}" changed during "componentDidLoad()", this triggers extra re-renders, try to setup on "componentWillLoad()"`, "\nElement", elm, "\nNew value", newVal, "\nOld value", oldVal);
        }
        if (!(0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad || instance) {
            // get an array of method names of watch functions to call
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).watchCallback && cmpMeta.$watchers$ && flags & 128 /* HOST_FLAGS.isWatchReady */ ) {
                const watchMethods = cmpMeta.$watchers$[propName];
                if (watchMethods) // this instance is watching for when this property changed
                watchMethods.map((watchMethodName)=>{
                    try {
                        // fire off each of the watch methods that are watching this property
                        instance[watchMethodName](newVal, oldVal, propName);
                    } catch (e) {
                        $8cd96f0f3be295d3$export$bf36f23bad3e1069(e, elm);
                    }
                });
            }
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).updatable && (flags & 18 /* HOST_FLAGS.isQueuedForUpdate */ ) === 2 /* HOST_FLAGS.hasRendered */ ) {
                if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).cmpShouldUpdate && instance.componentShouldUpdate) {
                    if (instance.componentShouldUpdate(newVal, oldVal, propName) === false) return;
                }
                // looks like this value actually changed, so we've got work to do!
                // but only if we've already rendered, otherwise just chill out
                // queue that we need to do an update, but don't worry about queuing
                // up millions cuz this function ensures it only runs once
                $8cd96f0f3be295d3$var$scheduleUpdate(hostRef, false);
            }
        }
    }
};
/**
 * Attach a series of runtime constructs to a compiled Stencil component
 * constructor, including getters and setters for the `@Prop` and `@State`
 * decorators, callbacks for when attributes change, and so on.
 *
 * @param Cstr the constructor for a component that we need to process
 * @param cmpMeta metadata collected previously about the component
 * @param flags a number used to store a series of bit flags
 * @returns a reference to the same constructor passed in (but now mutated)
 */ const $8cd96f0f3be295d3$export$982064ca8d9ad69 = (Cstr, cmpMeta, flags)=>{
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).member && cmpMeta.$members$) {
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).watchCallback && Cstr.watchers) cmpMeta.$watchers$ = Cstr.watchers;
        // It's better to have a const than two Object.entries()
        const members = Object.entries(cmpMeta.$members$);
        const prototype = Cstr.prototype;
        members.map(([memberName, [memberFlags]])=>{
            if (((0, $6c97b4542f89f042$export$455dbfd86f20b704).prop || (0, $6c97b4542f89f042$export$455dbfd86f20b704).state) && (memberFlags & 31 /* MEMBER_FLAGS.Prop */  || (!(0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad || flags & 2 /* PROXY_FLAGS.proxyState */ ) && memberFlags & 32 /* MEMBER_FLAGS.State */ )) // proxyComponent - prop
            Object.defineProperty(prototype, memberName, {
                get () {
                    // proxyComponent, get value
                    return $8cd96f0f3be295d3$export$bf7199a9ebcb84a9(this, memberName);
                },
                set (newValue) {
                    // only during dev time
                    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev) {
                        const ref = $8cd96f0f3be295d3$export$3f84770eccf215d2(this);
                        if (// we are proxying the instance (not element)
                        (flags & 1 /* PROXY_FLAGS.isElementConstructor */ ) === 0 && // the element is not constructing
                        (ref.$flags$ & 8 /* HOST_FLAGS.isConstructingInstance */ ) === 0 && // the member is a prop
                        (memberFlags & 31 /* MEMBER_FLAGS.Prop */ ) !== 0 && // the member is not mutable
                        (memberFlags & 1024 /* MEMBER_FLAGS.Mutable */ ) === 0) $8cd96f0f3be295d3$export$5d385f3b3df7e1b9(`@Prop() "${memberName}" on <${cmpMeta.$tagName$}> is immutable but was modified from within the component.\nMore information: https://stenciljs.com/docs/properties#prop-mutability`);
                    }
                    // proxyComponent, set value
                    $8cd96f0f3be295d3$export$80746c6bc6142fc8(this, memberName, newValue, cmpMeta);
                },
                configurable: true,
                enumerable: true
            });
            else if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad && (0, $6c97b4542f89f042$export$455dbfd86f20b704).method && flags & 1 /* PROXY_FLAGS.isElementConstructor */  && memberFlags & 64 /* MEMBER_FLAGS.Method */ ) // proxyComponent - method
            Object.defineProperty(prototype, memberName, {
                value (...args) {
                    const ref = $8cd96f0f3be295d3$export$3f84770eccf215d2(this);
                    return ref.$onInstancePromise$.then(()=>ref.$lazyInstance$[memberName](...args));
                }
            });
        });
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).observeAttribute && (!(0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad || flags & 1 /* PROXY_FLAGS.isElementConstructor */ )) {
            const attrNameToPropName = new Map();
            prototype.attributeChangedCallback = function(attrName, _oldValue, newValue) {
                $8cd96f0f3be295d3$export$2e40610e9d23bca6.jmp(()=>{
                    const propName = attrNameToPropName.get(attrName);
                    //  In a web component lifecycle the attributeChangedCallback runs prior to connectedCallback
                    //  in the case where an attribute was set inline.
                    //  ```html
                    //    <my-component some-attribute="some-value"></my-component>
                    //  ```
                    //
                    //  There is an edge case where a developer sets the attribute inline on a custom element and then
                    //  programmatically changes it before it has been upgraded as shown below:
                    //
                    //  ```html
                    //    <!-- this component has _not_ been upgraded yet -->
                    //    <my-component id="test" some-attribute="some-value"></my-component>
                    //    <script>
                    //      // grab non-upgraded component
                    //      el = document.querySelector("#test");
                    //      el.someAttribute = "another-value";
                    //      // upgrade component
                    //      customElements.define('my-component', MyComponent);
                    //    </script>
                    //  ```
                    //  In this case if we do not unshadow here and use the value of the shadowing property, attributeChangedCallback
                    //  will be called with `newValue = "some-value"` and will set the shadowed property (this.someAttribute = "another-value")
                    //  to the value that was set inline i.e. "some-value" from above example. When
                    //  the connectedCallback attempts to unshadow it will use "some-value" as the initial value rather than "another-value"
                    //
                    //  The case where the attribute was NOT set inline but was not set programmatically shall be handled/unshadowed
                    //  by connectedCallback as this attributeChangedCallback will not fire.
                    //
                    //  https://developers.google.com/web/fundamentals/web-components/best-practices#lazy-properties
                    //
                    //  TODO(STENCIL-16) we should think about whether or not we actually want to be reflecting the attributes to
                    //  properties here given that this goes against best practices outlined here
                    //  https://developers.google.com/web/fundamentals/web-components/best-practices#avoid-reentrancy
                    if (this.hasOwnProperty(propName)) {
                        newValue = this[propName];
                        delete this[propName];
                    } else if (prototype.hasOwnProperty(propName) && typeof this[propName] === "number" && this[propName] == newValue) // if the propName exists on the prototype of `Cstr`, this update may be a result of Stencil using native
                    // APIs to reflect props as attributes. Calls to `setAttribute(someElement, propName)` will result in
                    // `propName` to be converted to a `DOMString`, which may not be what we want for other primitive props.
                    return;
                    this[propName] = newValue === null && typeof this[propName] === "boolean" ? false : newValue;
                });
            };
            // create an array of attributes to observe
            // and also create a map of html attribute name to js property name
            Cstr.observedAttributes = members.filter(([_, m])=>m[0] & 15 /* MEMBER_FLAGS.HasAttribute */ ) // filter to only keep props that should match attributes
            .map(([propName, m])=>{
                const attrName = m[1] || propName;
                attrNameToPropName.set(attrName, propName);
                if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).reflect && m[0] & 512 /* MEMBER_FLAGS.ReflectAttr */ ) cmpMeta.$attrsToReflect$.push([
                    propName,
                    attrName
                ]);
                return attrName;
            });
        }
    }
    return Cstr;
};

const $8cd96f0f3be295d3$var$initializeComponent = async (elm, hostRef, cmpMeta, hmrVersionId, Cstr)=>{
    // initializeComponent
    if (((0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad || (0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateServerSide || (0, $6c97b4542f89f042$export$455dbfd86f20b704).style) && (hostRef.$flags$ & 32 /* HOST_FLAGS.hasInitializedComponent */ ) === 0) {
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad || (0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateClientSide) {
            // we haven't initialized this element yet
            hostRef.$flags$ |= 32 /* HOST_FLAGS.hasInitializedComponent */ ;
            // lazy loaded components
            // request the component's implementation to be
            // wired up with the host element
            Cstr = $8cd96f0f3be295d3$export$ebb47fdc8f2dbc6f(cmpMeta, hostRef, hmrVersionId);
            if (Cstr.then) {
                // Await creates a micro-task avoid if possible
                const endLoad = $8cd96f0f3be295d3$var$uniqueTime(`st:load:${cmpMeta.$tagName$}:${hostRef.$modeName$}`, `[Stencil] Load module for <${cmpMeta.$tagName$}>`);
                Cstr = await Cstr;
                endLoad();
            }
            if (((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev || (0, $6c97b4542f89f042$export$455dbfd86f20b704).isDebug) && !Cstr) throw new Error(`Constructor for "${cmpMeta.$tagName$}#${hostRef.$modeName$}" was not found`);
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).member && !Cstr.isProxied) {
                // we've never proxied this Constructor before
                // let's add the getters/setters to its prototype before
                // the first time we create an instance of the implementation
                if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).watchCallback) cmpMeta.$watchers$ = Cstr.watchers;
                $8cd96f0f3be295d3$export$982064ca8d9ad69(Cstr, cmpMeta, 2 /* PROXY_FLAGS.proxyState */ );
                Cstr.isProxied = true;
            }
            const endNewInstance = $8cd96f0f3be295d3$var$createTime("createInstance", cmpMeta.$tagName$);
            // ok, time to construct the instance
            // but let's keep track of when we start and stop
            // so that the getters/setters don't incorrectly step on data
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).member) hostRef.$flags$ |= 8 /* HOST_FLAGS.isConstructingInstance */ ;
            // construct the lazy-loaded component implementation
            // passing the hostRef is very important during
            // construction in order to directly wire together the
            // host element and the lazy-loaded instance
            try {
                new Cstr(hostRef);
            } catch (e) {
                $8cd96f0f3be295d3$export$bf36f23bad3e1069(e);
            }
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).member) hostRef.$flags$ &= -9 /* HOST_FLAGS.isConstructingInstance */ ;
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).watchCallback) hostRef.$flags$ |= 128 /* HOST_FLAGS.isWatchReady */ ;
            endNewInstance();
            $8cd96f0f3be295d3$var$fireConnectedCallback(hostRef.$lazyInstance$);
        } else {
            // sync constructor component
            Cstr = elm.constructor;
            hostRef.$flags$ |= 32 /* HOST_FLAGS.hasInitializedComponent */ ;
            // wait for the CustomElementRegistry to mark the component as ready before setting `isWatchReady`. Otherwise,
            // watchers may fire prematurely if `customElements.get()`/`customElements.whenDefined()` resolves _before_
            // Stencil has completed instantiating the component.
            customElements.whenDefined(cmpMeta.$tagName$).then(()=>hostRef.$flags$ |= 128 /* HOST_FLAGS.isWatchReady */ );
        }
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).style && Cstr.style) {
            // this component has styles but we haven't registered them yet
            let style = Cstr.style;
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).mode && typeof style !== "string") {
                style = style[hostRef.$modeName$ = $8cd96f0f3be295d3$var$computeMode(elm)];
                if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateServerSide && hostRef.$modeName$) elm.setAttribute("s-mode", hostRef.$modeName$);
            }
            const scopeId = $8cd96f0f3be295d3$var$getScopeId(cmpMeta, hostRef.$modeName$);
            if (!$8cd96f0f3be295d3$export$9dd6ff9ea0189349.has(scopeId)) {
                const endRegisterStyles = $8cd96f0f3be295d3$var$createTime("registerStyles", cmpMeta.$tagName$);
                if (!(0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateServerSide && (0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDom && (0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDomShim && cmpMeta.$flags$ & 8 /* CMP_FLAGS.needsShadowDomShim */ ) style = await (parcelRequire("5h8v1")).then((m)=>m.scopeCss(style, scopeId, false));
                $8cd96f0f3be295d3$var$registerStyle(scopeId, style, !!(cmpMeta.$flags$ & 1 /* CMP_FLAGS.shadowDomEncapsulation */ ));
                endRegisterStyles();
            }
        }
    }
    // we've successfully created a lazy instance
    const ancestorComponent = hostRef.$ancestorComponent$;
    const schedule = ()=>$8cd96f0f3be295d3$var$scheduleUpdate(hostRef, true);
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).asyncLoading && ancestorComponent && ancestorComponent["s-rc"]) // this is the initial load and this component it has an ancestor component
    // but the ancestor component has NOT fired its will update lifecycle yet
    // so let's just cool our jets and wait for the ancestor to continue first
    // this will get fired off when the ancestor component
    // finally gets around to rendering its lazy self
    // fire off the initial update
    ancestorComponent["s-rc"].push(schedule);
    else schedule();
};
const $8cd96f0f3be295d3$var$fireConnectedCallback = (instance)=>{
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad && (0, $6c97b4542f89f042$export$455dbfd86f20b704).connectedCallback) $8cd96f0f3be295d3$var$safeCall(instance, "connectedCallback");
};
const $8cd96f0f3be295d3$export$de367db4d6dadc9f = (elm)=>{
    if (($8cd96f0f3be295d3$export$2e40610e9d23bca6.$flags$ & 1 /* PLATFORM_FLAGS.isTmpDisconnected */ ) === 0) {
        const hostRef = $8cd96f0f3be295d3$export$3f84770eccf215d2(elm);
        const cmpMeta = hostRef.$cmpMeta$;
        const endConnected = $8cd96f0f3be295d3$var$createTime("connectedCallback", cmpMeta.$tagName$);
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hostListenerTargetParent) // only run if we have listeners being attached to a parent
        $8cd96f0f3be295d3$export$62df7fa1a32c483(elm, hostRef, cmpMeta.$listeners$, true);
        if (!(hostRef.$flags$ & 1 /* HOST_FLAGS.hasConnected */ )) {
            // first time this component has connected
            hostRef.$flags$ |= 1 /* HOST_FLAGS.hasConnected */ ;
            let hostId;
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateClientSide) {
                hostId = elm.getAttribute($8cd96f0f3be295d3$var$HYDRATE_ID);
                if (hostId) {
                    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDom && $8cd96f0f3be295d3$export$b4e7e6d61dbcd813 && cmpMeta.$flags$ & 1 /* CMP_FLAGS.shadowDomEncapsulation */ ) {
                        const scopeId = (0, $6c97b4542f89f042$export$455dbfd86f20b704).mode ? $8cd96f0f3be295d3$var$addStyle(elm.shadowRoot, cmpMeta, elm.getAttribute("s-mode")) : $8cd96f0f3be295d3$var$addStyle(elm.shadowRoot, cmpMeta);
                        elm.classList.remove(scopeId + "-h", scopeId + "-s");
                    }
                    $8cd96f0f3be295d3$var$initializeClientHydrate(elm, cmpMeta.$tagName$, hostId, hostRef);
                }
            }
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).slotRelocation && !hostId) // initUpdate
            // if the slot polyfill is required we'll need to put some nodes
            // in here to act as original content anchors as we move nodes around
            // host element has been connected to the DOM
            {
                if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateServerSide || ((0, $6c97b4542f89f042$export$455dbfd86f20b704).slot || (0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDom) && cmpMeta.$flags$ & 12 /* CMP_FLAGS.needsShadowDomShim */ ) $8cd96f0f3be295d3$var$setContentReference(elm);
            }
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).asyncLoading) {
                // find the first ancestor component (if there is one) and register
                // this component as one of the actively loading child components for its ancestor
                let ancestorComponent = elm;
                while(ancestorComponent = ancestorComponent.parentNode || ancestorComponent.host)// climb up the ancestors looking for the first
                // component that hasn't finished its lifecycle update yet
                if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateClientSide && ancestorComponent.nodeType === 1 /* NODE_TYPE.ElementNode */  && ancestorComponent.hasAttribute("s-id") && ancestorComponent["s-p"] || ancestorComponent["s-p"]) {
                    // we found this components first ancestor component
                    // keep a reference to this component's ancestor component
                    $8cd96f0f3be295d3$var$attachToAncestor(hostRef, hostRef.$ancestorComponent$ = ancestorComponent);
                    break;
                }
            }
            // Lazy properties
            // https://developers.google.com/web/fundamentals/web-components/best-practices#lazy-properties
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).prop && !(0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateServerSide && cmpMeta.$members$) Object.entries(cmpMeta.$members$).map(([memberName, [memberFlags]])=>{
                if (memberFlags & 31 /* MEMBER_FLAGS.Prop */  && elm.hasOwnProperty(memberName)) {
                    const value = elm[memberName];
                    delete elm[memberName];
                    elm[memberName] = value;
                }
            });
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).initializeNextTick) // connectedCallback, taskQueue, initialLoad
            // angular sets attribute AFTER connectCallback
            // https://github.com/angular/angular/issues/18909
            // https://github.com/angular/angular/issues/19940
            $8cd96f0f3be295d3$export$bdd553fddd433dcb(()=>$8cd96f0f3be295d3$var$initializeComponent(elm, hostRef, cmpMeta));
            else $8cd96f0f3be295d3$var$initializeComponent(elm, hostRef, cmpMeta);
        } else {
            // not the first time this has connected
            // reattach any event listeners to the host
            // since they would have been removed when disconnected
            $8cd96f0f3be295d3$export$62df7fa1a32c483(elm, hostRef, cmpMeta.$listeners$, false);
            // fire off connectedCallback() on component instance
            $8cd96f0f3be295d3$var$fireConnectedCallback(hostRef.$lazyInstance$);
        }
        endConnected();
    }
};
const $8cd96f0f3be295d3$var$setContentReference = (elm)=>{
    // only required when we're NOT using native shadow dom (slot)
    // or this browser doesn't support native shadow dom
    // and this host element was NOT created with SSR
    // let's pick out the inner content for slot projection
    // create a node to represent where the original
    // content was first placed, which is useful later on
    const contentRefElm = elm["s-cr"] = $8cd96f0f3be295d3$export$2a111da947c407d2.createComment((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDebug ? `content-ref (host=${elm.localName})` : "");
    contentRefElm["s-cn"] = true;
    elm.insertBefore(contentRefElm, elm.firstChild);
};
const $8cd96f0f3be295d3$export$6cf1a3dd300e0a4f = (elm)=>{
    if (($8cd96f0f3be295d3$export$2e40610e9d23bca6.$flags$ & 1 /* PLATFORM_FLAGS.isTmpDisconnected */ ) === 0) {
        const hostRef = $8cd96f0f3be295d3$export$3f84770eccf215d2(elm);
        const instance = (0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad ? hostRef.$lazyInstance$ : elm;
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hostListener) {
            if (hostRef.$rmListeners$) {
                hostRef.$rmListeners$.map((rmListener)=>rmListener());
                hostRef.$rmListeners$ = undefined;
            }
        }
        // clear CSS var-shim tracking
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).cssVarShim && $8cd96f0f3be295d3$export$2e40610e9d23bca6.$cssShim$) $8cd96f0f3be295d3$export$2e40610e9d23bca6.$cssShim$.removeHost(elm);
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad && (0, $6c97b4542f89f042$export$455dbfd86f20b704).disconnectedCallback) $8cd96f0f3be295d3$var$safeCall(instance, "disconnectedCallback");
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).cmpDidUnload) $8cd96f0f3be295d3$var$safeCall(instance, "componentDidUnload");
    }
};
const $8cd96f0f3be295d3$export$a00e2346eabbdbef = (Cstr, compactMeta)=>{
    customElements.define(compactMeta[1], $8cd96f0f3be295d3$export$370caf1876b7c579(Cstr, compactMeta));
};
const $8cd96f0f3be295d3$export$370caf1876b7c579 = (Cstr, compactMeta)=>{
    const cmpMeta = {
        $flags$: compactMeta[0],
        $tagName$: compactMeta[1]
    };
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).member) cmpMeta.$members$ = compactMeta[2];
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hostListener) cmpMeta.$listeners$ = compactMeta[3];
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).watchCallback) cmpMeta.$watchers$ = Cstr.$watchers$;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).reflect) cmpMeta.$attrsToReflect$ = [];
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDom && !$8cd96f0f3be295d3$export$b4e7e6d61dbcd813 && cmpMeta.$flags$ & 1 /* CMP_FLAGS.shadowDomEncapsulation */ ) cmpMeta.$flags$ |= 8 /* CMP_FLAGS.needsShadowDomShim */ ;
    const originalConnectedCallback = Cstr.prototype.connectedCallback;
    const originalDisconnectedCallback = Cstr.prototype.disconnectedCallback;
    Object.assign(Cstr.prototype, {
        __registerHost () {
            $8cd96f0f3be295d3$export$c20b986001efcf6c(this, cmpMeta);
        },
        connectedCallback () {
            $8cd96f0f3be295d3$export$de367db4d6dadc9f(this);
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).connectedCallback && originalConnectedCallback) originalConnectedCallback.call(this);
        },
        disconnectedCallback () {
            $8cd96f0f3be295d3$export$6cf1a3dd300e0a4f(this);
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).disconnectedCallback && originalDisconnectedCallback) originalDisconnectedCallback.call(this);
        },
        __attachShadow () {
            if ($8cd96f0f3be295d3$export$b4e7e6d61dbcd813) {
                if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDelegatesFocus) this.attachShadow({
                    mode: "open",
                    delegatesFocus: !!(cmpMeta.$flags$ & 16 /* CMP_FLAGS.shadowDelegatesFocus */ )
                });
                else this.attachShadow({
                    mode: "open"
                });
            } else this.shadowRoot = this;
        }
    });
    Cstr.is = cmpMeta.$tagName$;
    return $8cd96f0f3be295d3$export$982064ca8d9ad69(Cstr, cmpMeta, 3 /* PROXY_FLAGS.proxyState */ );
};
const $8cd96f0f3be295d3$export$d156c3c6ac0fffa3 = (elm)=>{
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).style && (0, $6c97b4542f89f042$export$455dbfd86f20b704).mode && !(0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad) {
        const mode = $8cd96f0f3be295d3$var$computeMode(elm);
        const hostRef = $8cd96f0f3be295d3$export$3f84770eccf215d2(elm);
        if (hostRef.$modeName$ !== mode) {
            const cmpMeta = hostRef.$cmpMeta$;
            const oldScopeId = elm["s-sc"];
            const scopeId = $8cd96f0f3be295d3$var$getScopeId(cmpMeta, mode);
            const style = elm.constructor.style[mode];
            const flags = cmpMeta.$flags$;
            if (style) {
                if (!$8cd96f0f3be295d3$export$9dd6ff9ea0189349.has(scopeId)) $8cd96f0f3be295d3$var$registerStyle(scopeId, style, !!(flags & 1 /* CMP_FLAGS.shadowDomEncapsulation */ ));
                hostRef.$modeName$ = mode;
                elm.classList.remove(oldScopeId + "-h", oldScopeId + "-s");
                $8cd96f0f3be295d3$var$attachStyles(hostRef);
                $8cd96f0f3be295d3$export$98c7f8edae68c30f(elm);
            }
        }
    }
};
const $8cd96f0f3be295d3$var$patchCloneNode = (HostElementPrototype)=>{
    const orgCloneNode = HostElementPrototype.cloneNode;
    HostElementPrototype.cloneNode = function(deep) {
        const srcNode = this;
        const isShadowDom = (0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDom ? srcNode.shadowRoot && $8cd96f0f3be295d3$export$b4e7e6d61dbcd813 : false;
        const clonedNode = orgCloneNode.call(srcNode, isShadowDom ? deep : false);
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).slot && !isShadowDom && deep) {
            let i = 0;
            let slotted, nonStencilNode;
            const stencilPrivates = [
                "s-id",
                "s-cr",
                "s-lr",
                "s-rc",
                "s-sc",
                "s-p",
                "s-cn",
                "s-sr",
                "s-sn",
                "s-hn",
                "s-ol",
                "s-nr",
                "s-si"
            ];
            for(; i < srcNode.childNodes.length; i++){
                slotted = srcNode.childNodes[i]["s-nr"];
                nonStencilNode = stencilPrivates.every((privateField)=>!srcNode.childNodes[i][privateField]);
                if (slotted) {
                    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).appendChildSlotFix && clonedNode.__appendChild) clonedNode.__appendChild(slotted.cloneNode(true));
                    else clonedNode.appendChild(slotted.cloneNode(true));
                }
                if (nonStencilNode) clonedNode.appendChild(srcNode.childNodes[i].cloneNode(true));
            }
        }
        return clonedNode;
    };
};
const $8cd96f0f3be295d3$var$patchSlotAppendChild = (HostElementPrototype)=>{
    HostElementPrototype.__appendChild = HostElementPrototype.appendChild;
    HostElementPrototype.appendChild = function(newChild) {
        const slotName = newChild["s-sn"] = $8cd96f0f3be295d3$var$getSlotName(newChild);
        const slotNode = $8cd96f0f3be295d3$var$getHostSlotNode(this.childNodes, slotName);
        if (slotNode) {
            const slotChildNodes = $8cd96f0f3be295d3$var$getHostSlotChildNodes(slotNode, slotName);
            const appendAfter = slotChildNodes[slotChildNodes.length - 1];
            return appendAfter.parentNode.insertBefore(newChild, appendAfter.nextSibling);
        }
        return this.__appendChild(newChild);
    };
};
/**
 * Patches the text content of an unnamed slotted node inside a scoped component
 * @param hostElementPrototype the `Element` to be patched
 * @param cmpMeta component runtime metadata used to determine if the component should be patched or not
 */ const $8cd96f0f3be295d3$var$patchTextContent = (hostElementPrototype, cmpMeta)=>{
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).scoped && cmpMeta.$flags$ & 2 /* CMP_FLAGS.scopedCssEncapsulation */ ) {
        const descriptor = Object.getOwnPropertyDescriptor(Node.prototype, "textContent");
        Object.defineProperty(hostElementPrototype, "__textContent", descriptor);
        Object.defineProperty(hostElementPrototype, "textContent", {
            get () {
                var _a;
                // get the 'default slot', which would be the first slot in a shadow tree (if we were using one), whose name is
                // the empty string
                const slotNode = $8cd96f0f3be295d3$var$getHostSlotNode(this.childNodes, "");
                // when a slot node is found, the textContent _may_ be found in the next sibling (text) node, depending on how
                // nodes were reordered during the vdom render. first try to get the text content from the sibling.
                if (((_a = slotNode === null || slotNode === void 0 ? void 0 : slotNode.nextSibling) === null || _a === void 0 ? void 0 : _a.nodeType) === 3 /* NODE_TYPES.TEXT_NODE */ ) return slotNode.nextSibling.textContent;
                else if (slotNode) return slotNode.textContent;
                else // fallback to the original implementation
                return this.__textContent;
            },
            set (value) {
                var _a;
                // get the 'default slot', which would be the first slot in a shadow tree (if we were using one), whose name is
                // the empty string
                const slotNode = $8cd96f0f3be295d3$var$getHostSlotNode(this.childNodes, "");
                // when a slot node is found, the textContent _may_ need to be placed in the next sibling (text) node,
                // depending on how nodes were reordered during the vdom render. first try to set the text content on the
                // sibling.
                if (((_a = slotNode === null || slotNode === void 0 ? void 0 : slotNode.nextSibling) === null || _a === void 0 ? void 0 : _a.nodeType) === 3 /* NODE_TYPES.TEXT_NODE */ ) slotNode.nextSibling.textContent = value;
                else if (slotNode) slotNode.textContent = value;
                else {
                    // we couldn't find a slot, but that doesn't mean that there isn't one. if this check ran before the DOM
                    // loaded, we could have missed it. check for a content reference element on the scoped component and insert
                    // it there
                    this.__textContent = value;
                    const contentRefElm = this["s-cr"];
                    if (contentRefElm) this.insertBefore(contentRefElm, this.firstChild);
                }
            }
        });
    }
};
const $8cd96f0f3be295d3$var$patchChildSlotNodes = (elm, cmpMeta)=>{
    class FakeNodeList extends Array {
        item(n) {
            return this[n];
        }
    }
    if (cmpMeta.$flags$ & 8 /* CMP_FLAGS.needsShadowDomShim */ ) {
        const childNodesFn = elm.__lookupGetter__("childNodes");
        Object.defineProperty(elm, "children", {
            get () {
                return this.childNodes.map((n)=>n.nodeType === 1);
            }
        });
        Object.defineProperty(elm, "childElementCount", {
            get () {
                return elm.children.length;
            }
        });
        Object.defineProperty(elm, "childNodes", {
            get () {
                const childNodes = childNodesFn.call(this);
                if (($8cd96f0f3be295d3$export$2e40610e9d23bca6.$flags$ & 1 /* PLATFORM_FLAGS.isTmpDisconnected */ ) === 0 && $8cd96f0f3be295d3$export$3f84770eccf215d2(this).$flags$ & 2 /* HOST_FLAGS.hasRendered */ ) {
                    const result = new FakeNodeList();
                    for(let i = 0; i < childNodes.length; i++){
                        const slot = childNodes[i]["s-nr"];
                        if (slot) result.push(slot);
                    }
                    return result;
                }
                return FakeNodeList.from(childNodes);
            }
        });
    }
};
const $8cd96f0f3be295d3$var$getSlotName = (node)=>node["s-sn"] || node.nodeType === 1 && node.getAttribute("slot") || "";
/**
 * Recursively searches a series of child nodes for a slot with the provided name.
 * @param childNodes the nodes to search for a slot with a specific name.
 * @param slotName the name of the slot to match on.
 * @returns a reference to the slot node that matches the provided name, `null` otherwise
 */ const $8cd96f0f3be295d3$var$getHostSlotNode = (childNodes, slotName)=>{
    let i = 0;
    let childNode;
    for(; i < childNodes.length; i++){
        childNode = childNodes[i];
        if (childNode["s-sr"] && childNode["s-sn"] === slotName) return childNode;
        childNode = $8cd96f0f3be295d3$var$getHostSlotNode(childNode.childNodes, slotName);
        if (childNode) return childNode;
    }
    return null;
};
const $8cd96f0f3be295d3$var$getHostSlotChildNodes = (n, slotName)=>{
    const childNodes = [
        n
    ];
    while((n = n.nextSibling) && n["s-sn"] === slotName)childNodes.push(n);
    return childNodes;
};
const $8cd96f0f3be295d3$var$hmrStart = (elm, cmpMeta, hmrVersionId)=>{
    // ¯\_(ツ)_/¯
    const hostRef = $8cd96f0f3be295d3$export$3f84770eccf215d2(elm);
    // reset state flags to only have been connected
    hostRef.$flags$ = 1 /* HOST_FLAGS.hasConnected */ ;
    // TODO
    // detatch any event listeners that may have been added
    // because we're not passing an exact event name it'll
    // remove all of this element's event, which is good
    // create a callback for when this component finishes hmr
    elm["s-hmr-load"] = ()=>{
        // finished hmr for this element
        delete elm["s-hmr-load"];
    };
    // re-initialize the component
    $8cd96f0f3be295d3$var$initializeComponent(elm, hostRef, cmpMeta, hmrVersionId);
};
const $8cd96f0f3be295d3$export$12ca34fb6e539801 = (lazyBundles, options = {})=>{
    var _a;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).profile && performance.mark) performance.mark("st:app:start");
    $8cd96f0f3be295d3$var$installDevTools();
    const endBootstrap = $8cd96f0f3be295d3$var$createTime("bootstrapLazy");
    const cmpTags = [];
    const exclude = options.exclude || [];
    const customElements1 = $8cd96f0f3be295d3$export$10a0f131c0eea21b.customElements;
    const head = $8cd96f0f3be295d3$export$2a111da947c407d2.head;
    const metaCharset = /*@__PURE__*/ head.querySelector("meta[charset]");
    const visibilityStyle = /*@__PURE__*/ $8cd96f0f3be295d3$export$2a111da947c407d2.createElement("style");
    const deferredConnectedCallbacks = [];
    const styles = /*@__PURE__*/ $8cd96f0f3be295d3$export$2a111da947c407d2.querySelectorAll(`[${$8cd96f0f3be295d3$var$HYDRATED_STYLE_ID}]`);
    let appLoadFallback;
    let isBootstrapping = true;
    let i = 0;
    Object.assign($8cd96f0f3be295d3$export$2e40610e9d23bca6, options);
    $8cd96f0f3be295d3$export$2e40610e9d23bca6.$resourcesUrl$ = new URL(options.resourcesUrl || "./", $8cd96f0f3be295d3$export$2a111da947c407d2.baseURI).href;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).asyncQueue) {
        if (options.syncQueue) $8cd96f0f3be295d3$export$2e40610e9d23bca6.$flags$ |= 4 /* PLATFORM_FLAGS.queueSync */ ;
    }
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateClientSide) // If the app is already hydrated there is not point to disable the
    // async queue. This will improve the first input delay
    $8cd96f0f3be295d3$export$2e40610e9d23bca6.$flags$ |= 2 /* PLATFORM_FLAGS.appLoaded */ ;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateClientSide && (0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDom) for(; i < styles.length; i++)$8cd96f0f3be295d3$var$registerStyle(styles[i].getAttribute($8cd96f0f3be295d3$var$HYDRATED_STYLE_ID), $8cd96f0f3be295d3$var$convertScopedToShadow(styles[i].innerHTML), true);
    lazyBundles.map((lazyBundle)=>{
        lazyBundle[1].map((compactMeta)=>{
            const cmpMeta = {
                $flags$: compactMeta[0],
                $tagName$: compactMeta[1],
                $members$: compactMeta[2],
                $listeners$: compactMeta[3]
            };
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).member) cmpMeta.$members$ = compactMeta[2];
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hostListener) cmpMeta.$listeners$ = compactMeta[3];
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).reflect) cmpMeta.$attrsToReflect$ = [];
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).watchCallback) cmpMeta.$watchers$ = {};
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDom && !$8cd96f0f3be295d3$export$b4e7e6d61dbcd813 && cmpMeta.$flags$ & 1 /* CMP_FLAGS.shadowDomEncapsulation */ ) cmpMeta.$flags$ |= 8 /* CMP_FLAGS.needsShadowDomShim */ ;
            const tagName = (0, $6c97b4542f89f042$export$455dbfd86f20b704).transformTagName && options.transformTagName ? options.transformTagName(cmpMeta.$tagName$) : cmpMeta.$tagName$;
            const HostElement = class extends HTMLElement {
                // StencilLazyHost
                constructor(self){
                    // @ts-ignore
                    super(self);
                    self = this;
                    $8cd96f0f3be295d3$export$c20b986001efcf6c(self, cmpMeta);
                    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDom && cmpMeta.$flags$ & 1 /* CMP_FLAGS.shadowDomEncapsulation */ ) {
                        // this component is using shadow dom
                        // and this browser supports shadow dom
                        // add the read-only property "shadowRoot" to the host element
                        // adding the shadow root build conditionals to minimize runtime
                        if ($8cd96f0f3be295d3$export$b4e7e6d61dbcd813) {
                            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDelegatesFocus) self.attachShadow({
                                mode: "open",
                                delegatesFocus: !!(cmpMeta.$flags$ & 16 /* CMP_FLAGS.shadowDelegatesFocus */ )
                            });
                            else self.attachShadow({
                                mode: "open"
                            });
                        } else if (!(0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateServerSide && !("shadowRoot" in self)) self.shadowRoot = self;
                    }
                    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).slotChildNodesFix) $8cd96f0f3be295d3$var$patchChildSlotNodes(self, cmpMeta);
                }
                connectedCallback() {
                    if (appLoadFallback) {
                        clearTimeout(appLoadFallback);
                        appLoadFallback = null;
                    }
                    if (isBootstrapping) // connectedCallback will be processed once all components have been registered
                    deferredConnectedCallbacks.push(this);
                    else $8cd96f0f3be295d3$export$2e40610e9d23bca6.jmp(()=>$8cd96f0f3be295d3$export$de367db4d6dadc9f(this));
                }
                disconnectedCallback() {
                    $8cd96f0f3be295d3$export$2e40610e9d23bca6.jmp(()=>$8cd96f0f3be295d3$export$6cf1a3dd300e0a4f(this));
                }
                componentOnReady() {
                    return $8cd96f0f3be295d3$export$3f84770eccf215d2(this).$onReadyPromise$;
                }
            };
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).cloneNodeFix) $8cd96f0f3be295d3$var$patchCloneNode(HostElement.prototype);
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).appendChildSlotFix) $8cd96f0f3be295d3$var$patchSlotAppendChild(HostElement.prototype);
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hotModuleReplacement) HostElement.prototype["s-hmr"] = function(hmrVersionId) {
                $8cd96f0f3be295d3$var$hmrStart(this, cmpMeta, hmrVersionId);
            };
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).scopedSlotTextContentFix) $8cd96f0f3be295d3$var$patchTextContent(HostElement.prototype, cmpMeta);
            cmpMeta.$lazyBundleId$ = lazyBundle[0];
            if (!exclude.includes(tagName) && !customElements1.get(tagName)) {
                cmpTags.push(tagName);
                customElements1.define(tagName, $8cd96f0f3be295d3$export$982064ca8d9ad69(HostElement, cmpMeta, 1 /* PROXY_FLAGS.isElementConstructor */ ));
            }
        });
    });
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).invisiblePrehydration && ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hydratedClass || (0, $6c97b4542f89f042$export$455dbfd86f20b704).hydratedAttribute)) {
        visibilityStyle.innerHTML = cmpTags + $8cd96f0f3be295d3$var$HYDRATED_CSS;
        visibilityStyle.setAttribute("data-styles", "");
        // Apply CSP nonce to the style tag if it exists
        const nonce = (_a = $8cd96f0f3be295d3$export$2e40610e9d23bca6.$nonce$) !== null && _a !== void 0 ? _a : $8cd96f0f3be295d3$var$queryNonceMetaTagContent($8cd96f0f3be295d3$export$2a111da947c407d2);
        if (nonce != null) visibilityStyle.setAttribute("nonce", nonce);
        head.insertBefore(visibilityStyle, metaCharset ? metaCharset.nextSibling : head.firstChild);
    }
    // Process deferred connectedCallbacks now all components have been registered
    isBootstrapping = false;
    if (deferredConnectedCallbacks.length) deferredConnectedCallbacks.map((host)=>host.connectedCallback());
    else if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).profile) $8cd96f0f3be295d3$export$2e40610e9d23bca6.jmp(()=>appLoadFallback = setTimeout($8cd96f0f3be295d3$var$appDidLoad, 30, "timeout"));
    else $8cd96f0f3be295d3$export$2e40610e9d23bca6.jmp(()=>appLoadFallback = setTimeout($8cd96f0f3be295d3$var$appDidLoad, 30));
    // Fallback appLoad event
    endBootstrap();
};
const $8cd96f0f3be295d3$export$3a4668f195d4bdaf = (_ref, tagName)=>{
    const componentOnReady = ()=>{
        let elm = $8cd96f0f3be295d3$export$2a111da947c407d2.querySelector(tagName);
        if (!elm) {
            elm = $8cd96f0f3be295d3$export$2a111da947c407d2.createElement(tagName);
            $8cd96f0f3be295d3$export$2a111da947c407d2.body.appendChild(elm);
        }
        return typeof elm.componentOnReady === "function" ? elm.componentOnReady() : Promise.resolve(elm);
    };
    const create = (...args)=>{
        return componentOnReady().then((el)=>el.create(...args));
    };
    return {
        create: create,
        componentOnReady: componentOnReady
    };
};
const $8cd96f0f3be295d3$export$31553aaa555c1514 = (_elm, context)=>{
    if (context in $8cd96f0f3be295d3$export$841858b892ce1f4c) return $8cd96f0f3be295d3$export$841858b892ce1f4c[context];
    else if (context === "window") return $8cd96f0f3be295d3$export$10a0f131c0eea21b;
    else if (context === "document") return $8cd96f0f3be295d3$export$2a111da947c407d2;
    else if (context === "isServer" || context === "isPrerender") return (0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateServerSide ? true : false;
    else if (context === "isClient") return (0, $6c97b4542f89f042$export$455dbfd86f20b704).hydrateServerSide ? false : true;
    else if (context === "resourcesUrl" || context === "publicPath") return $8cd96f0f3be295d3$export$7c3997b47f2311d9(".");
    else if (context === "queue") return {
        write: $8cd96f0f3be295d3$export$bbfc1321f142f72c,
        read: $8cd96f0f3be295d3$export$de6bea324e6d63f6,
        tick: {
            then (cb) {
                return $8cd96f0f3be295d3$export$bdd553fddd433dcb(cb);
            }
        }
    };
    return undefined;
};
const $8cd96f0f3be295d3$export$ffb0004e005737fa = (_, children)=>children;
const $8cd96f0f3be295d3$export$62df7fa1a32c483 = (elm, hostRef, listeners, attachParentListeners)=>{
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hostListener && listeners) {
        // this is called immediately within the element's constructor
        // initialize our event listeners on the host element
        // we do this now so that we can listen to events that may
        // have fired even before the instance is ready
        if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hostListenerTargetParent) {
            // this component may have event listeners that should be attached to the parent
            if (attachParentListeners) // this is being ran from within the connectedCallback
            // which is important so that we know the host element actually has a parent element
            // filter out the listeners to only have the ones that ARE being attached to the parent
            listeners = listeners.filter(([flags])=>flags & 32 /* LISTENER_FLAGS.TargetParent */ );
            else // this is being ran from within the component constructor
            // everything BUT the parent element listeners should be attached at this time
            // filter out the listeners that are NOT being attached to the parent
            listeners = listeners.filter(([flags])=>!(flags & 32 /* LISTENER_FLAGS.TargetParent */ ));
        }
        listeners.map(([flags, name, method])=>{
            const target = (0, $6c97b4542f89f042$export$455dbfd86f20b704).hostListenerTarget ? $8cd96f0f3be295d3$var$getHostListenerTarget(elm, flags) : elm;
            const handler = $8cd96f0f3be295d3$var$hostListenerProxy(hostRef, method);
            const opts = $8cd96f0f3be295d3$var$hostListenerOpts(flags);
            $8cd96f0f3be295d3$export$2e40610e9d23bca6.ael(target, name, handler, opts);
            (hostRef.$rmListeners$ = hostRef.$rmListeners$ || []).push(()=>$8cd96f0f3be295d3$export$2e40610e9d23bca6.rel(target, name, handler, opts));
        });
    }
};
const $8cd96f0f3be295d3$var$hostListenerProxy = (hostRef, methodName)=>(ev)=>{
        try {
            if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad) {
                if (hostRef.$flags$ & 256 /* HOST_FLAGS.isListenReady */ ) // instance is ready, let's call it's member method for this event
                hostRef.$lazyInstance$[methodName](ev);
                else (hostRef.$queuedListeners$ = hostRef.$queuedListeners$ || []).push([
                    methodName,
                    ev
                ]);
            } else hostRef.$hostElement$[methodName](ev);
        } catch (e) {
            $8cd96f0f3be295d3$export$bf36f23bad3e1069(e);
        }
    };
const $8cd96f0f3be295d3$var$getHostListenerTarget = (elm, flags)=>{
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hostListenerTargetDocument && flags & 4 /* LISTENER_FLAGS.TargetDocument */ ) return $8cd96f0f3be295d3$export$2a111da947c407d2;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hostListenerTargetWindow && flags & 8 /* LISTENER_FLAGS.TargetWindow */ ) return $8cd96f0f3be295d3$export$10a0f131c0eea21b;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hostListenerTargetBody && flags & 16 /* LISTENER_FLAGS.TargetBody */ ) return $8cd96f0f3be295d3$export$2a111da947c407d2.body;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).hostListenerTargetParent && flags & 32 /* LISTENER_FLAGS.TargetParent */ ) return elm.parentElement;
    return elm;
};
// prettier-ignore
const $8cd96f0f3be295d3$var$hostListenerOpts = (flags)=>$8cd96f0f3be295d3$export$b4b667f9f62821eb ? {
        passive: (flags & 1 /* LISTENER_FLAGS.Passive */ ) !== 0,
        capture: (flags & 2 /* LISTENER_FLAGS.Capture */ ) !== 0
    } : (flags & 2 /* LISTENER_FLAGS.Capture */ ) !== 0;
/**
 * Assigns the given value to the nonce property on the runtime platform object.
 * During runtime, this value is used to set the nonce attribute on all dynamically created script and style tags.
 * @param nonce The value to be assigned to the platform nonce property.
 * @returns void
 */ const $8cd96f0f3be295d3$export$c5f670b24c0ae95a = (nonce)=>$8cd96f0f3be295d3$export$2e40610e9d23bca6.$nonce$ = nonce;
const $8cd96f0f3be295d3$export$ac8bf6eebf15d3df = (opts)=>Object.assign($8cd96f0f3be295d3$export$2e40610e9d23bca6, opts);
const $8cd96f0f3be295d3$export$fd226bebc5efbbed = (doc, staticComponents)=>{
    if (doc != null) {
        const docData = {
            hostIds: 0,
            rootLevelIds: 0,
            staticComponents: new Set(staticComponents)
        };
        const orgLocationNodes = [];
        $8cd96f0f3be295d3$var$parseVNodeAnnotations(doc, doc.body, docData, orgLocationNodes);
        orgLocationNodes.forEach((orgLocationNode)=>{
            if (orgLocationNode != null) {
                const nodeRef = orgLocationNode["s-nr"];
                let hostId = nodeRef["s-host-id"];
                let nodeId = nodeRef["s-node-id"];
                let childId = `${hostId}.${nodeId}`;
                if (hostId == null) {
                    hostId = 0;
                    docData.rootLevelIds++;
                    nodeId = docData.rootLevelIds;
                    childId = `${hostId}.${nodeId}`;
                    if (nodeRef.nodeType === 1 /* NODE_TYPE.ElementNode */ ) nodeRef.setAttribute($8cd96f0f3be295d3$var$HYDRATE_CHILD_ID, childId);
                    else if (nodeRef.nodeType === 3 /* NODE_TYPE.TextNode */ ) {
                        if (hostId === 0) {
                            const textContent = nodeRef.nodeValue.trim();
                            if (textContent === "") {
                                // useless whitespace node at the document root
                                orgLocationNode.remove();
                                return;
                            }
                        }
                        const commentBeforeTextNode = doc.createComment(childId);
                        commentBeforeTextNode.nodeValue = `${$8cd96f0f3be295d3$var$TEXT_NODE_ID}.${childId}`;
                        nodeRef.parentNode.insertBefore(commentBeforeTextNode, nodeRef);
                    }
                }
                let orgLocationNodeId = `${$8cd96f0f3be295d3$var$ORG_LOCATION_ID}.${childId}`;
                const orgLocationParentNode = orgLocationNode.parentElement;
                if (orgLocationParentNode) {
                    if (orgLocationParentNode["s-en"] === "") // ending with a "." means that the parent element
                    // of this node's original location is a SHADOW dom element
                    // and this node is apart of the root level light dom
                    orgLocationNodeId += `.`;
                    else if (orgLocationParentNode["s-en"] === "c") // ending with a ".c" means that the parent element
                    // of this node's original location is a SCOPED element
                    // and this node is apart of the root level light dom
                    orgLocationNodeId += `.c`;
                }
                orgLocationNode.nodeValue = orgLocationNodeId;
            }
        });
    }
};
const $8cd96f0f3be295d3$var$parseVNodeAnnotations = (doc, node, docData, orgLocationNodes)=>{
    if (node == null) return;
    if (node["s-nr"] != null) orgLocationNodes.push(node);
    if (node.nodeType === 1 /* NODE_TYPE.ElementNode */ ) node.childNodes.forEach((childNode)=>{
        const hostRef = $8cd96f0f3be295d3$export$3f84770eccf215d2(childNode);
        if (hostRef != null && !docData.staticComponents.has(childNode.nodeName.toLowerCase())) {
            const cmpData = {
                nodeIds: 0
            };
            $8cd96f0f3be295d3$var$insertVNodeAnnotations(doc, childNode, hostRef.$vnode$, docData, cmpData);
        }
        $8cd96f0f3be295d3$var$parseVNodeAnnotations(doc, childNode, docData, orgLocationNodes);
    });
};
const $8cd96f0f3be295d3$var$insertVNodeAnnotations = (doc, hostElm, vnode, docData, cmpData)=>{
    if (vnode != null) {
        const hostId = ++docData.hostIds;
        hostElm.setAttribute($8cd96f0f3be295d3$var$HYDRATE_ID, hostId);
        if (hostElm["s-cr"] != null) hostElm["s-cr"].nodeValue = `${$8cd96f0f3be295d3$var$CONTENT_REF_ID}.${hostId}`;
        if (vnode.$children$ != null) {
            const depth = 0;
            vnode.$children$.forEach((vnodeChild, index)=>{
                $8cd96f0f3be295d3$var$insertChildVNodeAnnotations(doc, vnodeChild, cmpData, hostId, depth, index);
            });
        }
        if (hostElm && vnode && vnode.$elm$ && !hostElm.hasAttribute("c-id")) {
            const parent = hostElm.parentElement;
            if (parent && parent.childNodes) {
                const parentChildNodes = Array.from(parent.childNodes);
                const comment = parentChildNodes.find((node)=>node.nodeType === 8 /* NODE_TYPE.CommentNode */  && node["s-sr"]);
                if (comment) {
                    const index = parentChildNodes.indexOf(hostElm) - 1;
                    vnode.$elm$.setAttribute($8cd96f0f3be295d3$var$HYDRATE_CHILD_ID, `${comment["s-host-id"]}.${comment["s-node-id"]}.0.${index}`);
                }
            }
        }
    }
};
const $8cd96f0f3be295d3$var$insertChildVNodeAnnotations = (doc, vnodeChild, cmpData, hostId, depth, index)=>{
    const childElm = vnodeChild.$elm$;
    if (childElm == null) return;
    const nodeId = cmpData.nodeIds++;
    const childId = `${hostId}.${nodeId}.${depth}.${index}`;
    childElm["s-host-id"] = hostId;
    childElm["s-node-id"] = nodeId;
    if (childElm.nodeType === 1 /* NODE_TYPE.ElementNode */ ) childElm.setAttribute($8cd96f0f3be295d3$var$HYDRATE_CHILD_ID, childId);
    else if (childElm.nodeType === 3 /* NODE_TYPE.TextNode */ ) {
        const parentNode = childElm.parentNode;
        const nodeName = parentNode.nodeName;
        if (nodeName !== "STYLE" && nodeName !== "SCRIPT") {
            const textNodeId = `${$8cd96f0f3be295d3$var$TEXT_NODE_ID}.${childId}`;
            const commentBeforeTextNode = doc.createComment(textNodeId);
            parentNode.insertBefore(commentBeforeTextNode, childElm);
        }
    } else if (childElm.nodeType === 8 /* NODE_TYPE.CommentNode */ ) {
        if (childElm["s-sr"]) {
            const slotName = childElm["s-sn"] || "";
            const slotNodeId = `${$8cd96f0f3be295d3$var$SLOT_NODE_ID}.${childId}.${slotName}`;
            childElm.nodeValue = slotNodeId;
        }
    }
    if (vnodeChild.$children$ != null) {
        const childDepth = depth + 1;
        vnodeChild.$children$.forEach((vnode, index)=>{
            $8cd96f0f3be295d3$var$insertChildVNodeAnnotations(doc, vnode, cmpData, hostId, childDepth, index);
        });
    }
};
const $8cd96f0f3be295d3$var$hostRefs = /*@__PURE__*/ new WeakMap();
const $8cd96f0f3be295d3$export$3f84770eccf215d2 = (ref)=>$8cd96f0f3be295d3$var$hostRefs.get(ref);
const $8cd96f0f3be295d3$export$ea4bcaef8454fd24 = (lazyInstance, hostRef)=>$8cd96f0f3be295d3$var$hostRefs.set(hostRef.$lazyInstance$ = lazyInstance, hostRef);
const $8cd96f0f3be295d3$export$c20b986001efcf6c = (elm, cmpMeta)=>{
    const hostRef = {
        $flags$: 0,
        $hostElement$: elm,
        $cmpMeta$: cmpMeta,
        $instanceValues$: new Map()
    };
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev) hostRef.$renderCount$ = 0;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).method && (0, $6c97b4542f89f042$export$455dbfd86f20b704).lazyLoad) hostRef.$onInstancePromise$ = new Promise((r)=>hostRef.$onInstanceResolve$ = r);
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).asyncLoading) {
        hostRef.$onReadyPromise$ = new Promise((r)=>hostRef.$onReadyResolve$ = r);
        elm["s-p"] = [];
        elm["s-rc"] = [];
    }
    $8cd96f0f3be295d3$export$62df7fa1a32c483(elm, hostRef, cmpMeta.$listeners$, false);
    return $8cd96f0f3be295d3$var$hostRefs.set(elm, hostRef);
};
const $8cd96f0f3be295d3$export$304efeaa4c96d4e9 = (elm, memberName)=>memberName in elm;
const $8cd96f0f3be295d3$export$bf36f23bad3e1069 = (e, el)=>($8cd96f0f3be295d3$var$customError || console.error)(e, el);
const $8cd96f0f3be295d3$export$262a85bf225b2794 = (0, $6c97b4542f89f042$export$455dbfd86f20b704).isTesting ? [
    "STENCIL:"
] // E2E testing
 : [
    "%cstencil",
    "color: white;background:#4c47ff;font-weight: bold; font-size:10px; padding:2px 6px; border-radius: 5px"
];
const $8cd96f0f3be295d3$export$47b52a6e53fbbc24 = (...m)=>console.error(...$8cd96f0f3be295d3$export$262a85bf225b2794, ...m);
const $8cd96f0f3be295d3$export$5d385f3b3df7e1b9 = (...m)=>console.warn(...$8cd96f0f3be295d3$export$262a85bf225b2794, ...m);
const $8cd96f0f3be295d3$export$f71f4f192932e35e = (...m)=>console.info(...$8cd96f0f3be295d3$export$262a85bf225b2794, ...m);
const $8cd96f0f3be295d3$export$56c340fcfa13d1a2 = (handler)=>$8cd96f0f3be295d3$var$customError = handler;
const $8cd96f0f3be295d3$export$a8b3e6b062e6642a = /*@__PURE__*/ new Map();
const $8cd96f0f3be295d3$export$ebb47fdc8f2dbc6f = (cmpMeta, hostRef, hmrVersionId)=>{
    // loadModuleImport
    const exportName = cmpMeta.$tagName$.replace(/-/g, "_");
    const bundleId = cmpMeta.$lazyBundleId$;
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).isDev && typeof bundleId !== "string") {
        $8cd96f0f3be295d3$export$47b52a6e53fbbc24(`Trying to lazily load component <${cmpMeta.$tagName$}> with style mode "${hostRef.$modeName$}", but it does not exist.`);
        return undefined;
    }
    const module = !(0, $6c97b4542f89f042$export$455dbfd86f20b704).hotModuleReplacement ? $8cd96f0f3be295d3$export$a8b3e6b062e6642a.get(bundleId) : false;
    if (module) return module[exportName];
    /*!__STENCIL_STATIC_IMPORT_SWITCH__*/ return import(/* @vite-ignore */ /* webpackInclude: /\.entry\.js$/ */ /* webpackExclude: /\.system\.entry\.js$/ */ /* webpackMode: "lazy" */ `./${bundleId}.entry.js${(0, $6c97b4542f89f042$export$455dbfd86f20b704).hotModuleReplacement && hmrVersionId ? "?s-hmr=" + hmrVersionId : ""}`).then((importedModule)=>{
        if (!(0, $6c97b4542f89f042$export$455dbfd86f20b704).hotModuleReplacement) $8cd96f0f3be295d3$export$a8b3e6b062e6642a.set(bundleId, importedModule);
        return importedModule[exportName];
    }, $8cd96f0f3be295d3$export$bf36f23bad3e1069);
};
const $8cd96f0f3be295d3$export$9dd6ff9ea0189349 = /*@__PURE__*/ new Map();
const $8cd96f0f3be295d3$export$31c64a1f6cd0f6 = [];
const $8cd96f0f3be295d3$export$10a0f131c0eea21b = typeof window !== "undefined" ? window : {};
const $8cd96f0f3be295d3$export$c4ffa16951855e28 = (0, $6c97b4542f89f042$export$455dbfd86f20b704).cssVarShim ? $8cd96f0f3be295d3$export$10a0f131c0eea21b.CSS : null;
const $8cd96f0f3be295d3$export$2a111da947c407d2 = $8cd96f0f3be295d3$export$10a0f131c0eea21b.document || {
    head: {}
};
const $8cd96f0f3be295d3$export$7f8ddf7c7c20b3cd = $8cd96f0f3be295d3$export$10a0f131c0eea21b.HTMLElement || class {
};
const $8cd96f0f3be295d3$export$2e40610e9d23bca6 = {
    $flags$: 0,
    $resourcesUrl$: "",
    jmp: (h)=>h(),
    raf: (h)=>requestAnimationFrame(h),
    ael: (el, eventName, listener, opts)=>el.addEventListener(eventName, listener, opts),
    rel: (el, eventName, listener, opts)=>el.removeEventListener(eventName, listener, opts),
    ce: (eventName, opts)=>new CustomEvent(eventName, opts)
};
const $8cd96f0f3be295d3$export$a8ba718ef458346 = (helpers)=>{
    Object.assign($8cd96f0f3be295d3$export$2e40610e9d23bca6, helpers);
};
const $8cd96f0f3be295d3$export$b4e7e6d61dbcd813 = (0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDomShim && (0, $6c97b4542f89f042$export$455dbfd86f20b704).shadowDom ? /*@__PURE__*/ (()=>($8cd96f0f3be295d3$export$2a111da947c407d2.head.attachShadow + "").indexOf("[native") > -1)() : true;
const $8cd96f0f3be295d3$export$b4b667f9f62821eb = /*@__PURE__*/ (()=>{
    let supportsListenerOptions = false;
    try {
        $8cd96f0f3be295d3$export$2a111da947c407d2.addEventListener("e", null, Object.defineProperty({}, "passive", {
            get () {
                supportsListenerOptions = true;
            }
        }));
    } catch (e) {}
    return supportsListenerOptions;
})();
const $8cd96f0f3be295d3$export$2578fbb2d34e3823 = (v)=>Promise.resolve(v);
const $8cd96f0f3be295d3$export$27b311cd1cb97100 = (0, $6c97b4542f89f042$export$455dbfd86f20b704).constructableCSS ? /*@__PURE__*/ (()=>{
    try {
        new CSSStyleSheet();
        return typeof new CSSStyleSheet().replaceSync === "function";
    } catch (e) {}
    return false;
})() : false;
const $8cd96f0f3be295d3$var$queueDomReads = [];
const $8cd96f0f3be295d3$var$queueDomWrites = [];
const $8cd96f0f3be295d3$var$queueDomWritesLow = [];
const $8cd96f0f3be295d3$var$queueTask = (queue, write)=>(cb)=>{
        queue.push(cb);
        if (!$8cd96f0f3be295d3$var$queuePending) {
            $8cd96f0f3be295d3$var$queuePending = true;
            if (write && $8cd96f0f3be295d3$export$2e40610e9d23bca6.$flags$ & 4 /* PLATFORM_FLAGS.queueSync */ ) $8cd96f0f3be295d3$export$bdd553fddd433dcb($8cd96f0f3be295d3$var$flush);
            else $8cd96f0f3be295d3$export$2e40610e9d23bca6.raf($8cd96f0f3be295d3$var$flush);
        }
    };
const $8cd96f0f3be295d3$var$consume = (queue)=>{
    for(let i = 0; i < queue.length; i++)try {
        queue[i](performance.now());
    } catch (e) {
        $8cd96f0f3be295d3$export$bf36f23bad3e1069(e);
    }
    queue.length = 0;
};
const $8cd96f0f3be295d3$var$consumeTimeout = (queue, timeout)=>{
    let i = 0;
    let ts = 0;
    while(i < queue.length && (ts = performance.now()) < timeout)try {
        queue[i++](ts);
    } catch (e) {
        $8cd96f0f3be295d3$export$bf36f23bad3e1069(e);
    }
    if (i === queue.length) queue.length = 0;
    else if (i !== 0) queue.splice(0, i);
};
const $8cd96f0f3be295d3$var$flush = ()=>{
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).asyncQueue) $8cd96f0f3be295d3$var$queueCongestion++;
    // always force a bunch of medium callbacks to run, but still have
    // a throttle on how many can run in a certain time
    // DOM READS!!!
    $8cd96f0f3be295d3$var$consume($8cd96f0f3be295d3$var$queueDomReads);
    // DOM WRITES!!!
    if ((0, $6c97b4542f89f042$export$455dbfd86f20b704).asyncQueue) {
        const timeout = ($8cd96f0f3be295d3$export$2e40610e9d23bca6.$flags$ & 6 /* PLATFORM_FLAGS.queueMask */ ) === 2 /* PLATFORM_FLAGS.appLoaded */  ? performance.now() + 14 * Math.ceil($8cd96f0f3be295d3$var$queueCongestion * 0.1) : Infinity;
        $8cd96f0f3be295d3$var$consumeTimeout($8cd96f0f3be295d3$var$queueDomWrites, timeout);
        $8cd96f0f3be295d3$var$consumeTimeout($8cd96f0f3be295d3$var$queueDomWritesLow, timeout);
        if ($8cd96f0f3be295d3$var$queueDomWrites.length > 0) {
            $8cd96f0f3be295d3$var$queueDomWritesLow.push(...$8cd96f0f3be295d3$var$queueDomWrites);
            $8cd96f0f3be295d3$var$queueDomWrites.length = 0;
        }
        if ($8cd96f0f3be295d3$var$queuePending = $8cd96f0f3be295d3$var$queueDomReads.length + $8cd96f0f3be295d3$var$queueDomWrites.length + $8cd96f0f3be295d3$var$queueDomWritesLow.length > 0) // still more to do yet, but we've run out of time
        // let's let this thing cool off and try again in the next tick
        $8cd96f0f3be295d3$export$2e40610e9d23bca6.raf($8cd96f0f3be295d3$var$flush);
        else $8cd96f0f3be295d3$var$queueCongestion = 0;
    } else {
        $8cd96f0f3be295d3$var$consume($8cd96f0f3be295d3$var$queueDomWrites);
        if ($8cd96f0f3be295d3$var$queuePending = $8cd96f0f3be295d3$var$queueDomReads.length > 0) // still more to do yet, but we've run out of time
        // let's let this thing cool off and try again in the next tick
        $8cd96f0f3be295d3$export$2e40610e9d23bca6.raf($8cd96f0f3be295d3$var$flush);
    }
};
const $8cd96f0f3be295d3$export$bdd553fddd433dcb = /*@__PURE__*/ (cb)=>$8cd96f0f3be295d3$export$2578fbb2d34e3823().then(cb);
const $8cd96f0f3be295d3$export$de6bea324e6d63f6 = /*@__PURE__*/ $8cd96f0f3be295d3$var$queueTask($8cd96f0f3be295d3$var$queueDomReads, false);
const $8cd96f0f3be295d3$export$bbfc1321f142f72c = /*@__PURE__*/ $8cd96f0f3be295d3$var$queueTask($8cd96f0f3be295d3$var$queueDomWrites, true);


function $ed0966aa0f39122d$var$addDays(date, days) {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
}
function $ed0966aa0f39122d$var$getDaysOfMonth(date, padded, firstDayOfWeek) {
    const days = [];
    const firstOfMonth = $ed0966aa0f39122d$var$getFirstOfMonth(date);
    const firstDayMonth = firstOfMonth.getDay() === 0 ? 7 : firstOfMonth.getDay();
    const lastOfMonth = $ed0966aa0f39122d$var$getLastOfMonth(date);
    const lastDayOfMonth = lastOfMonth.getDay() === 0 ? 7 : lastOfMonth.getDay();
    const lastDayOfWeek = firstDayOfWeek === 1 ? 7 : firstDayOfWeek - 1;
    const leftPaddingDays = [];
    const rightPaddingDays = [];
    if (padded) {
        const leftPadding = (7 - firstDayOfWeek + firstDayMonth) % 7;
        let leftPaddingAmount = leftPadding;
        let leftPaddingDay = $ed0966aa0f39122d$var$getPreviousDay(firstOfMonth);
        while(leftPaddingAmount > 0){
            leftPaddingDays.push(leftPaddingDay);
            leftPaddingDay = $ed0966aa0f39122d$var$getPreviousDay(leftPaddingDay);
            leftPaddingAmount -= 1;
        }
        leftPaddingDays.reverse();
        const rightPadding = (7 - lastDayOfMonth + lastDayOfWeek) % 7;
        let rightPaddingAmount = rightPadding;
        let rightPaddingDay = $ed0966aa0f39122d$var$getNextDay(lastOfMonth);
        while(rightPaddingAmount > 0){
            rightPaddingDays.push(rightPaddingDay);
            rightPaddingDay = $ed0966aa0f39122d$var$getNextDay(rightPaddingDay);
            rightPaddingAmount -= 1;
        }
    }
    let currentDay = firstOfMonth;
    while(currentDay.getMonth() === date.getMonth()){
        days.push(currentDay);
        currentDay = $ed0966aa0f39122d$var$getNextDay(currentDay);
    }
    return [
        ...leftPaddingDays,
        ...days,
        ...rightPaddingDays
    ];
}
function $ed0966aa0f39122d$var$getFirstOfMonth(date) {
    const firstOfMonth = $ed0966aa0f39122d$var$removeTimezoneOffset(new Date(`${String($ed0966aa0f39122d$var$getYear(date)).padStart(4, "0")}-${String($ed0966aa0f39122d$var$getMonth(date)).padStart(2, "0")}-01`));
    return firstOfMonth;
}
function $ed0966aa0f39122d$var$getISODateString(date) {
    if (!(date instanceof Date)) return;
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}
function $ed0966aa0f39122d$var$getLastOfMonth(date) {
    const newDate = $ed0966aa0f39122d$var$getFirstOfMonth(date);
    newDate.setMonth(newDate.getMonth() + 1);
    newDate.setDate(newDate.getDate() - 1);
    return newDate;
}
function $ed0966aa0f39122d$var$getMonth(date) {
    return date.getMonth() + 1;
}
function $ed0966aa0f39122d$var$getMonths(locale) {
    return new Array(12).fill(undefined).map((_, month)=>{
        const date = $ed0966aa0f39122d$var$removeTimezoneOffset(new Date(`2006-${String(month + 1).padStart(2, "0")}-01`));
        return Intl.DateTimeFormat(locale, {
            month: "long"
        }).format(date);
    });
}
function $ed0966aa0f39122d$var$getNextDay(date) {
    return $ed0966aa0f39122d$var$addDays(date, 1);
}
function $ed0966aa0f39122d$var$getNextMonth(date) {
    const newDate = new Date(date);
    newDate.setDate(1);
    newDate.setMonth(newDate.getMonth() + 1);
    return newDate;
}
function $ed0966aa0f39122d$var$getNextYear(date) {
    const newDate = new Date(date);
    newDate.setFullYear(newDate.getFullYear() + 1);
    return newDate;
}
function $ed0966aa0f39122d$var$getPreviousDay(date) {
    return $ed0966aa0f39122d$var$subDays(date, 1);
}
function $ed0966aa0f39122d$var$getPreviousMonth(date) {
    const newDate = new Date(date);
    newDate.setDate(1);
    newDate.setMonth(newDate.getMonth() - 1);
    return newDate;
}
function $ed0966aa0f39122d$var$getPreviousYear(date) {
    const newDate = new Date(date);
    newDate.setFullYear(newDate.getFullYear() - 1);
    return newDate;
}
function $ed0966aa0f39122d$var$getWeekDays(firstDayOfWeek, locale) {
    return new Array(7).fill(undefined).map((_, index)=>(firstDayOfWeek + index) % 7 + 1).map((day)=>{
        const date = $ed0966aa0f39122d$var$removeTimezoneOffset(new Date(`2006-01-0${day}`));
        return [
            Intl.DateTimeFormat(locale, {
                weekday: "short"
            }).format(date),
            Intl.DateTimeFormat(locale, {
                weekday: "long"
            }).format(date)
        ];
    });
}
function $ed0966aa0f39122d$var$getYear(date) {
    return date.getFullYear();
}
function $ed0966aa0f39122d$var$isDateInRange(date, range) {
    if (!date || !range || !range.from || !range.to) return false;
    const earlyDate = range.from < range.to ? range.from : range.to;
    const laterDate = range.from < range.to ? range.to : range.from;
    return date >= earlyDate && date <= laterDate;
}
function $ed0966aa0f39122d$var$isSameDay(date1, date2) {
    if (!date1 || !date2) return false;
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
}
function $ed0966aa0f39122d$var$removeTimezoneOffset(date) {
    const newDate = new Date(date);
    newDate.setMinutes(newDate.getMinutes() + newDate.getTimezoneOffset());
    return newDate;
}
function $ed0966aa0f39122d$var$subDays(date, days) {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() - days);
    return newDate;
}
const $ed0966aa0f39122d$var$wcDatepickerCss = ".visually-hidden.sc-wc-datepicker{position:absolute;overflow:hidden;width:1px;height:1px;white-space:nowrap;clip:rect(0 0 0 0);-webkit-clip-path:inset(50%);clip-path:inset(50%)}";
const $ed0966aa0f39122d$var$defaultLabels = {
    clearButton: "Clear value",
    monthSelect: "Select month",
    nextMonthButton: "Next month",
    nextYearButton: "Next year",
    picker: "Choose date",
    previousMonthButton: "Previous month",
    previousYearButton: "Previous year",
    todayButton: "Show today",
    yearSelect: "Select year"
};
const $ed0966aa0f39122d$var$WCDatepicker = /*@__PURE__*/ (0, $8cd96f0f3be295d3$export$370caf1876b7c579)(class extends (0, $8cd96f0f3be295d3$export$7f8ddf7c7c20b3cd) {
    constructor(){
        super();
        this.__registerHost();
        this.selectDate = (0, $8cd96f0f3be295d3$export$c30017717ce2168e)(this, "selectDate", 7);
        this.changeMonth = (0, $8cd96f0f3be295d3$export$c30017717ce2168e)(this, "changeMonth", 7);
        this.disabled = false;
        this.disableDate = ()=>false;
        this.elementClassName = "wc-datepicker";
        this.firstDayOfWeek = 0;
        this.labels = $ed0966aa0f39122d$var$defaultLabels;
        this.locale = (navigator === null || navigator === void 0 ? void 0 : navigator.language) || "en-US";
        this.showClearButton = false;
        this.showMonthStepper = true;
        this.showTodayButton = false;
        this.showYearStepper = false;
        this.startDate = $ed0966aa0f39122d$var$getISODateString(new Date());
        this.maxSearchDays = 365;
        this.init = ()=>{
            this.currentDate = this.startDate ? $ed0966aa0f39122d$var$removeTimezoneOffset(new Date(this.startDate)) : new Date();
            this.updateWeekdays();
        };
        this.getAvailableDate = (date, direction)=>{
            let potentialDate;
            let outOfRange = false;
            switch(direction){
                case "previousDay":
                    potentialDate = $ed0966aa0f39122d$var$getPreviousDay(date);
                    break;
                case "nextDay":
                    potentialDate = $ed0966aa0f39122d$var$getNextDay(date);
                    break;
                case "previousSameWeekDay":
                    potentialDate = $ed0966aa0f39122d$var$subDays(date, 7);
                    break;
                case "nextSameWeekDay":
                    potentialDate = $ed0966aa0f39122d$var$addDays(date, 7);
                    break;
                case "firstOfMonth":
                    potentialDate = $ed0966aa0f39122d$var$getFirstOfMonth(date);
                    break;
                case "lastOfMonth":
                    potentialDate = $ed0966aa0f39122d$var$getLastOfMonth(date);
                    break;
                case "previousMonth":
                    potentialDate = $ed0966aa0f39122d$var$getPreviousMonth(date);
                    break;
                case "nextMonth":
                    potentialDate = $ed0966aa0f39122d$var$getNextMonth(date);
                    break;
                case "previousYear":
                    potentialDate = $ed0966aa0f39122d$var$getPreviousYear(date);
                    break;
                case "nextYear":
                    potentialDate = $ed0966aa0f39122d$var$getNextYear(date);
                    break;
            }
            while(this.disableDate(potentialDate) && !outOfRange){
                switch(direction){
                    case "previousDay":
                    case "lastOfMonth":
                        potentialDate = $ed0966aa0f39122d$var$getPreviousDay(potentialDate);
                        break;
                    case "nextDay":
                    case "firstOfMonth":
                    case "previousMonth":
                    case "nextMonth":
                    case "previousYear":
                    case "nextYear":
                        potentialDate = $ed0966aa0f39122d$var$getNextDay(potentialDate);
                        break;
                    case "previousSameWeekDay":
                        potentialDate = $ed0966aa0f39122d$var$subDays(potentialDate, 7);
                        break;
                    case "nextSameWeekDay":
                        potentialDate = $ed0966aa0f39122d$var$addDays(potentialDate, 7);
                        break;
                }
                switch(direction){
                    case "firstOfMonth":
                    case "lastOfMonth":
                    case "previousYear":
                    case "nextYear":
                        outOfRange = potentialDate.getMonth() !== date.getMonth();
                        break;
                    case "previousMonth":
                        outOfRange = potentialDate.getMonth() !== date.getMonth() - 1;
                        break;
                    case "nextMonth":
                        outOfRange = potentialDate.getMonth() !== date.getMonth() + 1;
                        break;
                    default:
                        outOfRange = !$ed0966aa0f39122d$var$isDateInRange(potentialDate, {
                            from: $ed0966aa0f39122d$var$subDays(date, this.maxSearchDays),
                            to: $ed0966aa0f39122d$var$addDays(date, this.maxSearchDays)
                        });
                        break;
                }
            }
            if (outOfRange) return date;
            return potentialDate;
        };
        this.nextMonth = ()=>{
            this.updateCurrentDate($ed0966aa0f39122d$var$getNextMonth(this.currentDate));
        };
        this.nextYear = ()=>{
            this.updateCurrentDate($ed0966aa0f39122d$var$getNextYear(this.currentDate));
        };
        this.previousMonth = ()=>{
            this.updateCurrentDate($ed0966aa0f39122d$var$getPreviousMonth(this.currentDate));
        };
        this.previousYear = ()=>{
            this.updateCurrentDate($ed0966aa0f39122d$var$getPreviousYear(this.currentDate));
        };
        this.showToday = ()=>{
            this.updateCurrentDate(new Date());
        };
        this.clear = ()=>{
            this.value = undefined;
            this.selectDate.emit(undefined);
        };
        this.onClick = (event)=>{
            if (this.disabled) return;
            const target = event.target.closest("[data-date]");
            if (!Boolean(target)) return;
            const date = $ed0966aa0f39122d$var$removeTimezoneOffset(new Date(target.dataset.date));
            this.updateCurrentDate(date);
            this.onSelectDate(date);
        };
        this.onMonthSelect = (event)=>{
            const month = +event.target.value - 1;
            const date = new Date(this.currentDate);
            date.setMonth(month);
            this.updateCurrentDate(date);
        };
        this.onYearSelect = (event)=>{
            let year = +event.target.value;
            const input = event.target;
            if (isNaN(year)) {
                year = new Date().getFullYear();
                input.value = String(year);
            } else if (year < 0) {
                year = 0;
                input.value = String(year);
            } else if (year > 9999) {
                year = 9999;
                input.value = String(year);
            }
            const date = new Date(this.currentDate);
            date.setFullYear(year);
            this.updateCurrentDate(date);
        };
        this.onKeyDown = (event)=>{
            if (this.disabled) return;
            if (event.code === "ArrowLeft") {
                event.preventDefault();
                this.updateCurrentDate(this.getAvailableDate(this.currentDate, "previousDay"), true);
            } else if (event.code === "ArrowRight") {
                event.preventDefault();
                this.updateCurrentDate(this.getAvailableDate(this.currentDate, "nextDay"), true);
            } else if (event.code === "ArrowUp") {
                event.preventDefault();
                this.updateCurrentDate(this.getAvailableDate(this.currentDate, "previousSameWeekDay"), true);
            } else if (event.code === "ArrowDown") {
                event.preventDefault();
                this.updateCurrentDate(this.getAvailableDate(this.currentDate, "nextSameWeekDay"), true);
            } else if (event.code === "PageUp") {
                event.preventDefault();
                if (event.shiftKey) this.updateCurrentDate(this.getAvailableDate(this.currentDate, "previousYear"), true);
                else this.updateCurrentDate(this.getAvailableDate(this.currentDate, "previousMonth"), true);
            } else if (event.code === "PageDown") {
                event.preventDefault();
                if (event.shiftKey) this.updateCurrentDate(this.getAvailableDate(this.currentDate, "nextYear"), true);
                else this.updateCurrentDate(this.getAvailableDate(this.currentDate, "nextMonth"), true);
            } else if (event.code === "Home") {
                event.preventDefault();
                this.updateCurrentDate(this.getAvailableDate(this.currentDate, "firstOfMonth"), true);
            } else if (event.code === "End") {
                event.preventDefault();
                this.updateCurrentDate(this.getAvailableDate(this.currentDate, "lastOfMonth"), true);
            } else if (event.code === "Space" || event.code === "Enter") {
                event.preventDefault();
                this.onSelectDate(this.currentDate);
            }
        };
        this.onMouseEnter = (event)=>{
            if (this.disabled) return;
            const date = $ed0966aa0f39122d$var$removeTimezoneOffset(new Date(event.target.closest("td").dataset.date));
            this.hoveredDate = date;
        };
        this.onMouseLeave = ()=>{
            this.hoveredDate = undefined;
        };
    }
    componentWillLoad() {
        this.init();
    }
    watchFirstDayOfWeek() {
        this.updateWeekdays();
    }
    watchLocale() {
        if (!Boolean(this.locale)) this.locale = (navigator === null || navigator === void 0 ? void 0 : navigator.language) || "en-US";
        this.updateWeekdays();
    }
    watchRange() {
        this.value = undefined;
        this.selectDate.emit(undefined);
    }
    watchStartDate() {
        this.currentDate = this.startDate ? $ed0966aa0f39122d$var$removeTimezoneOffset(new Date(this.startDate)) : new Date();
    }
    watchValue() {
        if (Boolean(this.value)) {
            if (Array.isArray(this.value) && this.value.length >= 1) this.currentDate = this.value[0];
            else if (this.value instanceof Date) this.currentDate = this.value;
        }
    }
    componentDidRender() {
        if (this.moveFocusAfterMonthChanged) {
            this.focusDate(this.currentDate);
            this.moveFocusAfterMonthChanged = false;
        }
    }
    updateWeekdays() {
        this.weekdays = $ed0966aa0f39122d$var$getWeekDays(this.firstDayOfWeek === 0 ? 7 : this.firstDayOfWeek, this.locale);
    }
    getClassName(element) {
        return Boolean(element) ? `${this.elementClassName}__${element}` : this.elementClassName;
    }
    getCalendarRows() {
        const daysOfMonth = $ed0966aa0f39122d$var$getDaysOfMonth(this.currentDate, true, this.firstDayOfWeek === 0 ? 7 : this.firstDayOfWeek);
        const calendarRows = [];
        for(let i = 0; i < daysOfMonth.length; i += 7){
            const row = daysOfMonth.slice(i, i + 7);
            calendarRows.push(row);
        }
        return calendarRows;
    }
    getTitle() {
        if (!Boolean(this.value)) return;
        if (this.isRangeValue(this.value)) {
            const startDate = Intl.DateTimeFormat(this.locale, {
                day: "numeric",
                month: "long",
                year: "numeric"
            }).format(this.value[0]);
            const endDate = this.value[1] ? Intl.DateTimeFormat(this.locale, {
                day: "numeric",
                month: "long",
                year: "numeric"
            }).format(this.value[1]) : undefined;
            if (Boolean(endDate)) return `${startDate} - ${endDate}`;
            else return startDate;
        } else return Intl.DateTimeFormat(this.locale, {
            day: "numeric",
            month: "long",
            year: "numeric"
        }).format(this.value);
    }
    focusDate(date) {
        var _a;
        (_a = this.el.querySelector(`[data-date="${$ed0966aa0f39122d$var$getISODateString(date)}"]`)) === null || _a === void 0 || _a.focus();
    }
    updateCurrentDate(date, moveFocus) {
        const month = date.getMonth();
        const year = date.getFullYear();
        if (year > 9999 || year < 0) return;
        const monthChanged = month !== this.currentDate.getMonth() || year !== this.currentDate.getFullYear();
        if (monthChanged) {
            this.changeMonth.emit({
                month: $ed0966aa0f39122d$var$getMonth(date),
                year: $ed0966aa0f39122d$var$getYear(date)
            });
            if (moveFocus) this.moveFocusAfterMonthChanged = true;
        }
        this.currentDate = date;
        if (moveFocus) this.focusDate(this.currentDate);
    }
    onSelectDate(date) {
        var _a, _b;
        if (this.disableDate(date)) return;
        if (this.isRangeValue(this.value)) {
            const newValue = ((_a = this.value) === null || _a === void 0 ? void 0 : _a[0]) === undefined || this.value.length === 2 ? [
                date
            ] : [
                this.value[0],
                date
            ];
            if (newValue.length === 2 && newValue[0] > newValue[1]) newValue.reverse();
            const isoValue = newValue[1] === undefined ? [
                $ed0966aa0f39122d$var$getISODateString(newValue[0])
            ] : [
                $ed0966aa0f39122d$var$getISODateString(newValue[0]),
                $ed0966aa0f39122d$var$getISODateString(newValue[1])
            ];
            this.value = newValue;
            this.selectDate.emit(isoValue);
        } else {
            if (((_b = this.value) === null || _b === void 0 ? void 0 : _b.getTime()) === date.getTime()) return;
            this.value = date;
            this.selectDate.emit($ed0966aa0f39122d$var$getISODateString(date));
        }
    }
    // @ts-ignore
    isRangeValue(value) {
        return this.range;
    }
    render() {
        const showFooter = this.showTodayButton || this.showClearButton;
        return (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)((0, $8cd96f0f3be295d3$export$5d2c872882e2b878), null, (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("div", {
            "aria-disabled": String(this.disabled),
            "aria-label": this.labels.picker,
            class: {
                [this.getClassName()]: true,
                [`${this.getClassName()}--disabled`]: this.disabled
            },
            role: "group"
        }, (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("div", {
            class: this.getClassName("header")
        }, (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("span", {
            "aria-atomic": "true",
            "aria-live": "polite",
            class: "visually-hidden"
        }, this.getTitle()), this.showYearStepper && (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("button", {
            "aria-label": this.labels.previousYearButton,
            class: this.getClassName("previous-year-button"),
            disabled: this.disabled,
            innerHTML: this.previousYearButtonContent || undefined,
            onClick: this.previousYear,
            type: "button"
        }, (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("svg", {
            fill: "none",
            height: "24",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            width: "24"
        }, (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("polyline", {
            points: "11 17 6 12 11 7"
        }), (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("polyline", {
            points: "18 17 13 12 18 7"
        }))), this.showMonthStepper && (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("button", {
            "aria-label": this.labels.previousMonthButton,
            class: this.getClassName("previous-month-button"),
            disabled: this.disabled,
            innerHTML: this.previousMonthButtonContent || undefined,
            onClick: this.previousMonth,
            type: "button"
        }, (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("svg", {
            fill: "none",
            height: "24",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            width: "24"
        }, (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("polyline", {
            points: "15 18 9 12 15 6"
        }))), (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("span", {
            class: this.getClassName("current-month")
        }, (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("select", {
            title: this.labels.monthSelect,
            "aria-label": this.labels.monthSelect,
            class: this.getClassName("month-select"),
            disabled: this.disabled,
            name: "month",
            onChange: this.onMonthSelect
        }, $ed0966aa0f39122d$var$getMonths(this.locale).map((month, index)=>(0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("option", {
                key: month,
                selected: this.currentDate.getMonth() === index,
                value: index + 1
            }, month))), (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("input", {
            title: this.labels.yearSelect,
            "aria-label": this.labels.yearSelect,
            class: this.getClassName("year-select"),
            disabled: this.disabled,
            max: 9999,
            maxLength: 4,
            min: 1,
            name: "year",
            onChange: this.onYearSelect,
            type: "number",
            value: this.currentDate.getFullYear()
        })), this.showMonthStepper && (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("button", {
            "aria-label": this.labels.nextMonthButton,
            class: this.getClassName("next-month-button"),
            disabled: this.disabled,
            innerHTML: this.nextMonthButtonContent || undefined,
            onClick: this.nextMonth,
            type: "button"
        }, (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("svg", {
            fill: "none",
            height: "24",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            width: "24"
        }, (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("polyline", {
            points: "9 18 15 12 9 6"
        }))), this.showYearStepper && (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("button", {
            "aria-label": this.labels.nextYearButton,
            class: this.getClassName("next-year-button"),
            disabled: this.disabled,
            innerHTML: this.nextYearButtonContent || undefined,
            onClick: this.nextYear,
            type: "button"
        }, (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("svg", {
            fill: "none",
            height: "24",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            width: "24"
        }, (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("polyline", {
            points: "13 17 18 12 13 7"
        }), (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("polyline", {
            points: "6 17 11 12 6 7"
        })))), (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("div", {
            class: this.getClassName("body")
        }, (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("table", {
            class: this.getClassName("calendar"),
            onKeyDown: this.onKeyDown,
            role: "grid"
        }, (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("thead", {
            class: this.getClassName("calendar-header")
        }, (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("tr", {
            class: this.getClassName("weekday-row")
        }, this.weekdays.map((weekday)=>(0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("th", {
                "aria-label": weekday[1],
                abbr: weekday[1],
                class: this.getClassName("weekday"),
                key: weekday[0],
                scope: "col"
            }, (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("span", null, weekday[0]))))), (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("tbody", null, this.getCalendarRows().map((calendarRow)=>{
            const rowKey = `row-${calendarRow[0].getMonth()}-${calendarRow[0].getDate()}`;
            return (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("tr", {
                class: this.getClassName("calendar-row"),
                key: rowKey
            }, calendarRow.map((day)=>{
                var _a, _b, _c, _d, _e;
                const isCurrent = $ed0966aa0f39122d$var$isSameDay(day, this.currentDate);
                const isOverflowing = day.getMonth() !== this.currentDate.getMonth();
                const isSelected = Array.isArray(this.value) ? $ed0966aa0f39122d$var$isSameDay(day, this.value[0]) || $ed0966aa0f39122d$var$isSameDay(day, this.value[1]) : $ed0966aa0f39122d$var$isSameDay(day, this.value);
                const isInRange = !this.isRangeValue ? false : $ed0966aa0f39122d$var$isDateInRange(day, {
                    from: (_a = this.value) === null || _a === void 0 ? void 0 : _a[0],
                    to: ((_b = this.value) === null || _b === void 0 ? void 0 : _b[1]) || this.hoveredDate || this.currentDate
                });
                const orderedValues = Boolean((_c = this.value) === null || _c === void 0 ? void 0 : _c[0]) ? [
                    (_d = this.value) === null || _d === void 0 ? void 0 : _d[0],
                    ((_e = this.value) === null || _e === void 0 ? void 0 : _e[1]) || this.hoveredDate
                ].sort((a, b)=>a - b) : [];
                const isStart = this.range && $ed0966aa0f39122d$var$isSameDay(orderedValues[0], day);
                const isEnd = this.range && $ed0966aa0f39122d$var$isSameDay(orderedValues[1], day);
                const isToday = $ed0966aa0f39122d$var$isSameDay(day, new Date());
                const isDisabled = this.disableDate(day);
                const cellKey = `cell-${day.getMonth()}-${day.getDate()}`;
                const className = {
                    [this.getClassName("date")]: true,
                    [this.getClassName("date--current")]: isCurrent,
                    [this.getClassName("date--disabled")]: isDisabled,
                    [this.getClassName("date--overflowing")]: isOverflowing,
                    [this.getClassName("date--today")]: isToday,
                    [this.getClassName("date--selected")]: isSelected,
                    [this.getClassName("date--in-range")]: isInRange,
                    [this.getClassName("date--start")]: isStart,
                    [this.getClassName("date--end")]: isEnd
                };
                const Tag = isSelected ? "strong" : isToday ? "em" : "span";
                return (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("td", {
                    "aria-disabled": String(isDisabled),
                    "aria-selected": isSelected ? "true" : undefined,
                    "aria-current": isToday ? "date" : undefined,
                    class: className,
                    "data-date": $ed0966aa0f39122d$var$getISODateString(day),
                    key: cellKey,
                    onClick: this.onClick,
                    onMouseEnter: this.onMouseEnter,
                    onMouseLeave: this.onMouseLeave,
                    role: "gridcell",
                    tabIndex: $ed0966aa0f39122d$var$isSameDay(day, this.currentDate) && !isDisabled && !this.disabled ? 0 : -1
                }, (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)(Tag, {
                    "aria-hidden": "true"
                }, day.getDate()), (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("span", {
                    class: "visually-hidden"
                }, Intl.DateTimeFormat(this.locale, {
                    day: "numeric",
                    month: "long"
                }).format(day)));
            }));
        })))), showFooter && (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("div", {
            class: this.getClassName("footer")
        }, this.showTodayButton && (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("button", {
            class: this.getClassName("today-button"),
            disabled: this.disabled,
            innerHTML: this.todayButtonContent || undefined,
            onClick: this.showToday,
            type: "button"
        }, this.labels.todayButton), this.showClearButton && (0, $8cd96f0f3be295d3$export$dda1d9f60106f0e9)("button", {
            class: this.getClassName("clear-button"),
            disabled: this.disabled,
            innerHTML: this.clearButtonContent || undefined,
            onClick: this.clear,
            type: "button"
        }, this.labels.clearButton))));
    }
    get el() {
        return this;
    }
    static get watchers() {
        return {
            "firstDayOfWeek": [
                "watchFirstDayOfWeek"
            ],
            "locale": [
                "watchLocale"
            ],
            "range": [
                "watchRange"
            ],
            "startDate": [
                "watchStartDate"
            ],
            "value": [
                "watchValue"
            ]
        };
    }
    static get style() {
        return $ed0966aa0f39122d$var$wcDatepickerCss;
    }
}, [
    2,
    "wc-datepicker",
    {
        "clearButtonContent": [
            1,
            "clear-button-content"
        ],
        "disabled": [
            4
        ],
        "disableDate": [
            16
        ],
        "elementClassName": [
            1,
            "element-class-name"
        ],
        "firstDayOfWeek": [
            2,
            "first-day-of-week"
        ],
        "range": [
            4
        ],
        "labels": [
            16
        ],
        "locale": [
            1
        ],
        "nextMonthButtonContent": [
            1,
            "next-month-button-content"
        ],
        "nextYearButtonContent": [
            1,
            "next-year-button-content"
        ],
        "previousMonthButtonContent": [
            1,
            "previous-month-button-content"
        ],
        "previousYearButtonContent": [
            1,
            "previous-year-button-content"
        ],
        "showClearButton": [
            4,
            "show-clear-button"
        ],
        "showMonthStepper": [
            4,
            "show-month-stepper"
        ],
        "showTodayButton": [
            4,
            "show-today-button"
        ],
        "showYearStepper": [
            4,
            "show-year-stepper"
        ],
        "startDate": [
            1,
            "start-date"
        ],
        "todayButtonContent": [
            1,
            "today-button-content"
        ],
        "value": [
            1040
        ],
        "maxSearchDays": [
            2,
            "max-search-days"
        ],
        "currentDate": [
            32
        ],
        "hoveredDate": [
            32
        ],
        "weekdays": [
            32
        ]
    }
]);
function $ed0966aa0f39122d$var$defineCustomElement$1() {
    if (typeof customElements === "undefined") return;
    const components = [
        "wc-datepicker"
    ];
    components.forEach((tagName)=>{
        switch(tagName){
            case "wc-datepicker":
                if (!customElements.get(tagName)) customElements.define(tagName, $ed0966aa0f39122d$var$WCDatepicker);
                break;
        }
    });
}
const $ed0966aa0f39122d$export$7df88f589dbda7a = $ed0966aa0f39122d$var$WCDatepicker;
const $ed0966aa0f39122d$export$a00e2346eabbdbef = $ed0966aa0f39122d$var$defineCustomElement$1;


customElements.define("wc-datepicker", (0, $ed0966aa0f39122d$export$7df88f589dbda7a));
const $bbf2ba14100374a5$var$createDatePicker = (element, closeAll)=>{
    const picker = element.querySelector("wc-datepicker");
    if (!picker) throw new Error("wc-datepicker not found");
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    picker.value = [
        today,
        tomorrow
    ];
    picker.disableDate = (date)=>{
        return date < new Date();
    };
    picker.labels = {
        clearButton: "T\xf6m v\xe4rde",
        monthSelect: "V\xe4lj m\xe5nad",
        nextMonthButton: "N\xe4sta m\xe5nad",
        nextYearButton: "N\xe4sta \xe5r",
        picker: "V\xe4lj datum",
        previousMonthButton: "F\xf6reg\xe5ende m\xe5nad",
        previousYearButton: "F\xf6reg\xe5ende \xe5r",
        todayButton: "Visa idag",
        yearSelect: "V\xe4lj \xe5r"
    };
    picker?.style.setProperty("display", "none");
    let isOpen = false;
    const formatDate = (date)=>{
        const parts = [
            date.getFullYear(),
            String(date.getMonth() + 1).padStart(2, "0"),
            String(date.getDate()).padStart(2, "0")
        ];
        return parts.join("-");
    };
    const toggle = (force)=>{
        if (!picker) return;
        const shouldOpen = force ?? !isOpen;
        if (shouldOpen) {
            isOpen = true;
            picker.style.removeProperty("display");
            picker.querySelector('button, select, input, [tabindex="0"]')?.focus();
        } else {
            isOpen = false;
            picker.style.setProperty("display", "none");
        }
    };
    const arrival = $bbf2ba14100374a5$var$createDateRepresentation(element.querySelector('[data-date-representation="arrival"]'));
    const departure = $bbf2ba14100374a5$var$createDateRepresentation(element.querySelector('[data-date-representation="departure"]'));
    const arrivalInput = element.querySelector("#edit-arrivaldate");
    const departureInput = element.querySelector("#edit-departuredate");
    const selectArrivalButton = element.querySelector("[data-select-arrival-date]");
    const selectDepartureButton = element.querySelector("[data-select-departure-date]");
    const updateDateRepresentation = (initial = false)=>{
        if (!Array.isArray(picker.value)) return;
        const [arrivalDate, departureDate] = picker.value;
        arrival.setDate(arrivalDate);
        departure.setDate(departureDate || arrivalDate);
        arrivalInput?.setAttribute("value", formatDate(arrivalDate));
        departureInput?.setAttribute("value", formatDate(departureDate || arrivalDate));
        if (departureDate) {
            toggle(false);
            if (!initial) selectDepartureButton?.focus();
        }
    };
    updateDateRepresentation(true);
    picker?.addEventListener("selectDate", ()=>{
        updateDateRepresentation();
    });
    selectArrivalButton?.addEventListener("click", ()=>{
        if (isOpen) closeAll();
        else {
            closeAll();
            toggle(true);
        }
    });
    selectDepartureButton?.addEventListener("click", ()=>{
        if (isOpen) closeAll();
        else {
            closeAll();
            toggle(true);
        }
    });
    window.addEventListener("keydown", (event)=>{
        if (isOpen && event.key === "Escape") {
            toggle(false);
            selectArrivalButton?.focus();
        }
    });
    return {
        toggle: toggle,
        get isOpen () {
            return isOpen;
        }
    };
};
const $bbf2ba14100374a5$var$createDateRepresentation = (element)=>{
    const monthNamesShort = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Maj",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dec"
    ];
    const top = element.querySelector(".top");
    const middle = element.querySelector(".middle");
    return {
        setDate (date) {
            if (top) top.textContent = monthNamesShort[date.getMonth()];
            if (middle) middle.textContent = String(date.getDate());
        }
    };
};
const $bbf2ba14100374a5$var$createAdultsPicker = (element, closeAll)=>{
    const adultsPickerButton = element.querySelector("button");
    const adultsPickerOptions = element.querySelectorAll("[data-adult-option]");
    const valueElement = element.querySelector("button .middle");
    const adultsInput = element.querySelector("#edit-adults");
    let isOpen = false;
    const toggle = (force)=>{
        isOpen = element.classList.toggle("picker-open", force);
    };
    adultsPickerButton?.addEventListener("click", ()=>{
        if (isOpen) closeAll();
        else {
            closeAll();
            toggle(true);
        }
        adultsPickerOptions[0]?.focus();
    });
    adultsPickerOptions?.forEach((option)=>{
        option.addEventListener("click", ()=>{
            const number = Number(option.getAttribute("data-adult-option"));
            if (valueElement) {
                valueElement.textContent = String(number);
                adultsInput?.setAttribute("value", String(number));
                toggle(false);
                adultsPickerButton?.focus();
            }
        });
    });
    window.addEventListener("keydown", (event)=>{
        if (isOpen && event.key === "Escape") {
            toggle(false);
            adultsPickerButton?.focus();
        }
    });
    return {
        toggle: toggle,
        get isOpen () {
            return isOpen;
        }
    };
};
const $bbf2ba14100374a5$var$createMoreOptions = (element, closeAll)=>{
    const moreOptionsButton = element.querySelector(".more-options-toggle");
    let isOpen = false;
    const toggle = (force)=>{
        const bookingMask = element.closest("#shcustom-bookingmask-form");
        if (bookingMask) isOpen = bookingMask.classList.toggle("more-options-open", force);
    };
    moreOptionsButton?.addEventListener("click", (event)=>{
        if (isOpen) closeAll();
        else {
            closeAll();
            toggle(true);
        }
    });
    return {
        toggle: toggle,
        get isOpen () {
            return isOpen;
        }
    };
};
const $bbf2ba14100374a5$var$createBookingWidget = (element)=>{
    const controls = new Set();
    const closeAll = ()=>{
        controls.forEach((control)=>{
            if (control.isOpen) control.toggle(false);
        });
    };
    controls.add($bbf2ba14100374a5$var$createDatePicker(element, closeAll));
    const adultsPickerElement = element.querySelector("[data-adults-picker]");
    if (adultsPickerElement) controls.add($bbf2ba14100374a5$var$createAdultsPicker(adultsPickerElement, closeAll));
    const moreOptionsElement = element.querySelector("[data-more-options]");
    if (moreOptionsElement) controls.add($bbf2ba14100374a5$var$createMoreOptions(moreOptionsElement, closeAll));
    document.body.addEventListener("click", (event)=>{
        if (!(event.target instanceof Element)) return;
        if (element.contains(event.target)) return;
        controls.forEach((control)=>{
            control.toggle(false);
        });
    });
};
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll("[data-booking-widget]").forEach($bbf2ba14100374a5$var$createBookingWidget);
});


(function($) {
    var focused = true;
    //FlexSlider: Object Instance
    $.flexslider = function(el, options) {
        var slider = $(el);
        // making variables public
        //if rtl value was not passed and html is in rtl..enable it by default.
        if (typeof options.rtl == "undefined" && $("html").attr("dir") == "rtl") options.rtl = true;
        slider.vars = $.extend({}, $.flexslider.defaults, options);
        var namespace = slider.vars.namespace, msGesture = window.navigator && window.navigator.msPointerEnabled && window.MSGesture, touch = ("ontouchstart" in window || msGesture || window.DocumentTouch && document instanceof DocumentTouch) && slider.vars.touch, // deprecating this idea, as devices are being released with both of these events
        eventType = "click touchend MSPointerUp keyup", watchedEvent = "", watchedEventClearTimer, vertical = slider.vars.direction === "vertical", reverse = slider.vars.reverse, carousel = slider.vars.itemWidth > 0, fade = slider.vars.animation === "fade", asNav = slider.vars.asNavFor !== "", methods = {};
        // Store a reference to the slider object
        $.data(el, "flexslider", slider);
        // Private slider methods
        methods = {
            init: function() {
                slider.animating = false;
                // Get current slide and make sure it is a number
                slider.currentSlide = parseInt(slider.vars.startAt ? slider.vars.startAt : 0, 10);
                if (isNaN(slider.currentSlide)) slider.currentSlide = 0;
                slider.animatingTo = slider.currentSlide;
                slider.atEnd = slider.currentSlide === 0 || slider.currentSlide === slider.last;
                slider.containerSelector = slider.vars.selector.substr(0, slider.vars.selector.search(" "));
                slider.slides = $(slider.vars.selector, slider);
                slider.container = $(slider.containerSelector, slider);
                slider.count = slider.slides.length;
                // SYNC:
                slider.syncExists = $(slider.vars.sync).length > 0;
                // SLIDE:
                if (slider.vars.animation === "slide") slider.vars.animation = "swing";
                slider.prop = vertical ? "top" : slider.vars.rtl ? "marginRight" : "marginLeft";
                slider.args = {};
                // SLIDESHOW:
                slider.manualPause = false;
                slider.stopped = false;
                //PAUSE WHEN INVISIBLE
                slider.started = false;
                slider.startTimeout = null;
                // TOUCH/USECSS:
                slider.transitions = !slider.vars.video && !fade && slider.vars.useCSS && function() {
                    var obj = document.createElement("div"), props = [
                        "perspectiveProperty",
                        "WebkitPerspective",
                        "MozPerspective",
                        "OPerspective",
                        "msPerspective"
                    ];
                    for(var i in props)if (obj.style[props[i]] !== undefined) {
                        slider.pfx = props[i].replace("Perspective", "").toLowerCase();
                        slider.prop = "-" + slider.pfx + "-transform";
                        return true;
                    }
                    return false;
                }();
                slider.isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
                slider.ensureAnimationEnd = "";
                // CONTROLSCONTAINER:
                if (slider.vars.controlsContainer !== "") slider.controlsContainer = $(slider.vars.controlsContainer).length > 0 && $(slider.vars.controlsContainer);
                // MANUAL:
                if (slider.vars.manualControls !== "") slider.manualControls = $(slider.vars.manualControls).length > 0 && $(slider.vars.manualControls);
                // CUSTOM DIRECTION NAV:
                if (slider.vars.customDirectionNav !== "") slider.customDirectionNav = $(slider.vars.customDirectionNav).length === 2 && $(slider.vars.customDirectionNav);
                // RANDOMIZE:
                if (slider.vars.randomize) {
                    slider.slides.sort(function() {
                        return Math.round(Math.random()) - 0.5;
                    });
                    slider.container.empty().append(slider.slides);
                }
                slider.doMath();
                // INIT
                slider.setup("init");
                // CONTROLNAV:
                if (slider.vars.controlNav) methods.controlNav.setup();
                // DIRECTIONNAV:
                if (slider.vars.directionNav) methods.directionNav.setup();
                // KEYBOARD:
                if (slider.vars.keyboard && ($(slider.containerSelector).length === 1 || slider.vars.multipleKeyboard)) $(document).bind("keyup", function(event) {
                    var keycode = event.keyCode;
                    if (!slider.animating && (keycode === 39 || keycode === 37)) {
                        var target = slider.vars.rtl ? keycode === 37 ? slider.getTarget("next") : keycode === 39 ? slider.getTarget("prev") : false : keycode === 39 ? slider.getTarget("next") : keycode === 37 ? slider.getTarget("prev") : false;
                        slider.flexAnimate(target, slider.vars.pauseOnAction);
                    }
                });
                // MOUSEWHEEL:
                if (slider.vars.mousewheel) slider.bind("mousewheel", function(event, delta, deltaX, deltaY) {
                    event.preventDefault();
                    var target = delta < 0 ? slider.getTarget("next") : slider.getTarget("prev");
                    slider.flexAnimate(target, slider.vars.pauseOnAction);
                });
                // PAUSEPLAY
                if (slider.vars.pausePlay) methods.pausePlay.setup();
                //PAUSE WHEN INVISIBLE
                if (slider.vars.slideshow && slider.vars.pauseInvisible) methods.pauseInvisible.init();
                // SLIDSESHOW
                if (slider.vars.slideshow) {
                    if (slider.vars.pauseOnHover) slider.hover(function() {
                        if (!slider.manualPlay && !slider.manualPause) slider.pause();
                    }, function() {
                        if (!slider.manualPause && !slider.manualPlay && !slider.stopped) slider.play();
                    });
                    // initialize animation
                    //If we're visible, or we don't use PageVisibility API
                    if (!slider.vars.pauseInvisible || !methods.pauseInvisible.isHidden()) slider.vars.initDelay > 0 ? slider.startTimeout = setTimeout(slider.play, slider.vars.initDelay) : slider.play();
                }
                // ASNAV:
                if (asNav) methods.asNav.setup();
                // TOUCH
                if (touch && slider.vars.touch) methods.touch();
                // FADE&&SMOOTHHEIGHT || SLIDE:
                if (!fade || fade && slider.vars.smoothHeight) $(window).bind("resize orientationchange focus", methods.resize);
                slider.find("img").attr("draggable", "false");
                // API: start() Callback
                setTimeout(function() {
                    slider.vars.start(slider);
                }, 200);
            },
            asNav: {
                setup: function() {
                    slider.asNav = true;
                    slider.animatingTo = Math.floor(slider.currentSlide / slider.move);
                    slider.currentItem = slider.currentSlide;
                    slider.slides.removeClass(namespace + "active-slide").eq(slider.currentItem).addClass(namespace + "active-slide");
                    if (!msGesture) slider.slides.on(eventType, function(e) {
                        e.preventDefault();
                        var $slide = $(this), target = $slide.index();
                        var posFromX;
                        if (slider.vars.rtl) posFromX = -1 * ($slide.offset().right - $(slider).scrollLeft()); // Find position of slide relative to right of slider container
                        else posFromX = $slide.offset().left - $(slider).scrollLeft(); // Find position of slide relative to left of slider container
                        if (posFromX <= 0 && $slide.hasClass(namespace + "active-slide")) slider.flexAnimate(slider.getTarget("prev"), true);
                        else if (!$(slider.vars.asNavFor).data("flexslider").animating && !$slide.hasClass(namespace + "active-slide")) {
                            slider.direction = slider.currentItem < target ? "next" : "prev";
                            slider.flexAnimate(target, slider.vars.pauseOnAction, false, true, true);
                        }
                    });
                    else {
                        el._slider = slider;
                        slider.slides.each(function() {
                            var that = this;
                            that._gesture = new MSGesture();
                            that._gesture.target = that;
                            that.addEventListener("MSPointerDown", function(e) {
                                e.preventDefault();
                                if (e.currentTarget._gesture) e.currentTarget._gesture.addPointer(e.pointerId);
                            }, false);
                            that.addEventListener("MSGestureTap", function(e) {
                                e.preventDefault();
                                var $slide = $(this), target = $slide.index();
                                if (!$(slider.vars.asNavFor).data("flexslider").animating && !$slide.hasClass("active")) {
                                    slider.direction = slider.currentItem < target ? "next" : "prev";
                                    slider.flexAnimate(target, slider.vars.pauseOnAction, false, true, true);
                                }
                            });
                        });
                    }
                }
            },
            controlNav: {
                setup: function() {
                    if (!slider.manualControls) methods.controlNav.setupPaging();
                    else methods.controlNav.setupManual();
                },
                setupPaging: function() {
                    var type = slider.vars.controlNav === "thumbnails" ? "control-thumbs" : "control-paging", j = 1, item, slide;
                    slider.controlNavScaffold = $('<ol class="' + namespace + "control-nav " + namespace + type + '"></ol>');
                    if (slider.pagingCount > 1) for(var i = 0; i < slider.pagingCount; i++){
                        slide = slider.slides.eq(i);
                        if (undefined === slide.attr("data-thumb-alt")) slide.attr("data-thumb-alt", "");
                        item = $("<a></a>").attr("href", "#").text(j);
                        if (slider.vars.controlNav === "thumbnails") item = $("<img/>").attr("src", slide.attr("data-thumb"));
                        if ("" !== slide.attr("data-thumb-alt")) item.attr("alt", slide.attr("data-thumb-alt"));
                        if ("thumbnails" === slider.vars.controlNav && true === slider.vars.thumbCaptions) {
                            var captn = slide.attr("data-thumbcaption");
                            if ("" !== captn && undefined !== captn) {
                                var caption = $("<span></span>").addClass(namespace + "caption").text(captn);
                                item.append(caption);
                            }
                        }
                        var liElement = $("<li>");
                        item.appendTo(liElement);
                        liElement.append("</li>");
                        slider.controlNavScaffold.append(liElement);
                        j++;
                    }
                    // CONTROLSCONTAINER:
                    slider.controlsContainer ? $(slider.controlsContainer).append(slider.controlNavScaffold) : slider.append(slider.controlNavScaffold);
                    methods.controlNav.set();
                    methods.controlNav.active();
                    slider.controlNavScaffold.delegate("a, img", eventType, function(event) {
                        event.preventDefault();
                        if (watchedEvent === "" || watchedEvent === event.type) {
                            var $this = $(this), target = slider.controlNav.index($this);
                            if (!$this.hasClass(namespace + "active")) {
                                slider.direction = target > slider.currentSlide ? "next" : "prev";
                                slider.flexAnimate(target, slider.vars.pauseOnAction);
                            }
                        }
                        // setup flags to prevent event duplication
                        if (watchedEvent === "") watchedEvent = event.type;
                        methods.setToClearWatchedEvent();
                    });
                },
                setupManual: function() {
                    slider.controlNav = slider.manualControls;
                    methods.controlNav.active();
                    slider.controlNav.bind(eventType, function(event) {
                        event.preventDefault();
                        if (watchedEvent === "" || watchedEvent === event.type) {
                            var $this = $(this), target = slider.controlNav.index($this);
                            if (!$this.hasClass(namespace + "active")) {
                                target > slider.currentSlide ? slider.direction = "next" : slider.direction = "prev";
                                slider.flexAnimate(target, slider.vars.pauseOnAction);
                            }
                        }
                        // setup flags to prevent event duplication
                        if (watchedEvent === "") watchedEvent = event.type;
                        methods.setToClearWatchedEvent();
                    });
                },
                set: function() {
                    var selector = slider.vars.controlNav === "thumbnails" ? "img" : "a";
                    slider.controlNav = $("." + namespace + "control-nav li " + selector, slider.controlsContainer ? slider.controlsContainer : slider);
                },
                active: function() {
                    slider.controlNav.removeClass(namespace + "active").eq(slider.animatingTo).addClass(namespace + "active");
                },
                update: function(action, pos) {
                    if (slider.pagingCount > 1 && action === "add") slider.controlNavScaffold.append($('<li><a href="#">' + slider.count + "</a></li>"));
                    else if (slider.pagingCount === 1) slider.controlNavScaffold.find("li").remove();
                    else slider.controlNav.eq(pos).closest("li").remove();
                    methods.controlNav.set();
                    slider.pagingCount > 1 && slider.pagingCount !== slider.controlNav.length ? slider.update(pos, action) : methods.controlNav.active();
                }
            },
            directionNav: {
                setup: function() {
                    var directionNavScaffold = $('<ul class="' + namespace + 'direction-nav"><li class="' + namespace + 'nav-prev"><a class="' + namespace + 'prev" href="#">' + slider.vars.prevText + '</a></li><li class="' + namespace + 'nav-next"><a class="' + namespace + 'next" href="#">' + slider.vars.nextText + "</a></li></ul>");
                    // CUSTOM DIRECTION NAV:
                    if (slider.customDirectionNav) slider.directionNav = slider.customDirectionNav;
                    else if (slider.controlsContainer) {
                        $(slider.controlsContainer).append(directionNavScaffold);
                        slider.directionNav = $("." + namespace + "direction-nav li a", slider.controlsContainer);
                    } else {
                        slider.append(directionNavScaffold);
                        slider.directionNav = $("." + namespace + "direction-nav li a", slider);
                    }
                    methods.directionNav.update();
                    slider.directionNav.bind(eventType, function(event) {
                        event.preventDefault();
                        var target;
                        if (watchedEvent === "" || watchedEvent === event.type) {
                            target = $(this).hasClass(namespace + "next") ? slider.getTarget("next") : slider.getTarget("prev");
                            slider.flexAnimate(target, slider.vars.pauseOnAction);
                        }
                        // setup flags to prevent event duplication
                        if (watchedEvent === "") watchedEvent = event.type;
                        methods.setToClearWatchedEvent();
                    });
                },
                update: function() {
                    var disabledClass = namespace + "disabled";
                    if (slider.pagingCount === 1) slider.directionNav.addClass(disabledClass).attr("tabindex", "-1");
                    else if (!slider.vars.animationLoop) {
                        if (slider.animatingTo === 0) slider.directionNav.removeClass(disabledClass).filter("." + namespace + "prev").addClass(disabledClass).attr("tabindex", "-1");
                        else if (slider.animatingTo === slider.last) slider.directionNav.removeClass(disabledClass).filter("." + namespace + "next").addClass(disabledClass).attr("tabindex", "-1");
                        else slider.directionNav.removeClass(disabledClass).removeAttr("tabindex");
                    } else slider.directionNav.removeClass(disabledClass).removeAttr("tabindex");
                }
            },
            pausePlay: {
                setup: function() {
                    var pausePlayScaffold = $('<div class="' + namespace + 'pauseplay"><a href="#"></a></div>');
                    // CONTROLSCONTAINER:
                    if (slider.controlsContainer) {
                        slider.controlsContainer.append(pausePlayScaffold);
                        slider.pausePlay = $("." + namespace + "pauseplay a", slider.controlsContainer);
                    } else {
                        slider.append(pausePlayScaffold);
                        slider.pausePlay = $("." + namespace + "pauseplay a", slider);
                    }
                    methods.pausePlay.update(slider.vars.slideshow ? namespace + "pause" : namespace + "play");
                    slider.pausePlay.bind(eventType, function(event) {
                        event.preventDefault();
                        if (watchedEvent === "" || watchedEvent === event.type) {
                            if ($(this).hasClass(namespace + "pause")) {
                                slider.manualPause = true;
                                slider.manualPlay = false;
                                slider.pause();
                            } else {
                                slider.manualPause = false;
                                slider.manualPlay = true;
                                slider.play();
                            }
                        }
                        // setup flags to prevent event duplication
                        if (watchedEvent === "") watchedEvent = event.type;
                        methods.setToClearWatchedEvent();
                    });
                },
                update: function(state) {
                    state === "play" ? slider.pausePlay.removeClass(namespace + "pause").addClass(namespace + "play").html(slider.vars.playText) : slider.pausePlay.removeClass(namespace + "play").addClass(namespace + "pause").html(slider.vars.pauseText);
                }
            },
            touch: function() {
                var startX, startY, offset, cwidth, dx, startT, onTouchStart, onTouchMove, onTouchEnd, scrolling = false, localX = 0, localY = 0, accDx = 0;
                if (!msGesture) {
                    onTouchStart = function(e) {
                        if (slider.animating) e.preventDefault();
                        else if (window.navigator.msPointerEnabled || e.touches.length === 1) {
                            slider.pause();
                            // CAROUSEL:
                            cwidth = vertical ? slider.h : slider.w;
                            startT = Number(new Date());
                            // CAROUSEL:
                            // Local vars for X and Y points.
                            localX = e.touches[0].pageX;
                            localY = e.touches[0].pageY;
                            offset = carousel && reverse && slider.animatingTo === slider.last ? 0 : carousel && reverse ? slider.limit - (slider.itemW + slider.vars.itemMargin) * slider.move * slider.animatingTo : carousel && slider.currentSlide === slider.last ? slider.limit : carousel ? (slider.itemW + slider.vars.itemMargin) * slider.move * slider.currentSlide : reverse ? (slider.last - slider.currentSlide + slider.cloneOffset) * cwidth : (slider.currentSlide + slider.cloneOffset) * cwidth;
                            startX = vertical ? localY : localX;
                            startY = vertical ? localX : localY;
                            el.addEventListener("touchmove", onTouchMove, false);
                            el.addEventListener("touchend", onTouchEnd, false);
                        }
                    };
                    onTouchMove = function(e) {
                        // Local vars for X and Y points.
                        localX = e.touches[0].pageX;
                        localY = e.touches[0].pageY;
                        dx = vertical ? startX - localY : (slider.vars.rtl ? -1 : 1) * (startX - localX);
                        scrolling = vertical ? Math.abs(dx) < Math.abs(localX - startY) : Math.abs(dx) < Math.abs(localY - startY);
                        var fxms = 500;
                        if (!scrolling || Number(new Date()) - startT > fxms) {
                            e.preventDefault();
                            if (!fade && slider.transitions) {
                                if (!slider.vars.animationLoop) dx = dx / (slider.currentSlide === 0 && dx < 0 || slider.currentSlide === slider.last && dx > 0 ? Math.abs(dx) / cwidth + 2 : 1);
                                slider.setProps(offset + dx, "setTouch");
                            }
                        }
                    };
                    onTouchEnd = function(e) {
                        // finish the touch by undoing the touch session
                        el.removeEventListener("touchmove", onTouchMove, false);
                        if (slider.animatingTo === slider.currentSlide && !scrolling && !(dx === null)) {
                            var updateDx = reverse ? -dx : dx, target = updateDx > 0 ? slider.getTarget("next") : slider.getTarget("prev");
                            if (slider.canAdvance(target) && (Number(new Date()) - startT < 550 && Math.abs(updateDx) > 50 || Math.abs(updateDx) > cwidth / 2)) slider.flexAnimate(target, slider.vars.pauseOnAction);
                            else if (!fade) slider.flexAnimate(slider.currentSlide, slider.vars.pauseOnAction, true);
                        }
                        el.removeEventListener("touchend", onTouchEnd, false);
                        startX = null;
                        startY = null;
                        dx = null;
                        offset = null;
                    };
                    el.addEventListener("touchstart", onTouchStart, false);
                } else {
                    el.style.msTouchAction = "none";
                    el._gesture = new MSGesture();
                    el._gesture.target = el;
                    el.addEventListener("MSPointerDown", onMSPointerDown, false);
                    el._slider = slider;
                    el.addEventListener("MSGestureChange", onMSGestureChange, false);
                    el.addEventListener("MSGestureEnd", onMSGestureEnd, false);
                    function onMSPointerDown(e) {
                        e.stopPropagation();
                        if (slider.animating) e.preventDefault();
                        else {
                            slider.pause();
                            el._gesture.addPointer(e.pointerId);
                            accDx = 0;
                            cwidth = vertical ? slider.h : slider.w;
                            startT = Number(new Date());
                            // CAROUSEL:
                            offset = carousel && reverse && slider.animatingTo === slider.last ? 0 : carousel && reverse ? slider.limit - (slider.itemW + slider.vars.itemMargin) * slider.move * slider.animatingTo : carousel && slider.currentSlide === slider.last ? slider.limit : carousel ? (slider.itemW + slider.vars.itemMargin) * slider.move * slider.currentSlide : reverse ? (slider.last - slider.currentSlide + slider.cloneOffset) * cwidth : (slider.currentSlide + slider.cloneOffset) * cwidth;
                        }
                    }
                    function onMSGestureChange(e) {
                        e.stopPropagation();
                        var slider = e.target._slider;
                        if (!slider) return;
                        var transX = -e.translationX, transY = -e.translationY;
                        //Accumulate translations.
                        accDx = accDx + (vertical ? transY : transX);
                        dx = (slider.vars.rtl ? -1 : 1) * accDx;
                        scrolling = vertical ? Math.abs(accDx) < Math.abs(-transX) : Math.abs(accDx) < Math.abs(-transY);
                        if (e.detail === e.MSGESTURE_FLAG_INERTIA) {
                            setImmediate(function() {
                                el._gesture.stop();
                            });
                            return;
                        }
                        if (!scrolling || Number(new Date()) - startT > 500) {
                            e.preventDefault();
                            if (!fade && slider.transitions) {
                                if (!slider.vars.animationLoop) dx = accDx / (slider.currentSlide === 0 && accDx < 0 || slider.currentSlide === slider.last && accDx > 0 ? Math.abs(accDx) / cwidth + 2 : 1);
                                slider.setProps(offset + dx, "setTouch");
                            }
                        }
                    }
                    function onMSGestureEnd(e) {
                        e.stopPropagation();
                        var slider = e.target._slider;
                        if (!slider) return;
                        if (slider.animatingTo === slider.currentSlide && !scrolling && !(dx === null)) {
                            var updateDx = reverse ? -dx : dx, target = updateDx > 0 ? slider.getTarget("next") : slider.getTarget("prev");
                            if (slider.canAdvance(target) && (Number(new Date()) - startT < 550 && Math.abs(updateDx) > 50 || Math.abs(updateDx) > cwidth / 2)) slider.flexAnimate(target, slider.vars.pauseOnAction);
                            else if (!fade) slider.flexAnimate(slider.currentSlide, slider.vars.pauseOnAction, true);
                        }
                        startX = null;
                        startY = null;
                        dx = null;
                        offset = null;
                        accDx = 0;
                    }
                }
            },
            resize: function() {
                if (!slider.animating && slider.is(":visible")) {
                    if (!carousel) slider.doMath();
                    if (fade) // SMOOTH HEIGHT:
                    methods.smoothHeight();
                    else if (carousel) {
                        slider.slides.width(slider.computedW);
                        slider.update(slider.pagingCount);
                        slider.setProps();
                    } else if (vertical) {
                        slider.viewport.height(slider.h);
                        slider.setProps(slider.h, "setTotal");
                    } else {
                        // SMOOTH HEIGHT:
                        if (slider.vars.smoothHeight) methods.smoothHeight();
                        slider.newSlides.width(slider.computedW);
                        slider.setProps(slider.computedW, "setTotal");
                    }
                }
            },
            smoothHeight: function(dur) {
                if (!vertical || fade) {
                    var $obj = fade ? slider : slider.viewport;
                    dur ? $obj.animate({
                        "height": slider.slides.eq(slider.animatingTo).innerHeight()
                    }, dur) : $obj.innerHeight(slider.slides.eq(slider.animatingTo).innerHeight());
                }
            },
            sync: function(action) {
                var $obj = $(slider.vars.sync).data("flexslider"), target = slider.animatingTo;
                switch(action){
                    case "animate":
                        $obj.flexAnimate(target, slider.vars.pauseOnAction, false, true);
                        break;
                    case "play":
                        if (!$obj.playing && !$obj.asNav) $obj.play();
                        break;
                    case "pause":
                        $obj.pause();
                        break;
                }
            },
            uniqueID: function($clone) {
                // Append _clone to current level and children elements with id attributes
                $clone.filter("[id]").add($clone.find("[id]")).each(function() {
                    var $this = $(this);
                    $this.attr("id", $this.attr("id") + "_clone");
                });
                return $clone;
            },
            pauseInvisible: {
                visProp: null,
                init: function() {
                    var visProp = methods.pauseInvisible.getHiddenProp();
                    if (visProp) {
                        var evtname = visProp.replace(/[H|h]idden/, "") + "visibilitychange";
                        document.addEventListener(evtname, function() {
                            if (methods.pauseInvisible.isHidden()) {
                                if (slider.startTimeout) clearTimeout(slider.startTimeout); //If clock is ticking, stop timer and prevent from starting while invisible
                                else slider.pause(); //Or just pause
                            } else {
                                if (slider.started) slider.play(); //Initiated before, just play
                                else if (slider.vars.initDelay > 0) setTimeout(slider.play, slider.vars.initDelay);
                                else slider.play(); //Didn't init before: simply init or wait for it
                            }
                        });
                    }
                },
                isHidden: function() {
                    var prop = methods.pauseInvisible.getHiddenProp();
                    if (!prop) return false;
                    return document[prop];
                },
                getHiddenProp: function() {
                    var prefixes = [
                        "webkit",
                        "moz",
                        "ms",
                        "o"
                    ];
                    // if 'hidden' is natively supported just return it
                    if ("hidden" in document) return "hidden";
                    // otherwise loop over all the known prefixes until we find one
                    for(var i = 0; i < prefixes.length; i++){
                        if (prefixes[i] + "Hidden" in document) return prefixes[i] + "Hidden";
                    }
                    // otherwise it's not supported
                    return null;
                }
            },
            setToClearWatchedEvent: function() {
                clearTimeout(watchedEventClearTimer);
                watchedEventClearTimer = setTimeout(function() {
                    watchedEvent = "";
                }, 3000);
            }
        };
        // public methods
        slider.flexAnimate = function(target, pause, override, withSync, fromNav) {
            if (!slider.vars.animationLoop && target !== slider.currentSlide) slider.direction = target > slider.currentSlide ? "next" : "prev";
            if (asNav && slider.pagingCount === 1) slider.direction = slider.currentItem < target ? "next" : "prev";
            if (!slider.animating && (slider.canAdvance(target, fromNav) || override) && slider.is(":visible")) {
                if (asNav && withSync) {
                    var master = $(slider.vars.asNavFor).data("flexslider");
                    slider.atEnd = target === 0 || target === slider.count - 1;
                    master.flexAnimate(target, true, false, true, fromNav);
                    slider.direction = slider.currentItem < target ? "next" : "prev";
                    master.direction = slider.direction;
                    if (Math.ceil((target + 1) / slider.visible) - 1 !== slider.currentSlide && target !== 0) {
                        slider.currentItem = target;
                        slider.slides.removeClass(namespace + "active-slide").eq(target).addClass(namespace + "active-slide");
                        target = Math.floor(target / slider.visible);
                    } else {
                        slider.currentItem = target;
                        slider.slides.removeClass(namespace + "active-slide").eq(target).addClass(namespace + "active-slide");
                        return false;
                    }
                }
                slider.animating = true;
                slider.animatingTo = target;
                // SLIDESHOW:
                if (pause) slider.pause();
                // API: before() animation Callback
                slider.vars.before(slider);
                // SYNC:
                if (slider.syncExists && !fromNav) methods.sync("animate");
                // CONTROLNAV
                if (slider.vars.controlNav) methods.controlNav.active();
                // !CAROUSEL:
                // CANDIDATE: slide active class (for add/remove slide)
                if (!carousel) slider.slides.removeClass(namespace + "active-slide").eq(target).addClass(namespace + "active-slide");
                // INFINITE LOOP:
                // CANDIDATE: atEnd
                slider.atEnd = target === 0 || target === slider.last;
                // DIRECTIONNAV:
                if (slider.vars.directionNav) methods.directionNav.update();
                if (target === slider.last) {
                    // API: end() of cycle Callback
                    slider.vars.end(slider);
                    // SLIDESHOW && !INFINITE LOOP:
                    if (!slider.vars.animationLoop) slider.pause();
                }
                // SLIDE:
                if (!fade) {
                    var dimension = vertical ? slider.slides.filter(":first").height() : slider.computedW, margin, slideString, calcNext;
                    // INFINITE LOOP / REVERSE:
                    if (carousel) {
                        margin = slider.vars.itemMargin;
                        calcNext = (slider.itemW + margin) * slider.move * slider.animatingTo;
                        slideString = calcNext > slider.limit && slider.visible !== 1 ? slider.limit : calcNext;
                    } else if (slider.currentSlide === 0 && target === slider.count - 1 && slider.vars.animationLoop && slider.direction !== "next") slideString = reverse ? (slider.count + slider.cloneOffset) * dimension : 0;
                    else if (slider.currentSlide === slider.last && target === 0 && slider.vars.animationLoop && slider.direction !== "prev") slideString = reverse ? 0 : (slider.count + 1) * dimension;
                    else slideString = reverse ? (slider.count - 1 - target + slider.cloneOffset) * dimension : (target + slider.cloneOffset) * dimension;
                    slider.setProps(slideString, "", slider.vars.animationSpeed);
                    if (slider.transitions) {
                        if (!slider.vars.animationLoop || !slider.atEnd) {
                            slider.animating = false;
                            slider.currentSlide = slider.animatingTo;
                        }
                        // Unbind previous transitionEnd events and re-bind new transitionEnd event
                        slider.container.unbind("webkitTransitionEnd transitionend");
                        slider.container.bind("webkitTransitionEnd transitionend", function() {
                            clearTimeout(slider.ensureAnimationEnd);
                            slider.wrapup(dimension);
                        });
                        // Insurance for the ever-so-fickle transitionEnd event
                        clearTimeout(slider.ensureAnimationEnd);
                        slider.ensureAnimationEnd = setTimeout(function() {
                            slider.wrapup(dimension);
                        }, slider.vars.animationSpeed + 100);
                    } else slider.container.animate(slider.args, slider.vars.animationSpeed, slider.vars.easing, function() {
                        slider.wrapup(dimension);
                    });
                } else if (!touch) {
                    slider.slides.eq(slider.currentSlide).css({
                        "zIndex": 1
                    }).animate({
                        "opacity": 0
                    }, slider.vars.animationSpeed, slider.vars.easing);
                    slider.slides.eq(target).css({
                        "zIndex": 2
                    }).animate({
                        "opacity": 1
                    }, slider.vars.animationSpeed, slider.vars.easing, slider.wrapup);
                } else {
                    slider.slides.eq(slider.currentSlide).css({
                        "opacity": 0,
                        "zIndex": 1
                    });
                    slider.slides.eq(target).css({
                        "opacity": 1,
                        "zIndex": 2
                    });
                    slider.wrapup(dimension);
                }
                // SMOOTH HEIGHT:
                if (slider.vars.smoothHeight) methods.smoothHeight(slider.vars.animationSpeed);
            }
        };
        slider.wrapup = function(dimension) {
            // SLIDE:
            if (!fade && !carousel) {
                if (slider.currentSlide === 0 && slider.animatingTo === slider.last && slider.vars.animationLoop) slider.setProps(dimension, "jumpEnd");
                else if (slider.currentSlide === slider.last && slider.animatingTo === 0 && slider.vars.animationLoop) slider.setProps(dimension, "jumpStart");
            }
            slider.animating = false;
            slider.currentSlide = slider.animatingTo;
            // API: after() animation Callback
            slider.vars.after(slider);
        };
        // SLIDESHOW:
        slider.animateSlides = function() {
            if (!slider.animating && focused) slider.flexAnimate(slider.getTarget("next"));
        };
        // SLIDESHOW:
        slider.pause = function() {
            clearInterval(slider.animatedSlides);
            slider.animatedSlides = null;
            slider.playing = false;
            // PAUSEPLAY:
            if (slider.vars.pausePlay) methods.pausePlay.update("play");
            // SYNC:
            if (slider.syncExists) methods.sync("pause");
        };
        // SLIDESHOW:
        slider.play = function() {
            if (slider.playing) clearInterval(slider.animatedSlides);
            slider.animatedSlides = slider.animatedSlides || setInterval(slider.animateSlides, slider.vars.slideshowSpeed);
            slider.started = slider.playing = true;
            // PAUSEPLAY:
            if (slider.vars.pausePlay) methods.pausePlay.update("pause");
            // SYNC:
            if (slider.syncExists) methods.sync("play");
        };
        // STOP:
        slider.stop = function() {
            slider.pause();
            slider.stopped = true;
        };
        slider.canAdvance = function(target, fromNav) {
            // ASNAV:
            var last = asNav ? slider.pagingCount - 1 : slider.last;
            return fromNav ? true : asNav && slider.currentItem === slider.count - 1 && target === 0 && slider.direction === "prev" ? true : asNav && slider.currentItem === 0 && target === slider.pagingCount - 1 && slider.direction !== "next" ? false : target === slider.currentSlide && !asNav ? false : slider.vars.animationLoop ? true : slider.atEnd && slider.currentSlide === 0 && target === last && slider.direction !== "next" ? false : slider.atEnd && slider.currentSlide === last && target === 0 && slider.direction === "next" ? false : true;
        };
        slider.getTarget = function(dir) {
            slider.direction = dir;
            if (dir === "next") return slider.currentSlide === slider.last ? 0 : slider.currentSlide + 1;
            else return slider.currentSlide === 0 ? slider.last : slider.currentSlide - 1;
        };
        // SLIDE:
        slider.setProps = function(pos, special, dur) {
            var target = function() {
                var posCheck = pos ? pos : (slider.itemW + slider.vars.itemMargin) * slider.move * slider.animatingTo, posCalc = function() {
                    if (carousel) return special === "setTouch" ? pos : reverse && slider.animatingTo === slider.last ? 0 : reverse ? slider.limit - (slider.itemW + slider.vars.itemMargin) * slider.move * slider.animatingTo : slider.animatingTo === slider.last ? slider.limit : posCheck;
                    else switch(special){
                        case "setTotal":
                            return reverse ? (slider.count - 1 - slider.currentSlide + slider.cloneOffset) * pos : (slider.currentSlide + slider.cloneOffset) * pos;
                        case "setTouch":
                            return reverse ? pos : pos;
                        case "jumpEnd":
                            return reverse ? pos : slider.count * pos;
                        case "jumpStart":
                            return reverse ? slider.count * pos : pos;
                        default:
                            return pos;
                    }
                }();
                return posCalc * (slider.vars.rtl ? 1 : -1) + "px";
            }();
            if (slider.transitions) {
                if (slider.isFirefox) target = vertical ? "translate3d(0," + target + ",0)" : "translate3d(" + (parseInt(target) + "px") + ",0,0)";
                else target = vertical ? "translate3d(0," + target + ",0)" : "translate3d(" + ((slider.vars.rtl ? -1 : 1) * parseInt(target) + "px") + ",0,0)";
                dur = dur !== undefined ? dur / 1000 + "s" : "0s";
                slider.container.css("-" + slider.pfx + "-transition-duration", dur);
                slider.container.css("transition-duration", dur);
            }
            slider.args[slider.prop] = target;
            if (slider.transitions || dur === undefined) slider.container.css(slider.args);
            slider.container.css("transform", target);
        };
        slider.setup = function(type) {
            // SLIDE:
            if (!fade) {
                var sliderOffset, arr;
                if (type === "init") {
                    slider.viewport = $('<div class="' + namespace + 'viewport"></div>').css({
                        "overflow": "hidden",
                        "position": "relative"
                    }).appendTo(slider).append(slider.container);
                    // INFINITE LOOP:
                    slider.cloneCount = 0;
                    slider.cloneOffset = 0;
                    // REVERSE:
                    if (reverse) {
                        arr = $.makeArray(slider.slides).reverse();
                        slider.slides = $(arr);
                        slider.container.empty().append(slider.slides);
                    }
                }
                // INFINITE LOOP && !CAROUSEL:
                if (slider.vars.animationLoop && !carousel) {
                    slider.cloneCount = 2;
                    slider.cloneOffset = 1;
                    // clear out old clones
                    if (type !== "init") slider.container.find(".clone").remove();
                    slider.container.append(methods.uniqueID(slider.slides.first().clone().addClass("clone")).attr("aria-hidden", "true")).prepend(methods.uniqueID(slider.slides.last().clone().addClass("clone")).attr("aria-hidden", "true"));
                }
                slider.newSlides = $(slider.vars.selector, slider);
                sliderOffset = reverse ? slider.count - 1 - slider.currentSlide + slider.cloneOffset : slider.currentSlide + slider.cloneOffset;
                // VERTICAL:
                if (vertical && !carousel) {
                    slider.container.height((slider.count + slider.cloneCount) * 200 + "%").css("position", "absolute").width("100%");
                    setTimeout(function() {
                        slider.newSlides.css({
                            "display": "block"
                        });
                        slider.doMath();
                        slider.viewport.height(slider.h);
                        slider.setProps(sliderOffset * slider.h, "init");
                    }, type === "init" ? 100 : 0);
                } else {
                    slider.container.width((slider.count + slider.cloneCount) * 200 + "%");
                    slider.setProps(sliderOffset * slider.computedW, "init");
                    setTimeout(function() {
                        slider.doMath();
                        if (slider.vars.rtl) {
                            if (slider.isFirefox) slider.newSlides.css({
                                "width": slider.computedW,
                                "marginRight": slider.computedM,
                                "float": "right",
                                "display": "block"
                            });
                            else slider.newSlides.css({
                                "width": slider.computedW,
                                "marginRight": slider.computedM,
                                "float": "left",
                                "display": "block"
                            });
                        } else slider.newSlides.css({
                            "width": slider.computedW,
                            "marginRight": slider.computedM,
                            "float": "left",
                            "display": "block"
                        });
                        // SMOOTH HEIGHT:
                        if (slider.vars.smoothHeight) methods.smoothHeight();
                    }, type === "init" ? 100 : 0);
                }
            } else {
                if (slider.vars.rtl) slider.slides.css({
                    "width": "100%",
                    "float": "right",
                    "marginLeft": "-100%",
                    "position": "relative"
                });
                else slider.slides.css({
                    "width": "100%",
                    "float": "left",
                    "marginRight": "-100%",
                    "position": "relative"
                });
                if (type === "init") {
                    if (!touch) {
                        //slider.slides.eq(slider.currentSlide).fadeIn(slider.vars.animationSpeed, slider.vars.easing);
                        if (slider.vars.fadeFirstSlide == false) slider.slides.css({
                            "opacity": 0,
                            "display": "block",
                            "zIndex": 1
                        }).eq(slider.currentSlide).css({
                            "zIndex": 2
                        }).css({
                            "opacity": 1
                        });
                        else slider.slides.css({
                            "opacity": 0,
                            "display": "block",
                            "zIndex": 1
                        }).eq(slider.currentSlide).css({
                            "zIndex": 2
                        }).animate({
                            "opacity": 1
                        }, slider.vars.animationSpeed, slider.vars.easing);
                    } else slider.slides.css({
                        "opacity": 0,
                        "display": "block",
                        "webkitTransition": "opacity " + slider.vars.animationSpeed / 1000 + "s ease",
                        "zIndex": 1
                    }).eq(slider.currentSlide).css({
                        "opacity": 1,
                        "zIndex": 2
                    });
                }
                // SMOOTH HEIGHT:
                if (slider.vars.smoothHeight) methods.smoothHeight();
            }
            // !CAROUSEL:
            // CANDIDATE: active slide
            if (!carousel) slider.slides.removeClass(namespace + "active-slide").eq(slider.currentSlide).addClass(namespace + "active-slide");
            //FlexSlider: init() Callback
            slider.vars.init(slider);
        };
        slider.doMath = function() {
            var slide = slider.slides.first(), slideMargin = slider.vars.itemMargin, minItems = slider.vars.minItems, maxItems = slider.vars.maxItems;
            slider.w = slider.viewport === undefined ? slider.width() : slider.viewport.width();
            if (slider.isFirefox) slider.w = slider.width();
            slider.h = slide.height();
            slider.boxPadding = slide.outerWidth() - slide.width();
            // CAROUSEL:
            if (carousel) {
                slider.itemT = slider.vars.itemWidth + slideMargin;
                slider.itemM = slideMargin;
                slider.minW = minItems ? minItems * slider.itemT : slider.w;
                slider.maxW = maxItems ? maxItems * slider.itemT - slideMargin : slider.w;
                slider.itemW = slider.minW > slider.w ? (slider.w - slideMargin * (minItems - 1)) / minItems : slider.maxW < slider.w ? (slider.w - slideMargin * (maxItems - 1)) / maxItems : slider.vars.itemWidth > slider.w ? slider.w : slider.vars.itemWidth;
                slider.visible = Math.floor(slider.w / slider.itemW);
                slider.move = slider.vars.move > 0 && slider.vars.move < slider.visible ? slider.vars.move : slider.visible;
                slider.pagingCount = Math.ceil((slider.count - slider.visible) / slider.move + 1);
                slider.last = slider.pagingCount - 1;
                slider.limit = slider.pagingCount === 1 ? 0 : slider.vars.itemWidth > slider.w ? slider.itemW * (slider.count - 1) + slideMargin * (slider.count - 1) : (slider.itemW + slideMargin) * slider.count - slider.w - slideMargin;
            } else {
                slider.itemW = slider.w;
                slider.itemM = slideMargin;
                slider.pagingCount = slider.count;
                slider.last = slider.count - 1;
            }
            slider.computedW = slider.itemW - slider.boxPadding;
            slider.computedM = slider.itemM;
        };
        slider.update = function(pos, action) {
            slider.doMath();
            // update currentSlide and slider.animatingTo if necessary
            if (!carousel) {
                if (pos < slider.currentSlide) slider.currentSlide += 1;
                else if (pos <= slider.currentSlide && pos !== 0) slider.currentSlide -= 1;
                slider.animatingTo = slider.currentSlide;
            }
            // update controlNav
            if (slider.vars.controlNav && !slider.manualControls) {
                if (action === "add" && !carousel || slider.pagingCount > slider.controlNav.length) methods.controlNav.update("add");
                else if (action === "remove" && !carousel || slider.pagingCount < slider.controlNav.length) {
                    if (carousel && slider.currentSlide > slider.last) {
                        slider.currentSlide -= 1;
                        slider.animatingTo -= 1;
                    }
                    methods.controlNav.update("remove", slider.last);
                }
            }
            // update directionNav
            if (slider.vars.directionNav) methods.directionNav.update();
        };
        slider.addSlide = function(obj, pos) {
            var $obj = $(obj);
            slider.count += 1;
            slider.last = slider.count - 1;
            // append new slide
            if (vertical && reverse) pos !== undefined ? slider.slides.eq(slider.count - pos).after($obj) : slider.container.prepend($obj);
            else pos !== undefined ? slider.slides.eq(pos).before($obj) : slider.container.append($obj);
            // update currentSlide, animatingTo, controlNav, and directionNav
            slider.update(pos, "add");
            // update slider.slides
            slider.slides = $(slider.vars.selector + ":not(.clone)", slider);
            // re-setup the slider to accomdate new slide
            slider.setup();
            //FlexSlider: added() Callback
            slider.vars.added(slider);
        };
        slider.removeSlide = function(obj) {
            var pos = isNaN(obj) ? slider.slides.index($(obj)) : obj;
            // update count
            slider.count -= 1;
            slider.last = slider.count - 1;
            // remove slide
            if (isNaN(obj)) $(obj, slider.slides).remove();
            else vertical && reverse ? slider.slides.eq(slider.last).remove() : slider.slides.eq(obj).remove();
            // update currentSlide, animatingTo, controlNav, and directionNav
            slider.doMath();
            slider.update(pos, "remove");
            // update slider.slides
            slider.slides = $(slider.vars.selector + ":not(.clone)", slider);
            // re-setup the slider to accomdate new slide
            slider.setup();
            // FlexSlider: removed() Callback
            slider.vars.removed(slider);
        };
        //FlexSlider: Initialize
        methods.init();
    };
    // Ensure the slider isn't focussed if the window loses focus.
    $(window).blur(function(e) {
        focused = false;
    }).focus(function(e) {
        focused = true;
    });
    //FlexSlider: Default Settings
    $.flexslider.defaults = {
        namespace: "flex-",
        selector: ".slides > li",
        animation: "fade",
        easing: "swing",
        direction: "horizontal",
        reverse: false,
        animationLoop: true,
        smoothHeight: false,
        startAt: 0,
        slideshow: true,
        slideshowSpeed: 7000,
        animationSpeed: 600,
        initDelay: 0,
        randomize: false,
        fadeFirstSlide: true,
        thumbCaptions: false,
        // Usability features
        pauseOnAction: true,
        pauseOnHover: false,
        pauseInvisible: true,
        useCSS: true,
        touch: true,
        video: false,
        // Primary Controls
        controlNav: true,
        directionNav: true,
        prevText: "Previous",
        nextText: "Next",
        // Secondary Navigation
        keyboard: true,
        multipleKeyboard: false,
        mousewheel: false,
        pausePlay: false,
        pauseText: "Pause",
        playText: "Play",
        // Special properties
        controlsContainer: "",
        manualControls: "",
        customDirectionNav: "",
        sync: "",
        asNavFor: "",
        // Carousel Options
        itemWidth: 0,
        itemMargin: 0,
        minItems: 1,
        maxItems: 0,
        move: 0,
        allowOneSlide: true,
        // Browser Specific
        isFirefox: false,
        // Callback API
        start: function() {},
        before: function() {},
        after: function() {},
        end: function() {},
        added: function() {},
        removed: function() {},
        init: function() {},
        rtl: false //{NEW} Boolean: Whether or not to enable RTL mode
    };
    //FlexSlider: Plugin Function
    $.fn.flexslider = function(options) {
        if (options === undefined) options = {};
        if (typeof options === "object") return this.each(function() {
            var $this = $(this), selector = options.selector ? options.selector : ".slides > li", $slides = $this.find(selector);
            if ($slides.length === 1 && options.allowOneSlide === false || $slides.length === 0) {
                $slides.fadeIn(400);
                if (options.start) options.start($this);
            } else if ($this.data("flexslider") === undefined) new $.flexslider(this, options);
        });
        else {
            // Helper strings to quickly perform functions on the slider
            var $slider = $(this).data("flexslider");
            switch(options){
                case "play":
                    $slider.play();
                    break;
                case "pause":
                    $slider.pause();
                    break;
                case "stop":
                    $slider.stop();
                    break;
                case "next":
                    $slider.flexAnimate($slider.getTarget("next"), true);
                    break;
                case "prev":
                case "previous":
                    $slider.flexAnimate($slider.getTarget("prev"), true);
                    break;
                default:
                    if (typeof options === "number") $slider.flexAnimate(options, true);
            }
        }
    };
})(jQuery);


(function($) {
    /**
	 * Background gallery slideshow.
	 */ (function() {
        var total = 0, current = 0, context = $("#background-images .overlay");
        var infoSlider = $("#background-images .info-slider").flexslider({
            slideshow: false,
            startAt: parseInt($("#background-images ul").attr("data-start")),
            controlNav: false,
            directionNav: false,
            sync: imageSlider,
            useCss: false
        });
        var imageSlider = $("#background-images .images").flexslider({
            slideshow: false,
            startAt: parseInt($("#background-images ul").attr("data-start")),
            controlNav: false,
            directionNav: true,
            /* controlsContainer: '#background-images .controls', */ useCss: true,
            sync: ".info-slider",
            after: function(slider) {},
            before: function(slider) {
                current = slider.animatingTo;
                updateCounter();
                var field = $("#background-images .field-" + current);
                field.addClass("loaded");
                field.find("img").css("display", "");
            },
            start: function(slider) {
                current = slider.currentSlide;
                total = slider.count;
                updateCounter();
                $(".gallery-prev", context).on("click", function(e) {
                    if (current - 1 < 0) slider.flexAnimate(total - 1);
                    else slider.flexAnimate(current - 1);
                    e.preventDefault();
                });
                $(".gallery-next", context).on("click", function(e) {
                    if (current + 1 > total - 1) slider.flexAnimate(0);
                    else slider.flexAnimate(current + 1);
                    e.preventDefault();
                });
            }
        });
        function updateCounter() {
            $("span.count", context).text(current + 1);
            $("span.total", context).text(total);
        }
        $("#background-images .info-toggle").on("click", function(e) {
            $("body").toggleClass("gallery-info-open");
            e.preventDefault();
        });
    })();
    $("#mobile-navigation").attr("aria-hidden", "true");
    $("#mobile-navigation a").attr("tabindex", "-1");
    $(".nav-toggle").on("click", function(e) {
        $("body").toggleClass("nav-open");
        var nav = $("#mobile-navigation");
        if ($("body").hasClass("nav-open")) {
            $(this).attr("aria-expanded", "true").attr("aria-label", shuStrings.hideMenu);
            nav.attr("aria-hidden", "false");
            $("#mobile-navigation a").removeAttr("tabindex");
        } else {
            $(this).attr("aria-expanded", "false").attr("aria-label", shuStrings.showMenu);
            nav.attr("aria-hidden", "true");
            $("#mobile-navigation a").attr("tabindex", "-1");
        }
        e.preventDefault();
    });
    $("#mobile-navigation a").on("click", function() {
        $("body").toggleClass("nav-open");
    });
    $(".gallery-toggle").on("click", function(e) {
        $("body").toggleClass("gallery-open");
        $("body").removeClass("gallery-info-open");
        e.preventDefault();
    });
/**
	 * Lazyloading of images.
	 */ // (function () {
// 	$('img.lazyload').lazy({
// 		delay: 300,
// 		effect: 'fadeIn',
// 		effectTime: 1500,
// 	});
// })();
/**
	 * Event tracking
	 */ // $('#shcustom-bookingmask-form').on('submit', function () {
// 	if (window.ga && typeof window.ga === 'function') {
// 		window.ga('send', 'event', 'Book Room', 'Open');
// 	}
// });
// $('.body a.fancybox[href*="gotthardskrog.2book.se"]').on(
// 	'click',
// 	function () {
// 		if (window.ga && typeof window.ga === 'function') {
// 			window.ga('send', 'event', 'Book Table', 'Open', 'Link in text');
// 		}
// 	},
// );
})(jQuery);


var $cd9d0e9cbecec201$exports = {};
!function(e, t) {
    $cd9d0e9cbecec201$exports = t();
}("undefined" != typeof self ? self : $cd9d0e9cbecec201$exports, function() {
    return function(e) {
        function t(r) {
            if (i[r]) return i[r].exports;
            var n = i[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return e[r].call(n.exports, n, n.exports, t), n.l = !0, n.exports;
        }
        var i = {};
        return t.m = e, t.c = i, t.d = function(e, i, r) {
            t.o(e, i) || Object.defineProperty(e, i, {
                configurable: !1,
                enumerable: !0,
                get: r
            });
        }, t.n = function(e) {
            var i = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(i, "a", i), i;
        }, t.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, t, i) {
            "use strict";
            function r(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, s = function() {
                function e(e, t) {
                    for(var i = 0; i < t.length; i++){
                        var r = t[i];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                    }
                }
                return function(t, i, r) {
                    return i && e(t.prototype, i), r && e(t, r), t;
                };
            }(), l = function() {
                function e(t) {
                    var i = this;
                    if (r(this, e), this.config = e.mergeSettings(t), this.selector = "string" == typeof this.config.selector ? document.querySelector(this.config.selector) : this.config.selector, null === this.selector) throw new Error("Something wrong with your selector \uD83D\uDE2D");
                    this.resolveSlidesNumber(), this.selectorWidth = this.selector.offsetWidth, this.innerElements = [].slice.call(this.selector.children), this.currentSlide = this.config.loop ? this.config.startIndex % this.innerElements.length : Math.max(0, Math.min(this.config.startIndex, this.innerElements.length - this.perPage)), this.transformProperty = e.webkitOrNot(), [
                        "resizeHandler",
                        "touchstartHandler",
                        "touchendHandler",
                        "touchmoveHandler",
                        "mousedownHandler",
                        "mouseupHandler",
                        "mouseleaveHandler",
                        "mousemoveHandler",
                        "clickHandler"
                    ].forEach(function(e) {
                        i[e] = i[e].bind(i);
                    }), this.init();
                }
                return s(e, [
                    {
                        key: "attachEvents",
                        value: function() {
                            window.addEventListener("resize", this.resizeHandler), this.config.draggable && (this.pointerDown = !1, this.drag = {
                                startX: 0,
                                endX: 0,
                                startY: 0,
                                letItGo: null,
                                preventClick: !1
                            }, this.selector.addEventListener("touchstart", this.touchstartHandler), this.selector.addEventListener("touchend", this.touchendHandler), this.selector.addEventListener("touchmove", this.touchmoveHandler), this.selector.addEventListener("mousedown", this.mousedownHandler), this.selector.addEventListener("mouseup", this.mouseupHandler), this.selector.addEventListener("mouseleave", this.mouseleaveHandler), this.selector.addEventListener("mousemove", this.mousemoveHandler), this.selector.addEventListener("click", this.clickHandler));
                        }
                    },
                    {
                        key: "detachEvents",
                        value: function() {
                            window.removeEventListener("resize", this.resizeHandler), this.selector.removeEventListener("touchstart", this.touchstartHandler), this.selector.removeEventListener("touchend", this.touchendHandler), this.selector.removeEventListener("touchmove", this.touchmoveHandler), this.selector.removeEventListener("mousedown", this.mousedownHandler), this.selector.removeEventListener("mouseup", this.mouseupHandler), this.selector.removeEventListener("mouseleave", this.mouseleaveHandler), this.selector.removeEventListener("mousemove", this.mousemoveHandler), this.selector.removeEventListener("click", this.clickHandler);
                        }
                    },
                    {
                        key: "init",
                        value: function() {
                            this.attachEvents(), this.selector.style.overflow = "hidden", this.selector.style.direction = this.config.rtl ? "rtl" : "ltr", this.buildSliderFrame(), this.config.onInit.call(this);
                        }
                    },
                    {
                        key: "buildSliderFrame",
                        value: function() {
                            var e = this.selectorWidth / this.perPage, t = this.config.loop ? this.innerElements.length + 2 * this.perPage : this.innerElements.length;
                            this.sliderFrame = document.createElement("div"), this.sliderFrame.style.width = e * t + "px", this.enableTransition(), this.config.draggable && (this.selector.style.cursor = "-webkit-grab");
                            var i = document.createDocumentFragment();
                            if (this.config.loop) for(var r = this.innerElements.length - this.perPage; r < this.innerElements.length; r++){
                                var n = this.buildSliderFrameItem(this.innerElements[r].cloneNode(!0));
                                i.appendChild(n);
                            }
                            for(var s = 0; s < this.innerElements.length; s++){
                                var l = this.buildSliderFrameItem(this.innerElements[s]);
                                i.appendChild(l);
                            }
                            if (this.config.loop) for(var o = 0; o < this.perPage; o++){
                                var a = this.buildSliderFrameItem(this.innerElements[o].cloneNode(!0));
                                i.appendChild(a);
                            }
                            this.sliderFrame.appendChild(i), this.selector.innerHTML = "", this.selector.appendChild(this.sliderFrame), this.slideToCurrent();
                        }
                    },
                    {
                        key: "buildSliderFrameItem",
                        value: function(e) {
                            var t = document.createElement("div");
                            return t.style.cssFloat = this.config.rtl ? "right" : "left", t.style.float = this.config.rtl ? "right" : "left", t.style.width = (this.config.loop ? 100 / (this.innerElements.length + 2 * this.perPage) : 100 / this.innerElements.length) + "%", t.appendChild(e), t;
                        }
                    },
                    {
                        key: "resolveSlidesNumber",
                        value: function() {
                            if ("number" == typeof this.config.perPage) this.perPage = this.config.perPage;
                            else if ("object" === n(this.config.perPage)) {
                                this.perPage = 1;
                                for(var e in this.config.perPage)window.innerWidth >= e && (this.perPage = this.config.perPage[e]);
                            }
                        }
                    },
                    {
                        key: "prev",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments[1];
                            if (!(this.innerElements.length <= this.perPage)) {
                                var i = this.currentSlide;
                                if (this.config.loop) {
                                    if (this.currentSlide - e < 0) {
                                        this.disableTransition();
                                        var r = this.currentSlide + this.innerElements.length, n = this.perPage, s = r + n, l = (this.config.rtl ? 1 : -1) * s * (this.selectorWidth / this.perPage), o = this.config.draggable ? this.drag.endX - this.drag.startX : 0;
                                        this.sliderFrame.style[this.transformProperty] = "translate3d(" + (l + o) + "px, 0, 0)", this.currentSlide = r - e;
                                    } else this.currentSlide = this.currentSlide - e;
                                } else this.currentSlide = Math.max(this.currentSlide - e, 0);
                                i !== this.currentSlide && (this.slideToCurrent(this.config.loop), this.config.onChange.call(this), t && t.call(this));
                            }
                        }
                    },
                    {
                        key: "next",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments[1];
                            if (!(this.innerElements.length <= this.perPage)) {
                                var i = this.currentSlide;
                                if (this.config.loop) {
                                    if (this.currentSlide + e > this.innerElements.length - this.perPage) {
                                        this.disableTransition();
                                        var r = this.currentSlide - this.innerElements.length, n = this.perPage, s = r + n, l = (this.config.rtl ? 1 : -1) * s * (this.selectorWidth / this.perPage), o = this.config.draggable ? this.drag.endX - this.drag.startX : 0;
                                        this.sliderFrame.style[this.transformProperty] = "translate3d(" + (l + o) + "px, 0, 0)", this.currentSlide = r + e;
                                    } else this.currentSlide = this.currentSlide + e;
                                } else this.currentSlide = Math.min(this.currentSlide + e, this.innerElements.length - this.perPage);
                                i !== this.currentSlide && (this.slideToCurrent(this.config.loop), this.config.onChange.call(this), t && t.call(this));
                            }
                        }
                    },
                    {
                        key: "disableTransition",
                        value: function() {
                            this.sliderFrame.style.webkitTransition = "all 0ms " + this.config.easing, this.sliderFrame.style.transition = "all 0ms " + this.config.easing;
                        }
                    },
                    {
                        key: "enableTransition",
                        value: function() {
                            this.sliderFrame.style.webkitTransition = "all " + this.config.duration + "ms " + this.config.easing, this.sliderFrame.style.transition = "all " + this.config.duration + "ms " + this.config.easing;
                        }
                    },
                    {
                        key: "goTo",
                        value: function(e, t) {
                            if (!(this.innerElements.length <= this.perPage)) {
                                var i = this.currentSlide;
                                this.currentSlide = this.config.loop ? e % this.innerElements.length : Math.min(Math.max(e, 0), this.innerElements.length - this.perPage), i !== this.currentSlide && (this.slideToCurrent(), this.config.onChange.call(this), t && t.call(this));
                            }
                        }
                    },
                    {
                        key: "slideToCurrent",
                        value: function(e) {
                            var t = this, i = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide, r = (this.config.rtl ? 1 : -1) * i * (this.selectorWidth / this.perPage);
                            e ? requestAnimationFrame(function() {
                                requestAnimationFrame(function() {
                                    t.enableTransition(), t.sliderFrame.style[t.transformProperty] = "translate3d(" + r + "px, 0, 0)";
                                });
                            }) : this.sliderFrame.style[this.transformProperty] = "translate3d(" + r + "px, 0, 0)";
                        }
                    },
                    {
                        key: "updateAfterDrag",
                        value: function() {
                            var e = (this.config.rtl ? -1 : 1) * (this.drag.endX - this.drag.startX), t = Math.abs(e), i = this.config.multipleDrag ? Math.ceil(t / (this.selectorWidth / this.perPage)) : 1, r = e > 0 && this.currentSlide - i < 0, n = e < 0 && this.currentSlide + i > this.innerElements.length - this.perPage;
                            e > 0 && t > this.config.threshold && this.innerElements.length > this.perPage ? this.prev(i) : e < 0 && t > this.config.threshold && this.innerElements.length > this.perPage && this.next(i), this.slideToCurrent(r || n);
                        }
                    },
                    {
                        key: "resizeHandler",
                        value: function() {
                            this.resolveSlidesNumber(), this.currentSlide + this.perPage > this.innerElements.length && (this.currentSlide = this.innerElements.length <= this.perPage ? 0 : this.innerElements.length - this.perPage), this.selectorWidth = this.selector.offsetWidth, this.buildSliderFrame();
                        }
                    },
                    {
                        key: "clearDrag",
                        value: function() {
                            this.drag = {
                                startX: 0,
                                endX: 0,
                                startY: 0,
                                letItGo: null,
                                preventClick: this.drag.preventClick
                            };
                        }
                    },
                    {
                        key: "touchstartHandler",
                        value: function(e) {
                            -1 !== [
                                "TEXTAREA",
                                "OPTION",
                                "INPUT",
                                "SELECT"
                            ].indexOf(e.target.nodeName) || (e.stopPropagation(), this.pointerDown = !0, this.drag.startX = e.touches[0].pageX, this.drag.startY = e.touches[0].pageY);
                        }
                    },
                    {
                        key: "touchendHandler",
                        value: function(e) {
                            e.stopPropagation(), this.pointerDown = !1, this.enableTransition(), this.drag.endX && this.updateAfterDrag(), this.clearDrag();
                        }
                    },
                    {
                        key: "touchmoveHandler",
                        value: function(e) {
                            if (e.stopPropagation(), null === this.drag.letItGo && (this.drag.letItGo = Math.abs(this.drag.startY - e.touches[0].pageY) < Math.abs(this.drag.startX - e.touches[0].pageX)), this.pointerDown && this.drag.letItGo) {
                                e.preventDefault(), this.drag.endX = e.touches[0].pageX, this.sliderFrame.style.webkitTransition = "all 0ms " + this.config.easing, this.sliderFrame.style.transition = "all 0ms " + this.config.easing;
                                var t = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide, i = t * (this.selectorWidth / this.perPage), r = this.drag.endX - this.drag.startX, n = this.config.rtl ? i + r : i - r;
                                this.sliderFrame.style[this.transformProperty] = "translate3d(" + (this.config.rtl ? 1 : -1) * n + "px, 0, 0)";
                            }
                        }
                    },
                    {
                        key: "mousedownHandler",
                        value: function(e) {
                            -1 !== [
                                "TEXTAREA",
                                "OPTION",
                                "INPUT",
                                "SELECT"
                            ].indexOf(e.target.nodeName) || (e.preventDefault(), e.stopPropagation(), this.pointerDown = !0, this.drag.startX = e.pageX);
                        }
                    },
                    {
                        key: "mouseupHandler",
                        value: function(e) {
                            e.stopPropagation(), this.pointerDown = !1, this.selector.style.cursor = "-webkit-grab", this.enableTransition(), this.drag.endX && this.updateAfterDrag(), this.clearDrag();
                        }
                    },
                    {
                        key: "mousemoveHandler",
                        value: function(e) {
                            if (e.preventDefault(), this.pointerDown) {
                                "A" === e.target.nodeName && (this.drag.preventClick = !0), this.drag.endX = e.pageX, this.selector.style.cursor = "-webkit-grabbing", this.sliderFrame.style.webkitTransition = "all 0ms " + this.config.easing, this.sliderFrame.style.transition = "all 0ms " + this.config.easing;
                                var t = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide, i = t * (this.selectorWidth / this.perPage), r = this.drag.endX - this.drag.startX, n = this.config.rtl ? i + r : i - r;
                                this.sliderFrame.style[this.transformProperty] = "translate3d(" + (this.config.rtl ? 1 : -1) * n + "px, 0, 0)";
                            }
                        }
                    },
                    {
                        key: "mouseleaveHandler",
                        value: function(e) {
                            this.pointerDown && (this.pointerDown = !1, this.selector.style.cursor = "-webkit-grab", this.drag.endX = e.pageX, this.drag.preventClick = !1, this.enableTransition(), this.updateAfterDrag(), this.clearDrag());
                        }
                    },
                    {
                        key: "clickHandler",
                        value: function(e) {
                            this.drag.preventClick && e.preventDefault(), this.drag.preventClick = !1;
                        }
                    },
                    {
                        key: "remove",
                        value: function(e, t) {
                            if (e < 0 || e >= this.innerElements.length) throw new Error("Item to remove doesn't exist \uD83D\uDE2D");
                            var i = e < this.currentSlide, r = this.currentSlide + this.perPage - 1 === e;
                            (i || r) && this.currentSlide--, this.innerElements.splice(e, 1), this.buildSliderFrame(), t && t.call(this);
                        }
                    },
                    {
                        key: "insert",
                        value: function(e, t, i) {
                            if (t < 0 || t > this.innerElements.length + 1) throw new Error("Unable to inset it at this index \uD83D\uDE2D");
                            if (-1 !== this.innerElements.indexOf(e)) throw new Error("The same item in a carousel? Really? Nope \uD83D\uDE2D");
                            var r = t <= this.currentSlide > 0 && this.innerElements.length;
                            this.currentSlide = r ? this.currentSlide + 1 : this.currentSlide, this.innerElements.splice(t, 0, e), this.buildSliderFrame(), i && i.call(this);
                        }
                    },
                    {
                        key: "prepend",
                        value: function(e, t) {
                            this.insert(e, 0), t && t.call(this);
                        }
                    },
                    {
                        key: "append",
                        value: function(e, t) {
                            this.insert(e, this.innerElements.length + 1), t && t.call(this);
                        }
                    },
                    {
                        key: "destroy",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = arguments[1];
                            if (this.detachEvents(), this.selector.style.cursor = "auto", e) {
                                for(var i = document.createDocumentFragment(), r = 0; r < this.innerElements.length; r++)i.appendChild(this.innerElements[r]);
                                this.selector.innerHTML = "", this.selector.appendChild(i), this.selector.removeAttribute("style");
                            }
                            t && t.call(this);
                        }
                    }
                ], [
                    {
                        key: "mergeSettings",
                        value: function(e) {
                            var t = {
                                selector: ".siema",
                                duration: 200,
                                easing: "ease-out",
                                perPage: 1,
                                startIndex: 0,
                                draggable: !0,
                                multipleDrag: !0,
                                threshold: 20,
                                loop: !1,
                                rtl: !1,
                                onInit: function() {},
                                onChange: function() {}
                            }, i = e;
                            for(var r in i)t[r] = i[r];
                            return t;
                        }
                    },
                    {
                        key: "webkitOrNot",
                        value: function() {
                            return "string" == typeof document.documentElement.style.transform ? "transform" : "WebkitTransform";
                        }
                    }
                ]), e;
            }();
            t.default = l, e.exports = t.default;
        }
    ]);
});


const $d7e4a02b5adf64e9$var$gallery = document.querySelector("[data-gallery]");
const $d7e4a02b5adf64e9$var$slider = document.querySelector("[data-slider]");
if ($d7e4a02b5adf64e9$var$slider && $d7e4a02b5adf64e9$var$slider.childElementCount > 0) {
    const mySiemaSlider = new (0, (/*@__PURE__*/$parcel$interopDefault($cd9d0e9cbecec201$exports)))({
        loop: true,
        selector: $d7e4a02b5adf64e9$var$slider,
        duration: 1000,
        easing: "cubic-bezier(.27,.22,.04,1)"
    });
    setInterval(()=>mySiemaSlider.next(), 8000);
}
if ($d7e4a02b5adf64e9$var$gallery) {
    const imgs = $d7e4a02b5adf64e9$var$gallery.querySelectorAll("img");
    const addDots = ()=>{
        const dots = document.createElement("div");
        dots.classList.add("gallery__dots");
        imgs.forEach((img, i)=>{
            const dot = document.createElement("button");
            dot.classList.add("gallery__dot");
            dot.setAttribute("role", "button");
            dot.setAttribute("aria-label", `Visa bild ${i + 1}`);
            dot.addEventListener("click", (e)=>{
                mySiemaWithDots.goTo(i);
            });
            dots.appendChild(dot);
        });
        $d7e4a02b5adf64e9$var$gallery.parentNode?.appendChild(dots);
    };
    const updateDots = (currentSlide)=>{
        const buttons = document.querySelectorAll(".gallery__dots button");
        buttons.forEach((dot, i)=>{
            const addOrRemove = currentSlide === i ? "add" : "remove";
            dot.classList[addOrRemove]("gallery__dot--active");
        });
    };
    const mySiemaWithDots = new (0, (/*@__PURE__*/$parcel$interopDefault($cd9d0e9cbecec201$exports)))({
        loop: true,
        selector: $d7e4a02b5adf64e9$var$gallery,
        onInit: function() {
            addDots();
            updateDots(0);
        },
        onChange: function() {
            updateDots(this.currentSlide);
        }
    });
}


var $af2a7b930688c62d$var$be = Object.defineProperty, $af2a7b930688c62d$var$me = Object.defineProperties;
var $af2a7b930688c62d$var$ge = Object.getOwnPropertyDescriptors;
var $af2a7b930688c62d$var$F = Object.getOwnPropertySymbols;
var $af2a7b930688c62d$var$At = Object.prototype.hasOwnProperty, $af2a7b930688c62d$var$Pt = Object.prototype.propertyIsEnumerable;
var $af2a7b930688c62d$var$Et = (r, t, e)=>t in r ? $af2a7b930688c62d$var$be(r, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : r[t] = e, $af2a7b930688c62d$var$M = (r, t)=>{
    for(var e in t || (t = {}))$af2a7b930688c62d$var$At.call(t, e) && $af2a7b930688c62d$var$Et(r, e, t[e]);
    if ($af2a7b930688c62d$var$F) for (var e of $af2a7b930688c62d$var$F(t))$af2a7b930688c62d$var$Pt.call(t, e) && $af2a7b930688c62d$var$Et(r, e, t[e]);
    return r;
}, $af2a7b930688c62d$var$Ut = (r, t)=>$af2a7b930688c62d$var$me(r, $af2a7b930688c62d$var$ge(t));
var $af2a7b930688c62d$var$rt = (r, t)=>{
    var e = {};
    for(var n in r)$af2a7b930688c62d$var$At.call(r, n) && t.indexOf(n) < 0 && (e[n] = r[n]);
    if (r != null && $af2a7b930688c62d$var$F) for (var n of $af2a7b930688c62d$var$F(r))t.indexOf(n) < 0 && $af2a7b930688c62d$var$Pt.call(r, n) && (e[n] = r[n]);
    return e;
};
var $af2a7b930688c62d$var$X, $af2a7b930688c62d$var$h, $af2a7b930688c62d$var$Gt, $af2a7b930688c62d$var$A, $af2a7b930688c62d$var$Tt, $af2a7b930688c62d$var$Jt, $af2a7b930688c62d$var$st, $af2a7b930688c62d$var$Kt, $af2a7b930688c62d$var$T = {}, $af2a7b930688c62d$var$Qt = [], $af2a7b930688c62d$var$Se = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $af2a7b930688c62d$var$mt = Array.isArray;
function $af2a7b930688c62d$var$E(r, t) {
    for(var e in t)r[e] = t[e];
    return r;
}
function $af2a7b930688c62d$var$Xt(r) {
    var t = r.parentNode;
    t && t.removeChild(r);
}
function $af2a7b930688c62d$var$Ce(r, t, e) {
    var n, o, i, s = {};
    for(i in t)i == "key" ? n = t[i] : i == "ref" ? o = t[i] : s[i] = t[i];
    if (arguments.length > 2 && (s.children = arguments.length > 3 ? $af2a7b930688c62d$var$X.call(arguments, 2) : e), typeof r == "function" && r.defaultProps != null) for(i in r.defaultProps)s[i] === void 0 && (s[i] = r.defaultProps[i]);
    return $af2a7b930688c62d$var$q(r, s, n, o, null);
}
function $af2a7b930688c62d$var$q(r, t, e, n, o) {
    var i = {
        type: r,
        props: t,
        key: e,
        ref: n,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: o == null ? ++$af2a7b930688c62d$var$Gt : o,
        __i: -1,
        __u: 0
    };
    return o == null && $af2a7b930688c62d$var$h.vnode != null && $af2a7b930688c62d$var$h.vnode(i), i;
}
function $af2a7b930688c62d$var$O(r) {
    return r.children;
}
function $af2a7b930688c62d$var$V(r, t) {
    this.props = r, this.context = t;
}
function $af2a7b930688c62d$var$P(r, t) {
    if (t == null) return r.__ ? $af2a7b930688c62d$var$P(r.__, r.__i + 1) : null;
    for(var e; t < r.__k.length; t++)if ((e = r.__k[t]) != null && e.__e != null) return e.__e;
    return typeof r.type == "function" ? $af2a7b930688c62d$var$P(r) : null;
}
function $af2a7b930688c62d$var$Zt(r) {
    var t, e;
    if ((r = r.__) != null && r.__c != null) {
        for(r.__e = r.__c.base = null, t = 0; t < r.__k.length; t++)if ((e = r.__k[t]) != null && e.__e != null) {
            r.__e = r.__c.base = e.__e;
            break;
        }
        return $af2a7b930688c62d$var$Zt(r);
    }
}
function $af2a7b930688c62d$var$ct(r) {
    (!r.__d && (r.__d = !0) && $af2a7b930688c62d$var$A.push(r) && !$af2a7b930688c62d$var$Q.__r++ || $af2a7b930688c62d$var$Tt !== $af2a7b930688c62d$var$h.debounceRendering) && (($af2a7b930688c62d$var$Tt = $af2a7b930688c62d$var$h.debounceRendering) || $af2a7b930688c62d$var$Jt)($af2a7b930688c62d$var$Q);
}
function $af2a7b930688c62d$var$Q() {
    var r, t, e, n, o, i, s, _, u;
    for($af2a7b930688c62d$var$A.sort($af2a7b930688c62d$var$st); r = $af2a7b930688c62d$var$A.shift();)r.__d && (t = $af2a7b930688c62d$var$A.length, n = void 0, i = (o = (e = r).__v).__e, _ = [], u = [], (s = e.__P) && ((n = $af2a7b930688c62d$var$E({}, o)).__v = o.__v + 1, $af2a7b930688c62d$var$h.vnode && $af2a7b930688c62d$var$h.vnode(n), $af2a7b930688c62d$var$gt(s, n, o, e.__n, s.ownerSVGElement !== void 0, 32 & o.__u ? [
        i
    ] : null, _, i == null ? $af2a7b930688c62d$var$P(o) : i, !!(32 & o.__u), u), n.__v = o.__v, n.__.__k[n.__i] = n, $af2a7b930688c62d$var$re(_, n, u), n.__e != i && $af2a7b930688c62d$var$Zt(n)), $af2a7b930688c62d$var$A.length > t && $af2a7b930688c62d$var$A.sort($af2a7b930688c62d$var$st));
    $af2a7b930688c62d$var$Q.__r = 0;
}
function $af2a7b930688c62d$var$te(r, t, e, n, o, i, s, _, u, l, f) {
    var c, p, a, m, v, g = n && n.__k || $af2a7b930688c62d$var$Qt, y = t.length;
    for(e.__d = u, $af2a7b930688c62d$var$we(e, t, g), u = e.__d, c = 0; c < y; c++)(a = e.__k[c]) != null && typeof a != "boolean" && typeof a != "function" && (p = a.__i === -1 ? $af2a7b930688c62d$var$T : g[a.__i] || $af2a7b930688c62d$var$T, a.__i = c, $af2a7b930688c62d$var$gt(r, a, p, o, i, s, _, u, l, f), m = a.__e, a.ref && p.ref != a.ref && (p.ref && $af2a7b930688c62d$var$St(p.ref, null, a), f.push(a.ref, a.__c || m, a)), v == null && m != null && (v = m), 65536 & a.__u || p.__k === a.__k ? (m || p.__e != u || (u = $af2a7b930688c62d$var$P(p)), u = $af2a7b930688c62d$var$ee(a, u, r)) : typeof a.type == "function" && a.__d !== void 0 ? u = a.__d : m && (u = m.nextSibling), a.__d = void 0, a.__u &= -196609);
    e.__d = u, e.__e = v;
}
function $af2a7b930688c62d$var$we(r, t, e) {
    var n, o, i, s, _, u = t.length, l = e.length, f = l, c = 0;
    for(r.__k = [], n = 0; n < u; n++)s = n + c, (o = r.__k[n] = (o = t[n]) == null || typeof o == "boolean" || typeof o == "function" ? null : typeof o == "string" || typeof o == "number" || typeof o == "bigint" || o.constructor == String ? $af2a7b930688c62d$var$q(null, o, null, null, null) : $af2a7b930688c62d$var$mt(o) ? $af2a7b930688c62d$var$q($af2a7b930688c62d$var$O, {
        children: o
    }, null, null, null) : o.constructor === void 0 && o.__b > 0 ? $af2a7b930688c62d$var$q(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : o) != null ? (o.__ = r, o.__b = r.__b + 1, _ = $af2a7b930688c62d$var$xe(o, e, s, f), o.__i = _, i = null, _ !== -1 && (f--, (i = e[_]) && (i.__u |= 131072)), i == null || i.__v === null ? (_ == -1 && c--, typeof o.type != "function" && (o.__u |= 65536)) : _ !== s && (_ === s + 1 ? c++ : _ > s ? f > u - s ? c += _ - s : c-- : _ < s ? _ == s - 1 && (c = _ - s) : c = 0, _ !== n + c && (o.__u |= 65536))) : (i = e[s]) && i.key == null && i.__e && !(131072 & i.__u) && (i.__e == r.__d && (r.__d = $af2a7b930688c62d$var$P(i)), $af2a7b930688c62d$var$_t(i, i, !1), e[s] = null, f--);
    if (f) for(n = 0; n < l; n++)(i = e[n]) != null && !(131072 & i.__u) && (i.__e == r.__d && (r.__d = $af2a7b930688c62d$var$P(i)), $af2a7b930688c62d$var$_t(i, i));
}
function $af2a7b930688c62d$var$ee(r, t, e) {
    var n, o;
    if (typeof r.type == "function") {
        for(n = r.__k, o = 0; n && o < n.length; o++)n[o] && (n[o].__ = r, t = $af2a7b930688c62d$var$ee(n[o], t, e));
        return t;
    }
    r.__e != t && (e.insertBefore(r.__e, t || null), t = r.__e);
    do t = t && t.nextSibling;
    while (t != null && t.nodeType === 8);
    return t;
}
function $af2a7b930688c62d$var$xe(r, t, e, n) {
    var o = r.key, i = r.type, s = e - 1, _ = e + 1, u = t[e];
    if (u === null || u && o == u.key && i === u.type && !(131072 & u.__u)) return e;
    if (n > (u != null && !(131072 & u.__u) ? 1 : 0)) for(; s >= 0 || _ < t.length;){
        if (s >= 0) {
            if ((u = t[s]) && !(131072 & u.__u) && o == u.key && i === u.type) return s;
            s--;
        }
        if (_ < t.length) {
            if ((u = t[_]) && !(131072 & u.__u) && o == u.key && i === u.type) return _;
            _++;
        }
    }
    return -1;
}
function $af2a7b930688c62d$var$$t(r, t, e) {
    t[0] === "-" ? r.setProperty(t, e == null ? "" : e) : r[t] = e == null ? "" : typeof e != "number" || $af2a7b930688c62d$var$Se.test(t) ? e : e + "px";
}
function $af2a7b930688c62d$var$N(r, t, e, n, o) {
    var i;
    t: if (t === "style") {
        if (typeof e == "string") r.style.cssText = e;
        else {
            if (typeof n == "string" && (r.style.cssText = n = ""), n) for(t in n)e && t in e || $af2a7b930688c62d$var$$t(r.style, t, "");
            if (e) for(t in e)n && e[t] === n[t] || $af2a7b930688c62d$var$$t(r.style, t, e[t]);
        }
    } else if (t[0] === "o" && t[1] === "n") i = t !== (t = t.replace(/(PointerCapture)$|Capture$/i, "$1")), t = t.toLowerCase() in r || t === "onFocusOut" || t === "onFocusIn" ? t.toLowerCase().slice(2) : t.slice(2), r.l || (r.l = {}), r.l[t + i] = e, e ? n ? e.u = n.u : (e.u = Date.now(), r.addEventListener(t, i ? $af2a7b930688c62d$var$Ht : $af2a7b930688c62d$var$Ot, i)) : r.removeEventListener(t, i ? $af2a7b930688c62d$var$Ht : $af2a7b930688c62d$var$Ot, i);
    else {
        if (o) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if (t !== "width" && t !== "height" && t !== "href" && t !== "list" && t !== "form" && t !== "tabIndex" && t !== "download" && t !== "rowSpan" && t !== "colSpan" && t !== "role" && t in r) try {
            r[t] = e == null ? "" : e;
            break t;
        } catch (s) {}
        typeof e == "function" || (e == null || e === !1 && t[4] !== "-" ? r.removeAttribute(t) : r.setAttribute(t, e));
    }
}
function $af2a7b930688c62d$var$Ot(r) {
    if (this.l) {
        var t = this.l[r.type + !1];
        if (r.t) {
            if (r.t <= t.u) return;
        } else r.t = Date.now();
        return t($af2a7b930688c62d$var$h.event ? $af2a7b930688c62d$var$h.event(r) : r);
    }
}
function $af2a7b930688c62d$var$Ht(r) {
    if (this.l) return this.l[r.type + !0]($af2a7b930688c62d$var$h.event ? $af2a7b930688c62d$var$h.event(r) : r);
}
function $af2a7b930688c62d$var$gt(r, t, e, n, o, i, s, _, u, l) {
    var f, c, p, a, m, v, g, y, C, k, j, U, kt, D, et, w = t.type;
    if (t.constructor !== void 0) return null;
    128 & e.__u && (u = !!(32 & e.__u), i = [
        _ = t.__e = e.__e
    ]), (f = $af2a7b930688c62d$var$h.__b) && f(t);
    t: if (typeof w == "function") try {
        if (y = t.props, C = (f = w.contextType) && n[f.__c], k = f ? C ? C.props.value : f.__ : n, e.__c ? g = (c = t.__c = e.__c).__ = c.__E : ("prototype" in w && w.prototype.render ? t.__c = c = new w(y, k) : (t.__c = c = new $af2a7b930688c62d$var$V(y, k), c.constructor = w, c.render = $af2a7b930688c62d$var$Ee), C && C.sub(c), c.props = y, c.state || (c.state = {}), c.context = k, c.__n = n, p = c.__d = !0, c.__h = [], c._sb = []), c.__s == null && (c.__s = c.state), w.getDerivedStateFromProps != null && (c.__s == c.state && (c.__s = $af2a7b930688c62d$var$E({}, c.__s)), $af2a7b930688c62d$var$E(c.__s, w.getDerivedStateFromProps(y, c.__s))), a = c.props, m = c.state, c.__v = t, p) w.getDerivedStateFromProps == null && c.componentWillMount != null && c.componentWillMount(), c.componentDidMount != null && c.__h.push(c.componentDidMount);
        else {
            if (w.getDerivedStateFromProps == null && y !== a && c.componentWillReceiveProps != null && c.componentWillReceiveProps(y, k), !c.__e && (c.shouldComponentUpdate != null && c.shouldComponentUpdate(y, c.__s, k) === !1 || t.__v === e.__v)) {
                for(t.__v !== e.__v && (c.props = y, c.state = c.__s, c.__d = !1), t.__e = e.__e, t.__k = e.__k, t.__k.forEach(function(I) {
                    I && (I.__ = t);
                }), j = 0; j < c._sb.length; j++)c.__h.push(c._sb[j]);
                c._sb = [], c.__h.length && s.push(c);
                break t;
            }
            c.componentWillUpdate != null && c.componentWillUpdate(y, c.__s, k), c.componentDidUpdate != null && c.__h.push(function() {
                c.componentDidUpdate(a, m, v);
            });
        }
        if (c.context = k, c.props = y, c.__P = r, c.__e = !1, U = $af2a7b930688c62d$var$h.__r, kt = 0, "prototype" in w && w.prototype.render) {
            for(c.state = c.__s, c.__d = !1, U && U(t), f = c.render(c.props, c.state, c.context), D = 0; D < c._sb.length; D++)c.__h.push(c._sb[D]);
            c._sb = [];
        } else do c.__d = !1, U && U(t), f = c.render(c.props, c.state, c.context), c.state = c.__s;
        while (c.__d && ++kt < 25);
        c.state = c.__s, c.getChildContext != null && (n = $af2a7b930688c62d$var$E($af2a7b930688c62d$var$E({}, n), c.getChildContext())), p || c.getSnapshotBeforeUpdate == null || (v = c.getSnapshotBeforeUpdate(a, m)), $af2a7b930688c62d$var$te(r, $af2a7b930688c62d$var$mt(et = f != null && f.type === $af2a7b930688c62d$var$O && f.key == null ? f.props.children : f) ? et : [
            et
        ], t, e, n, o, i, s, _, u, l), c.base = t.__e, t.__u &= -161, c.__h.length && s.push(c), g && (c.__E = c.__ = null);
    } catch (I) {
        t.__v = null, u || i != null ? (t.__e = _, t.__u |= u ? 160 : 32, i[i.indexOf(_)] = null) : (t.__e = e.__e, t.__k = e.__k), $af2a7b930688c62d$var$h.__e(I, t, e);
    }
    else i == null && t.__v === e.__v ? (t.__k = e.__k, t.__e = e.__e) : t.__e = $af2a7b930688c62d$var$ke(e.__e, t, e, n, o, i, s, u, l);
    (f = $af2a7b930688c62d$var$h.diffed) && f(t);
}
function $af2a7b930688c62d$var$re(r, t, e) {
    t.__d = void 0;
    for(var n = 0; n < e.length; n++)$af2a7b930688c62d$var$St(e[n], e[++n], e[++n]);
    $af2a7b930688c62d$var$h.__c && $af2a7b930688c62d$var$h.__c(t, r), r.some(function(o) {
        try {
            r = o.__h, o.__h = [], r.some(function(i) {
                i.call(o);
            });
        } catch (i) {
            $af2a7b930688c62d$var$h.__e(i, o.__v);
        }
    });
}
function $af2a7b930688c62d$var$ke(r, t, e, n, o, i, s, _, u) {
    var l, f, c, p, a, m, v, g = e.props, y = t.props, C = t.type;
    if (C === "svg" && (o = !0), i != null) {
        for(l = 0; l < i.length; l++)if ((a = i[l]) && "setAttribute" in a == !!C && (C ? a.localName === C : a.nodeType === 3)) {
            r = a, i[l] = null;
            break;
        }
    }
    if (r == null) {
        if (C === null) return document.createTextNode(y);
        r = o ? document.createElementNS("http://www.w3.org/2000/svg", C) : document.createElement(C, y.is && y), i = null, _ = !1;
    }
    if (C === null) g === y || _ && r.data === y || (r.data = y);
    else {
        if (i = i && $af2a7b930688c62d$var$X.call(r.childNodes), g = e.props || $af2a7b930688c62d$var$T, !_ && i != null) for(g = {}, l = 0; l < r.attributes.length; l++)g[(a = r.attributes[l]).name] = a.value;
        for(l in g)a = g[l], l == "children" || (l == "dangerouslySetInnerHTML" ? c = a : l === "key" || l in y || $af2a7b930688c62d$var$N(r, l, null, a, o));
        for(l in y)a = y[l], l == "children" ? p = a : l == "dangerouslySetInnerHTML" ? f = a : l == "value" ? m = a : l == "checked" ? v = a : l === "key" || _ && typeof a != "function" || g[l] === a || $af2a7b930688c62d$var$N(r, l, a, g[l], o);
        if (f) _ || c && (f.__html === c.__html || f.__html === r.innerHTML) || (r.innerHTML = f.__html), t.__k = [];
        else if (c && (r.innerHTML = ""), $af2a7b930688c62d$var$te(r, $af2a7b930688c62d$var$mt(p) ? p : [
            p
        ], t, e, n, o && C !== "foreignObject", i, s, i ? i[0] : e.__k && $af2a7b930688c62d$var$P(e, 0), _, u), i != null) for(l = i.length; l--;)i[l] != null && $af2a7b930688c62d$var$Xt(i[l]);
        _ || (l = "value", m !== void 0 && (m !== r[l] || C === "progress" && !m || C === "option" && m !== g[l]) && $af2a7b930688c62d$var$N(r, l, m, g[l], !1), l = "checked", v !== void 0 && v !== r[l] && $af2a7b930688c62d$var$N(r, l, v, g[l], !1));
    }
    return r;
}
function $af2a7b930688c62d$var$St(r, t, e) {
    try {
        typeof r == "function" ? r(t) : r.current = t;
    } catch (n) {
        $af2a7b930688c62d$var$h.__e(n, e);
    }
}
function $af2a7b930688c62d$var$_t(r, t, e) {
    var n, o;
    if ($af2a7b930688c62d$var$h.unmount && $af2a7b930688c62d$var$h.unmount(r), (n = r.ref) && (n.current && n.current !== r.__e || $af2a7b930688c62d$var$St(n, null, t)), (n = r.__c) != null) {
        if (n.componentWillUnmount) try {
            n.componentWillUnmount();
        } catch (i) {
            $af2a7b930688c62d$var$h.__e(i, t);
        }
        n.base = n.__P = null, r.__c = void 0;
    }
    if (n = r.__k) for(o = 0; o < n.length; o++)n[o] && $af2a7b930688c62d$var$_t(n[o], t, e || typeof r.type != "function");
    e || r.__e == null || $af2a7b930688c62d$var$Xt(r.__e), r.__ = r.__e = r.__d = void 0;
}
function $af2a7b930688c62d$var$Ee(r, t, e) {
    return this.constructor(r, e);
}
function $af2a7b930688c62d$var$Ae(r, t, e) {
    var n, o, i, s;
    $af2a7b930688c62d$var$h.__ && $af2a7b930688c62d$var$h.__(r, t), o = (n = typeof e == "function") ? null : e && e.__k || t.__k, i = [], s = [], $af2a7b930688c62d$var$gt(t, r = (!n && e || t).__k = $af2a7b930688c62d$var$Ce($af2a7b930688c62d$var$O, null, [
        r
    ]), o || $af2a7b930688c62d$var$T, $af2a7b930688c62d$var$T, t.ownerSVGElement !== void 0, !n && e ? [
        e
    ] : o ? null : t.firstChild ? $af2a7b930688c62d$var$X.call(t.childNodes) : null, i, !n && e ? e : o ? o.__e : t.firstChild, n, s), $af2a7b930688c62d$var$re(i, r, s);
}
function $af2a7b930688c62d$var$Ct(r, t) {
    var e = {
        __c: t = "__cC" + $af2a7b930688c62d$var$Kt++,
        __: r,
        Consumer: function(n, o) {
            return n.children(o);
        },
        Provider: function(n) {
            var o, i;
            return this.getChildContext || (o = [], (i = {})[t] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(s) {
                this.props.value !== s.value && o.some(function(_) {
                    _.__e = !0, $af2a7b930688c62d$var$ct(_);
                });
            }, this.sub = function(s) {
                o.push(s);
                var _ = s.componentWillUnmount;
                s.componentWillUnmount = function() {
                    o.splice(o.indexOf(s), 1), _ && _.call(s);
                };
            }), n.children;
        }
    };
    return e.Provider.__ = e.Consumer.contextType = e;
}
$af2a7b930688c62d$var$X = $af2a7b930688c62d$var$Qt.slice, $af2a7b930688c62d$var$h = {
    __e: function(r, t, e, n) {
        for(var o, i, s; t = t.__;)if ((o = t.__c) && !o.__) try {
            if ((i = o.constructor) && i.getDerivedStateFromError != null && (o.setState(i.getDerivedStateFromError(r)), s = o.__d), o.componentDidCatch != null && (o.componentDidCatch(r, n || {}), s = o.__d), s) return o.__E = o;
        } catch (_) {
            r = _;
        }
        throw r;
    }
}, $af2a7b930688c62d$var$Gt = 0, $af2a7b930688c62d$var$V.prototype.setState = function(r, t) {
    var e;
    e = this.__s != null && this.__s !== this.state ? this.__s : this.__s = $af2a7b930688c62d$var$E({}, this.state), typeof r == "function" && (r = r($af2a7b930688c62d$var$E({}, e), this.props)), r && $af2a7b930688c62d$var$E(e, r), r != null && this.__v && (t && this._sb.push(t), $af2a7b930688c62d$var$ct(this));
}, $af2a7b930688c62d$var$V.prototype.forceUpdate = function(r) {
    this.__v && (this.__e = !0, r && this.__h.push(r), $af2a7b930688c62d$var$ct(this));
}, $af2a7b930688c62d$var$V.prototype.render = $af2a7b930688c62d$var$O, $af2a7b930688c62d$var$A = [], $af2a7b930688c62d$var$Jt = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $af2a7b930688c62d$var$st = function(r, t) {
    return r.__v.__b - t.__v.__b;
}, $af2a7b930688c62d$var$Q.__r = 0, $af2a7b930688c62d$var$Kt = 0;
/*! js-cookie v3.0.5 | MIT */ function $af2a7b930688c62d$var$L(r) {
    for(var t = 1; t < arguments.length; t++){
        var e = arguments[t];
        for(var n in e)r[n] = e[n];
    }
    return r;
}
var $af2a7b930688c62d$var$Pe = {
    read: function(r) {
        return r[0] === '"' && (r = r.slice(1, -1)), r.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(r) {
        return encodeURIComponent(r).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
};
function $af2a7b930688c62d$var$ut(r, t) {
    function e(o, i, s) {
        if (typeof document != "undefined") {
            s = $af2a7b930688c62d$var$L({}, t, s), typeof s.expires == "number" && (s.expires = new Date(Date.now() + s.expires * 864e5)), s.expires && (s.expires = s.expires.toUTCString()), o = encodeURIComponent(o).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var _ = "";
            for(var u in s)s[u] && (_ += "; " + u, s[u] !== !0 && (_ += "=" + s[u].split(";")[0]));
            return document.cookie = o + "=" + r.write(i, o) + _;
        }
    }
    function n(o) {
        if (!(typeof document == "undefined" || arguments.length && !o)) {
            for(var i = document.cookie ? document.cookie.split("; ") : [], s = {}, _ = 0; _ < i.length; _++){
                var u = i[_].split("="), l = u.slice(1).join("=");
                try {
                    var f = decodeURIComponent(u[0]);
                    if (s[f] = r.read(l, f), o === f) break;
                } catch (c) {}
            }
            return o ? s[o] : s;
        }
    }
    return Object.create({
        set: e,
        get: n,
        remove: function(o, i) {
            e(o, "", $af2a7b930688c62d$var$L({}, i, {
                expires: -1
            }));
        },
        withAttributes: function(o) {
            return $af2a7b930688c62d$var$ut(this.converter, $af2a7b930688c62d$var$L({}, this.attributes, o));
        },
        withConverter: function(o) {
            return $af2a7b930688c62d$var$ut($af2a7b930688c62d$var$L({}, this.converter, o), this.attributes);
        }
    }, {
        attributes: {
            value: Object.freeze(t)
        },
        converter: {
            value: Object.freeze(r)
        }
    });
}
var $af2a7b930688c62d$var$R = $af2a7b930688c62d$var$ut($af2a7b930688c62d$var$Pe, {
    path: "/"
}), $af2a7b930688c62d$var$lt = function(r, t) {
    return $af2a7b930688c62d$var$lt = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(e, n) {
        e.__proto__ = n;
    } || function(e, n) {
        for(var o in n)Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }, $af2a7b930688c62d$var$lt(r, t);
};
function $af2a7b930688c62d$var$H(r, t) {
    if (typeof t != "function" && t !== null) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    $af2a7b930688c62d$var$lt(r, t);
    function e() {
        this.constructor = r;
    }
    r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
function $af2a7b930688c62d$var$at(r) {
    var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], n = 0;
    if (e) return e.call(r);
    if (r && typeof r.length == "number") return {
        next: function() {
            return r && n >= r.length && (r = void 0), {
                value: r && r[n++],
                done: !r
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $af2a7b930688c62d$var$ft(r, t) {
    var e = typeof Symbol == "function" && r[Symbol.iterator];
    if (!e) return r;
    var n = e.call(r), o, i = [], s;
    try {
        for(; (t === void 0 || t-- > 0) && !(o = n.next()).done;)i.push(o.value);
    } catch (_) {
        s = {
            error: _
        };
    } finally{
        try {
            o && !o.done && (e = n.return) && e.call(n);
        } finally{
            if (s) throw s.error;
        }
    }
    return i;
}
function $af2a7b930688c62d$var$pt(r, t, e) {
    if (e || arguments.length === 2) for(var n = 0, o = t.length, i; n < o; n++)(i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
    return r.concat(i || Array.prototype.slice.call(t));
}
function $af2a7b930688c62d$var$x(r) {
    return typeof r == "function";
}
function $af2a7b930688c62d$var$ne(r) {
    var t = function(n) {
        Error.call(n), n.stack = new Error().stack;
    }, e = r(t);
    return e.prototype = Object.create(Error.prototype), e.prototype.constructor = e, e;
}
var $af2a7b930688c62d$var$nt = $af2a7b930688c62d$var$ne(function(r) {
    return function(e) {
        r(this), this.message = e ? e.length + ` errors occurred during unsubscription:
` + e.map(function(n, o) {
            return o + 1 + ") " + n.toString();
        }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = e;
    };
});
function $af2a7b930688c62d$var$dt(r, t) {
    if (r) {
        var e = r.indexOf(t);
        0 <= e && r.splice(e, 1);
    }
}
var $af2a7b930688c62d$var$Z = function() {
    function r(t) {
        this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
    }
    return r.prototype.unsubscribe = function() {
        var t, e, n, o, i;
        if (!this.closed) {
            this.closed = !0;
            var s = this._parentage;
            if (s) {
                if (this._parentage = null, Array.isArray(s)) try {
                    for(var _ = $af2a7b930688c62d$var$at(s), u = _.next(); !u.done; u = _.next()){
                        var l = u.value;
                        l.remove(this);
                    }
                } catch (v) {
                    t = {
                        error: v
                    };
                } finally{
                    try {
                        u && !u.done && (e = _.return) && e.call(_);
                    } finally{
                        if (t) throw t.error;
                    }
                }
                else s.remove(this);
            }
            var f = this.initialTeardown;
            if ($af2a7b930688c62d$var$x(f)) try {
                f();
            } catch (v) {
                i = v instanceof $af2a7b930688c62d$var$nt ? v.errors : [
                    v
                ];
            }
            var c = this._finalizers;
            if (c) {
                this._finalizers = null;
                try {
                    for(var p = $af2a7b930688c62d$var$at(c), a = p.next(); !a.done; a = p.next()){
                        var m = a.value;
                        try {
                            $af2a7b930688c62d$var$jt(m);
                        } catch (v) {
                            i = i != null ? i : [], v instanceof $af2a7b930688c62d$var$nt ? i = $af2a7b930688c62d$var$pt($af2a7b930688c62d$var$pt([], $af2a7b930688c62d$var$ft(i)), $af2a7b930688c62d$var$ft(v.errors)) : i.push(v);
                        }
                    }
                } catch (v) {
                    n = {
                        error: v
                    };
                } finally{
                    try {
                        a && !a.done && (o = p.return) && o.call(p);
                    } finally{
                        if (n) throw n.error;
                    }
                }
            }
            if (i) throw new $af2a7b930688c62d$var$nt(i);
        }
    }, r.prototype.add = function(t) {
        var e;
        if (t && t !== this) {
            if (this.closed) $af2a7b930688c62d$var$jt(t);
            else {
                if (t instanceof r) {
                    if (t.closed || t._hasParent(this)) return;
                    t._addParent(this);
                }
                (this._finalizers = (e = this._finalizers) !== null && e !== void 0 ? e : []).push(t);
            }
        }
    }, r.prototype._hasParent = function(t) {
        var e = this._parentage;
        return e === t || Array.isArray(e) && e.includes(t);
    }, r.prototype._addParent = function(t) {
        var e = this._parentage;
        this._parentage = Array.isArray(e) ? (e.push(t), e) : e ? [
            e,
            t
        ] : t;
    }, r.prototype._removeParent = function(t) {
        var e = this._parentage;
        e === t ? this._parentage = null : Array.isArray(e) && $af2a7b930688c62d$var$dt(e, t);
    }, r.prototype.remove = function(t) {
        var e = this._finalizers;
        e && $af2a7b930688c62d$var$dt(e, t), t instanceof r && t._removeParent(this);
    }, r.EMPTY = function() {
        var t = new r();
        return t.closed = !0, t;
    }(), r;
}(), $af2a7b930688c62d$var$oe = $af2a7b930688c62d$var$Z.EMPTY;
function $af2a7b930688c62d$var$ie(r) {
    return r instanceof $af2a7b930688c62d$var$Z || r && "closed" in r && $af2a7b930688c62d$var$x(r.remove) && $af2a7b930688c62d$var$x(r.add) && $af2a7b930688c62d$var$x(r.unsubscribe);
}
function $af2a7b930688c62d$var$jt(r) {
    $af2a7b930688c62d$var$x(r) ? r() : r.unsubscribe();
}
var $af2a7b930688c62d$var$se = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: void 0,
    useDeprecatedSynchronousErrorHandling: !1,
    useDeprecatedNextContext: !1
}, $af2a7b930688c62d$var$ce = {
    setTimeout: function(r, t) {
        for(var e = [], n = 2; n < arguments.length; n++)e[n - 2] = arguments[n];
        return setTimeout.apply(void 0, $af2a7b930688c62d$var$pt([
            r,
            t
        ], $af2a7b930688c62d$var$ft(e)));
    },
    clearTimeout: function(r) {
        var t = $af2a7b930688c62d$var$ce.delegate;
        return ((t == null ? void 0 : t.clearTimeout) || clearTimeout)(r);
    },
    delegate: void 0
};
function $af2a7b930688c62d$var$Ue(r) {
    $af2a7b930688c62d$var$ce.setTimeout(function() {
        throw r;
    });
}
function $af2a7b930688c62d$var$Dt() {}
function $af2a7b930688c62d$var$Y(r) {
    r();
}
var $af2a7b930688c62d$var$wt = function(r) {
    $af2a7b930688c62d$var$H(t, r);
    function t(e) {
        var n = r.call(this) || this;
        return n.isStopped = !1, e ? (n.destination = e, $af2a7b930688c62d$var$ie(e) && e.add(n)) : n.destination = $af2a7b930688c62d$var$He, n;
    }
    return t.create = function(e, n, o) {
        return new $af2a7b930688c62d$var$ht(e, n, o);
    }, t.prototype.next = function(e) {
        this.isStopped || this._next(e);
    }, t.prototype.error = function(e) {
        this.isStopped || (this.isStopped = !0, this._error(e));
    }, t.prototype.complete = function() {
        this.isStopped || (this.isStopped = !0, this._complete());
    }, t.prototype.unsubscribe = function() {
        this.closed || (this.isStopped = !0, r.prototype.unsubscribe.call(this), this.destination = null);
    }, t.prototype._next = function(e) {
        this.destination.next(e);
    }, t.prototype._error = function(e) {
        try {
            this.destination.error(e);
        } finally{
            this.unsubscribe();
        }
    }, t.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    }, t;
}($af2a7b930688c62d$var$Z), $af2a7b930688c62d$var$Te = Function.prototype.bind;
function $af2a7b930688c62d$var$ot(r, t) {
    return $af2a7b930688c62d$var$Te.call(r, t);
}
var $af2a7b930688c62d$var$$e = function() {
    function r(t) {
        this.partialObserver = t;
    }
    return r.prototype.next = function(t) {
        var e = this.partialObserver;
        if (e.next) try {
            e.next(t);
        } catch (n) {
            $af2a7b930688c62d$var$B(n);
        }
    }, r.prototype.error = function(t) {
        var e = this.partialObserver;
        if (e.error) try {
            e.error(t);
        } catch (n) {
            $af2a7b930688c62d$var$B(n);
        }
        else $af2a7b930688c62d$var$B(t);
    }, r.prototype.complete = function() {
        var t = this.partialObserver;
        if (t.complete) try {
            t.complete();
        } catch (e) {
            $af2a7b930688c62d$var$B(e);
        }
    }, r;
}(), $af2a7b930688c62d$var$ht = function(r) {
    $af2a7b930688c62d$var$H(t, r);
    function t(e, n, o) {
        var i = r.call(this) || this, s;
        if ($af2a7b930688c62d$var$x(e) || !e) s = {
            next: e != null ? e : void 0,
            error: n != null ? n : void 0,
            complete: o != null ? o : void 0
        };
        else {
            var _;
            i && $af2a7b930688c62d$var$se.useDeprecatedNextContext ? (_ = Object.create(e), _.unsubscribe = function() {
                return i.unsubscribe();
            }, s = {
                next: e.next && $af2a7b930688c62d$var$ot(e.next, _),
                error: e.error && $af2a7b930688c62d$var$ot(e.error, _),
                complete: e.complete && $af2a7b930688c62d$var$ot(e.complete, _)
            }) : s = e;
        }
        return i.destination = new $af2a7b930688c62d$var$$e(s), i;
    }
    return t;
}($af2a7b930688c62d$var$wt);
function $af2a7b930688c62d$var$B(r) {
    $af2a7b930688c62d$var$Ue(r);
}
function $af2a7b930688c62d$var$Oe(r) {
    throw r;
}
var $af2a7b930688c62d$var$He = {
    closed: !0,
    next: $af2a7b930688c62d$var$Dt,
    error: $af2a7b930688c62d$var$Oe,
    complete: $af2a7b930688c62d$var$Dt
}, $af2a7b930688c62d$var$je = function() {
    return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function $af2a7b930688c62d$var$De(r) {
    return r;
}
function $af2a7b930688c62d$var$Ie(r) {
    return r.length === 0 ? $af2a7b930688c62d$var$De : r.length === 1 ? r[0] : function(e) {
        return r.reduce(function(n, o) {
            return o(n);
        }, e);
    };
}
var $af2a7b930688c62d$var$It = function() {
    function r(t) {
        t && (this._subscribe = t);
    }
    return r.prototype.lift = function(t) {
        var e = new r();
        return e.source = this, e.operator = t, e;
    }, r.prototype.subscribe = function(t, e, n) {
        var o = this, i = $af2a7b930688c62d$var$Me(t) ? t : new $af2a7b930688c62d$var$ht(t, e, n);
        return $af2a7b930688c62d$var$Y(function() {
            var s = o, _ = s.operator, u = s.source;
            i.add(_ ? _.call(i, u) : u ? o._subscribe(i) : o._trySubscribe(i));
        }), i;
    }, r.prototype._trySubscribe = function(t) {
        try {
            return this._subscribe(t);
        } catch (e) {
            t.error(e);
        }
    }, r.prototype.forEach = function(t, e) {
        var n = this;
        return e = $af2a7b930688c62d$var$Ft(e), new e(function(o, i) {
            var s = new $af2a7b930688c62d$var$ht({
                next: function(_) {
                    try {
                        t(_);
                    } catch (u) {
                        i(u), s.unsubscribe();
                    }
                },
                error: i,
                complete: o
            });
            n.subscribe(s);
        });
    }, r.prototype._subscribe = function(t) {
        var e;
        return (e = this.source) === null || e === void 0 ? void 0 : e.subscribe(t);
    }, r.prototype[$af2a7b930688c62d$var$je] = function() {
        return this;
    }, r.prototype.pipe = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        return $af2a7b930688c62d$var$Ie(t)(this);
    }, r.prototype.toPromise = function(t) {
        var e = this;
        return t = $af2a7b930688c62d$var$Ft(t), new t(function(n, o) {
            var i;
            e.subscribe(function(s) {
                return i = s;
            }, function(s) {
                return o(s);
            }, function() {
                return n(i);
            });
        });
    }, r.create = function(t) {
        return new r(t);
    }, r;
}();
function $af2a7b930688c62d$var$Ft(r) {
    var t;
    return (t = r != null ? r : $af2a7b930688c62d$var$se.Promise) !== null && t !== void 0 ? t : Promise;
}
function $af2a7b930688c62d$var$Fe(r) {
    return r && $af2a7b930688c62d$var$x(r.next) && $af2a7b930688c62d$var$x(r.error) && $af2a7b930688c62d$var$x(r.complete);
}
function $af2a7b930688c62d$var$Me(r) {
    return r && r instanceof $af2a7b930688c62d$var$wt || $af2a7b930688c62d$var$Fe(r) && $af2a7b930688c62d$var$ie(r);
}
function $af2a7b930688c62d$var$Ne(r) {
    return $af2a7b930688c62d$var$x(r == null ? void 0 : r.lift);
}
function $af2a7b930688c62d$var$Le(r) {
    return function(t) {
        if ($af2a7b930688c62d$var$Ne(t)) return t.lift(function(e) {
            try {
                return r(e, this);
            } catch (n) {
                this.error(n);
            }
        });
        throw new TypeError("Unable to lift unknown Observable type");
    };
}
function $af2a7b930688c62d$var$Re(r, t, e, n, o) {
    return new $af2a7b930688c62d$var$Be(r, t, e, n, o);
}
var $af2a7b930688c62d$var$Be = function(r) {
    $af2a7b930688c62d$var$H(t, r);
    function t(e, n, o, i, s, _) {
        var u = r.call(this, e) || this;
        return u.onFinalize = s, u.shouldUnsubscribe = _, u._next = n ? function(l) {
            try {
                n(l);
            } catch (f) {
                e.error(f);
            }
        } : r.prototype._next, u._error = i ? function(l) {
            try {
                i(l);
            } catch (f) {
                e.error(f);
            } finally{
                this.unsubscribe();
            }
        } : r.prototype._error, u._complete = o ? function() {
            try {
                o();
            } catch (l) {
                e.error(l);
            } finally{
                this.unsubscribe();
            }
        } : r.prototype._complete, u;
    }
    return t.prototype.unsubscribe = function() {
        var e;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var n = this.closed;
            r.prototype.unsubscribe.call(this), !n && ((e = this.onFinalize) === null || e === void 0 || e.call(this));
        }
    }, t;
}($af2a7b930688c62d$var$wt), $af2a7b930688c62d$var$We = $af2a7b930688c62d$var$ne(function(r) {
    return function() {
        r(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
    };
}), $af2a7b930688c62d$var$_e = function(r) {
    $af2a7b930688c62d$var$H(t, r);
    function t() {
        var e = r.call(this) || this;
        return e.closed = !1, e.currentObservers = null, e.observers = [], e.isStopped = !1, e.hasError = !1, e.thrownError = null, e;
    }
    return t.prototype.lift = function(e) {
        var n = new $af2a7b930688c62d$var$Mt(this, this);
        return n.operator = e, n;
    }, t.prototype._throwIfClosed = function() {
        if (this.closed) throw new $af2a7b930688c62d$var$We();
    }, t.prototype.next = function(e) {
        var n = this;
        $af2a7b930688c62d$var$Y(function() {
            var o, i;
            if (n._throwIfClosed(), !n.isStopped) {
                n.currentObservers || (n.currentObservers = Array.from(n.observers));
                try {
                    for(var s = $af2a7b930688c62d$var$at(n.currentObservers), _ = s.next(); !_.done; _ = s.next()){
                        var u = _.value;
                        u.next(e);
                    }
                } catch (l) {
                    o = {
                        error: l
                    };
                } finally{
                    try {
                        _ && !_.done && (i = s.return) && i.call(s);
                    } finally{
                        if (o) throw o.error;
                    }
                }
            }
        });
    }, t.prototype.error = function(e) {
        var n = this;
        $af2a7b930688c62d$var$Y(function() {
            if (n._throwIfClosed(), !n.isStopped) {
                n.hasError = n.isStopped = !0, n.thrownError = e;
                for(var o = n.observers; o.length;)o.shift().error(e);
            }
        });
    }, t.prototype.complete = function() {
        var e = this;
        $af2a7b930688c62d$var$Y(function() {
            if (e._throwIfClosed(), !e.isStopped) {
                e.isStopped = !0;
                for(var n = e.observers; n.length;)n.shift().complete();
            }
        });
    }, t.prototype.unsubscribe = function() {
        this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
    }, Object.defineProperty(t.prototype, "observed", {
        get: function() {
            var e;
            return ((e = this.observers) === null || e === void 0 ? void 0 : e.length) > 0;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype._trySubscribe = function(e) {
        return this._throwIfClosed(), r.prototype._trySubscribe.call(this, e);
    }, t.prototype._subscribe = function(e) {
        return this._throwIfClosed(), this._checkFinalizedStatuses(e), this._innerSubscribe(e);
    }, t.prototype._innerSubscribe = function(e) {
        var n = this, o = this, i = o.hasError, s = o.isStopped, _ = o.observers;
        return i || s ? $af2a7b930688c62d$var$oe : (this.currentObservers = null, _.push(e), new $af2a7b930688c62d$var$Z(function() {
            n.currentObservers = null, $af2a7b930688c62d$var$dt(_, e);
        }));
    }, t.prototype._checkFinalizedStatuses = function(e) {
        var n = this, o = n.hasError, i = n.thrownError, s = n.isStopped;
        o ? e.error(i) : s && e.complete();
    }, t.prototype.asObservable = function() {
        var e = new $af2a7b930688c62d$var$It();
        return e.source = this, e;
    }, t.create = function(e, n) {
        return new $af2a7b930688c62d$var$Mt(e, n);
    }, t;
}($af2a7b930688c62d$var$It), $af2a7b930688c62d$var$Mt = function(r) {
    $af2a7b930688c62d$var$H(t, r);
    function t(e, n) {
        var o = r.call(this) || this;
        return o.destination = e, o.source = n, o;
    }
    return t.prototype.next = function(e) {
        var n, o;
        (o = (n = this.destination) === null || n === void 0 ? void 0 : n.next) === null || o === void 0 || o.call(n, e);
    }, t.prototype.error = function(e) {
        var n, o;
        (o = (n = this.destination) === null || n === void 0 ? void 0 : n.error) === null || o === void 0 || o.call(n, e);
    }, t.prototype.complete = function() {
        var e, n;
        (n = (e = this.destination) === null || e === void 0 ? void 0 : e.complete) === null || n === void 0 || n.call(e);
    }, t.prototype._subscribe = function(e) {
        var n, o;
        return (o = (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(e)) !== null && o !== void 0 ? o : $af2a7b930688c62d$var$oe;
    }, t;
}($af2a7b930688c62d$var$_e);
function $af2a7b930688c62d$var$ze(r, t) {
    return $af2a7b930688c62d$var$Le(function(e, n) {
        var o = 0;
        e.subscribe($af2a7b930688c62d$var$Re(n, function(i) {
            return r.call(t, i, o++) && n.next(i);
        }));
    });
}
var $af2a7b930688c62d$var$$, $af2a7b930688c62d$var$b, $af2a7b930688c62d$var$it, $af2a7b930688c62d$var$Nt, $af2a7b930688c62d$var$vt = 0, $af2a7b930688c62d$var$ue = [], $af2a7b930688c62d$var$G = [], $af2a7b930688c62d$var$S = $af2a7b930688c62d$var$h, $af2a7b930688c62d$var$Lt = $af2a7b930688c62d$var$S.__b, $af2a7b930688c62d$var$Rt = $af2a7b930688c62d$var$S.__r, $af2a7b930688c62d$var$Bt = $af2a7b930688c62d$var$S.diffed, $af2a7b930688c62d$var$Wt = $af2a7b930688c62d$var$S.__c, $af2a7b930688c62d$var$zt = $af2a7b930688c62d$var$S.unmount, $af2a7b930688c62d$var$qt = $af2a7b930688c62d$var$S.__;
function $af2a7b930688c62d$var$xt(r, t) {
    $af2a7b930688c62d$var$S.__h && $af2a7b930688c62d$var$S.__h($af2a7b930688c62d$var$b, r, $af2a7b930688c62d$var$vt || t), $af2a7b930688c62d$var$vt = 0;
    var e = $af2a7b930688c62d$var$b.__H || ($af2a7b930688c62d$var$b.__H = {
        __: [],
        __h: []
    });
    return r >= e.__.length && e.__.push({
        __V: $af2a7b930688c62d$var$G
    }), e.__[r];
}
function $af2a7b930688c62d$var$yt(r) {
    return $af2a7b930688c62d$var$vt = 1, $af2a7b930688c62d$var$qe($af2a7b930688c62d$var$ae, r);
}
function $af2a7b930688c62d$var$qe(r, t, e) {
    var n = $af2a7b930688c62d$var$xt($af2a7b930688c62d$var$$++, 2);
    if (n.t = r, !n.__c && (n.__ = [
        e ? e(t) : $af2a7b930688c62d$var$ae(void 0, t),
        function(_) {
            var u = n.__N ? n.__N[0] : n.__[0], l = n.t(u, _);
            u !== l && (n.__N = [
                l,
                n.__[1]
            ], n.__c.setState({}));
        }
    ], n.__c = $af2a7b930688c62d$var$b, !$af2a7b930688c62d$var$b.u)) {
        var o = function(_, u, l) {
            if (!n.__c.__H) return !0;
            var f = n.__c.__H.__.filter(function(p) {
                return !!p.__c;
            });
            if (f.every(function(p) {
                return !p.__N;
            })) return !i || i.call(this, _, u, l);
            var c = !1;
            return f.forEach(function(p) {
                if (p.__N) {
                    var a = p.__[0];
                    p.__ = p.__N, p.__N = void 0, a !== p.__[0] && (c = !0);
                }
            }), !(!c && n.__c.props === _) && (!i || i.call(this, _, u, l));
        };
        $af2a7b930688c62d$var$b.u = !0;
        var i = $af2a7b930688c62d$var$b.shouldComponentUpdate, s = $af2a7b930688c62d$var$b.componentWillUpdate;
        $af2a7b930688c62d$var$b.componentWillUpdate = function(_, u, l) {
            if (this.__e) {
                var f = i;
                i = void 0, o(_, u, l), i = f;
            }
            s && s.call(this, _, u, l);
        }, $af2a7b930688c62d$var$b.shouldComponentUpdate = o;
    }
    return n.__N || n.__;
}
function $af2a7b930688c62d$var$Ve(r, t) {
    var e = $af2a7b930688c62d$var$xt($af2a7b930688c62d$var$$++, 3);
    !$af2a7b930688c62d$var$S.__s && $af2a7b930688c62d$var$Je(e.__H, t) && (e.__ = r, e.i = t, $af2a7b930688c62d$var$b.__H.__h.push(e));
}
function $af2a7b930688c62d$var$le(r) {
    var t = $af2a7b930688c62d$var$b.context[r.__c], e = $af2a7b930688c62d$var$xt($af2a7b930688c62d$var$$++, 9);
    return e.c = r, t ? (e.__ == null && (e.__ = !0, t.sub($af2a7b930688c62d$var$b)), t.props.value) : r.__;
}
function $af2a7b930688c62d$var$Ye() {
    for(var r; r = $af2a7b930688c62d$var$ue.shift();)if (r.__P && r.__H) try {
        r.__H.__h.forEach($af2a7b930688c62d$var$J), r.__H.__h.forEach($af2a7b930688c62d$var$bt), r.__H.__h = [];
    } catch (t) {
        r.__H.__h = [], $af2a7b930688c62d$var$S.__e(t, r.__v);
    }
}
$af2a7b930688c62d$var$S.__b = function(r) {
    $af2a7b930688c62d$var$b = null, $af2a7b930688c62d$var$Lt && $af2a7b930688c62d$var$Lt(r);
}, $af2a7b930688c62d$var$S.__ = function(r, t) {
    r && t.__k && t.__k.__m && (r.__m = t.__k.__m), $af2a7b930688c62d$var$qt && $af2a7b930688c62d$var$qt(r, t);
}, $af2a7b930688c62d$var$S.__r = function(r) {
    $af2a7b930688c62d$var$Rt && $af2a7b930688c62d$var$Rt(r), $af2a7b930688c62d$var$$ = 0;
    var t = ($af2a7b930688c62d$var$b = r.__c).__H;
    t && ($af2a7b930688c62d$var$it === $af2a7b930688c62d$var$b ? (t.__h = [], $af2a7b930688c62d$var$b.__h = [], t.__.forEach(function(e) {
        e.__N && (e.__ = e.__N), e.__V = $af2a7b930688c62d$var$G, e.__N = e.i = void 0;
    })) : (t.__h.forEach($af2a7b930688c62d$var$J), t.__h.forEach($af2a7b930688c62d$var$bt), t.__h = [], $af2a7b930688c62d$var$$ = 0)), $af2a7b930688c62d$var$it = $af2a7b930688c62d$var$b;
}, $af2a7b930688c62d$var$S.diffed = function(r) {
    $af2a7b930688c62d$var$Bt && $af2a7b930688c62d$var$Bt(r);
    var t = r.__c;
    t && t.__H && (t.__H.__h.length && ($af2a7b930688c62d$var$ue.push(t) !== 1 && $af2a7b930688c62d$var$Nt === $af2a7b930688c62d$var$S.requestAnimationFrame || (($af2a7b930688c62d$var$Nt = $af2a7b930688c62d$var$S.requestAnimationFrame) || $af2a7b930688c62d$var$Ge)($af2a7b930688c62d$var$Ye)), t.__H.__.forEach(function(e) {
        e.i && (e.__H = e.i), e.__V !== $af2a7b930688c62d$var$G && (e.__ = e.__V), e.i = void 0, e.__V = $af2a7b930688c62d$var$G;
    })), $af2a7b930688c62d$var$it = $af2a7b930688c62d$var$b = null;
}, $af2a7b930688c62d$var$S.__c = function(r, t) {
    t.some(function(e) {
        try {
            e.__h.forEach($af2a7b930688c62d$var$J), e.__h = e.__h.filter(function(n) {
                return !n.__ || $af2a7b930688c62d$var$bt(n);
            });
        } catch (n) {
            t.some(function(o) {
                o.__h && (o.__h = []);
            }), t = [], $af2a7b930688c62d$var$S.__e(n, e.__v);
        }
    }), $af2a7b930688c62d$var$Wt && $af2a7b930688c62d$var$Wt(r, t);
}, $af2a7b930688c62d$var$S.unmount = function(r) {
    $af2a7b930688c62d$var$zt && $af2a7b930688c62d$var$zt(r);
    var t, e = r.__c;
    e && e.__H && (e.__H.__.forEach(function(n) {
        try {
            $af2a7b930688c62d$var$J(n);
        } catch (o) {
            t = o;
        }
    }), e.__H = void 0, t && $af2a7b930688c62d$var$S.__e(t, e.__v));
};
var $af2a7b930688c62d$var$Vt = typeof requestAnimationFrame == "function";
function $af2a7b930688c62d$var$Ge(r) {
    var t, e = function() {
        clearTimeout(n), $af2a7b930688c62d$var$Vt && cancelAnimationFrame(t), setTimeout(r);
    }, n = setTimeout(e, 100);
    $af2a7b930688c62d$var$Vt && (t = requestAnimationFrame(e));
}
function $af2a7b930688c62d$var$J(r) {
    var t = $af2a7b930688c62d$var$b, e = r.__c;
    typeof e == "function" && (r.__c = void 0, e()), $af2a7b930688c62d$var$b = t;
}
function $af2a7b930688c62d$var$bt(r) {
    var t = $af2a7b930688c62d$var$b;
    r.__c = r.__(), $af2a7b930688c62d$var$b = t;
}
function $af2a7b930688c62d$var$Je(r, t) {
    return !r || r.length !== t.length || t.some(function(e, n) {
        return e !== r[n];
    });
}
function $af2a7b930688c62d$var$ae(r, t) {
    return typeof t == "function" ? t(r) : t;
}
const $af2a7b930688c62d$var$K = (r, t)=>{
    const e = /* @__PURE__ */ new Map();
    return r.forEach((n)=>e.set(n, t.includes(n) ? "allow" : "deny")), e;
}, $af2a7b930688c62d$var$fe = (r)=>Array.from(r).reduce((t, [e, n])=>n === "allow" ? [
            ...t,
            e
        ] : t, []), $af2a7b930688c62d$var$Ke = (r)=>r.reduce((t, e)=>(t.set(e, "allow"), t), /* @__PURE__ */ new Map());
var $af2a7b930688c62d$var$Qe = 0;
function $af2a7b930688c62d$var$d(r, t, e, n, o, i) {
    var s, _, u = {};
    for(_ in t)_ == "ref" ? s = t[_] : u[_] = t[_];
    var l = {
        type: r,
        props: u,
        key: e,
        ref: s,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: --$af2a7b930688c62d$var$Qe,
        __i: -1,
        __u: 0,
        __source: o,
        __self: i
    };
    if (typeof r == "function" && (s = r.defaultProps)) for(_ in s)u[_] === void 0 && (u[_] = s[_]);
    return $af2a7b930688c62d$var$h.vnode && $af2a7b930688c62d$var$h.vnode(l), l;
}
const $af2a7b930688c62d$var$pe = $af2a7b930688c62d$var$Ct({}), $af2a7b930688c62d$var$Xe = ({ customStyles: r, children: t })=>$af2a7b930688c62d$var$d($af2a7b930688c62d$var$pe.Provider, {
        value: r,
        children: t
    });
function $af2a7b930688c62d$var$Ze(r) {
    const t = $af2a7b930688c62d$var$le($af2a7b930688c62d$var$pe);
    if (!t || !("classNames" in t)) return {};
    const { classNames: e } = t;
    return e === void 0 || r === void 0 || !("location" in e) ? e : e[r];
}
function $af2a7b930688c62d$var$tr(r, t, e, n) {
    return [
        ...(Array.isArray(t) ? t : [
            t
        ]).flatMap((i)=>n != null && n.includes(i) ? [] : [
                `cc-${i}`,
                r[i]
            ]),
        e
    ].flat().filter(Boolean).join(" ");
}
function $af2a7b930688c62d$var$tt(r) {
    const t = $af2a7b930688c62d$var$Ze(), e = (n)=>t[n];
    return (n)=>{
        const o = Array.isArray(n) ? n.map((i)=>e(i)) : [
            e(n)
        ];
        return $af2a7b930688c62d$var$tr(r, n, o.filter((i)=>typeof i == "string"), Object.keys(t));
    };
}
const $af2a7b930688c62d$var$er = "_button_1rlej_1", $af2a7b930688c62d$var$rr = {
    button: $af2a7b930688c62d$var$er,
    "button-primary": "_button-primary_1rlej_15",
    "button-secondary": "_button-secondary_1rlej_20"
}, $af2a7b930688c62d$var$W = (n)=>{
    var o = n, { priority: r = "secondary", children: t } = o, e = $af2a7b930688c62d$var$rt(o, [
        "priority",
        "children"
    ]);
    const i = $af2a7b930688c62d$var$tt($af2a7b930688c62d$var$rr);
    return $af2a7b930688c62d$var$d("button", $af2a7b930688c62d$var$Ut($af2a7b930688c62d$var$M({}, e), {
        className: i([
            "button",
            `button-${r}`
        ]),
        children: t
    }));
}, $af2a7b930688c62d$var$nr = {
    "button-set": "_button-set_1it6l_1"
}, $af2a7b930688c62d$var$or = ({ children: r })=>{
    const t = $af2a7b930688c62d$var$tt($af2a7b930688c62d$var$nr);
    return $af2a7b930688c62d$var$d("div", {
        className: t("button-set"),
        children: r
    });
}, $af2a7b930688c62d$var$ir = "_list_1ocrb_1", $af2a7b930688c62d$var$sr = {
    list: $af2a7b930688c62d$var$ir,
    "list-item": "_list-item_1ocrb_8",
    "list-title": "_list-title_1ocrb_14",
    "list-description": "_list-description_1ocrb_19",
    "list-checkbox": "_list-checkbox_1ocrb_24"
}, $af2a7b930688c62d$var$cr = ({ categories: r, consent: t, onChange: e })=>{
    const n = $af2a7b930688c62d$var$tt($af2a7b930688c62d$var$sr);
    return $af2a7b930688c62d$var$d("ul", {
        className: n("list"),
        children: r.map((o)=>{
            const i = o.id === "necessary";
            return $af2a7b930688c62d$var$d("li", {
                className: n("list-item"),
                children: [
                    $af2a7b930688c62d$var$d("input", {
                        type: "checkbox",
                        id: o.id,
                        className: n("list-checkbox"),
                        checked: i || t.includes(o.id),
                        disabled: i,
                        onChange: ()=>{
                            if (i) return;
                            const s = t.includes(o.id) ? t.filter((_)=>_ !== o.id) : [
                                ...t,
                                o.id
                            ];
                            return e(s);
                        }
                    }),
                    $af2a7b930688c62d$var$d("div", {
                        children: [
                            $af2a7b930688c62d$var$d("label", {
                                for: o.id,
                                className: n("list-title"),
                                children: o.title
                            }),
                            $af2a7b930688c62d$var$d("p", {
                                className: n("list-description"),
                                children: o.description
                            })
                        ]
                    })
                ]
            }, o.id);
        })
    });
}, $af2a7b930688c62d$var$de = $af2a7b930688c62d$var$Ct(/* @__PURE__ */ new Map()), $af2a7b930688c62d$var$_r = ({ events: r, defaultConsent: t, children: e })=>{
    const [n, o] = $af2a7b930688c62d$var$yt(t);
    return $af2a7b930688c62d$var$Ve(()=>{
        const i = r.subscribe((s)=>{
            s.type === "consent-updated" && o(s.details);
        });
        return ()=>i.unsubscribe();
    }, [
        r
    ]), $af2a7b930688c62d$var$d($af2a7b930688c62d$var$de.Provider, {
        value: n,
        children: e
    });
}, $af2a7b930688c62d$var$ur = ()=>$af2a7b930688c62d$var$le($af2a7b930688c62d$var$de), $af2a7b930688c62d$var$he = {
    accept: "Accept",
    configure: "Configure",
    deny: "Only necessary",
    acceptSelected: "Accept Selected"
}, $af2a7b930688c62d$var$ve = $af2a7b930688c62d$var$Ct($af2a7b930688c62d$var$he), $af2a7b930688c62d$var$lr = ({ strings: r, children: t })=>$af2a7b930688c62d$var$d($af2a7b930688c62d$var$ve.Provider, {
        value: $af2a7b930688c62d$var$M($af2a7b930688c62d$var$M({}, $af2a7b930688c62d$var$he), r),
        children: t
    }), $af2a7b930688c62d$var$z = ({ id: r })=>$af2a7b930688c62d$var$d($af2a7b930688c62d$var$ve.Consumer, {
        children: (t)=>t[r]
    }), $af2a7b930688c62d$var$ar = "_box_1rs3p_1", $af2a7b930688c62d$var$fr = {
    box: $af2a7b930688c62d$var$ar
}, $af2a7b930688c62d$var$pr = ({ heading: r, message: t, categories: e, onConsent: n })=>{
    const [o, i] = $af2a7b930688c62d$var$yt(!1), s = $af2a7b930688c62d$var$tt($af2a7b930688c62d$var$fr), _ = $af2a7b930688c62d$var$ur(), [u, l] = $af2a7b930688c62d$var$yt($af2a7b930688c62d$var$fe(_)), f = e.map(({ id: g })=>g), c = ()=>{
        n($af2a7b930688c62d$var$K(f, f)), i(!1);
    }, p = ()=>{
        n($af2a7b930688c62d$var$K(f, [
            "necessary",
            ...u
        ])), i(!1);
    }, a = ()=>{
        n($af2a7b930688c62d$var$K(f, [
            "necessary"
        ])), i(!1);
    }, v = t.trim().startsWith("<p") ? $af2a7b930688c62d$var$d("div", {
        class: s("message"),
        dangerouslySetInnerHTML: {
            __html: t
        }
    }) : $af2a7b930688c62d$var$d("p", {
        class: s("message"),
        dangerouslySetInnerHTML: {
            __html: t
        }
    });
    return $af2a7b930688c62d$var$d("div", {
        class: s("box"),
        children: [
            r && $af2a7b930688c62d$var$d("h1", {
                class: s("heading"),
                children: r
            }),
            v,
            !o && $af2a7b930688c62d$var$d($af2a7b930688c62d$var$or, {
                children: [
                    $af2a7b930688c62d$var$d($af2a7b930688c62d$var$W, {
                        onClick: c,
                        priority: "primary",
                        children: $af2a7b930688c62d$var$d($af2a7b930688c62d$var$z, {
                            id: "accept"
                        })
                    }),
                    $af2a7b930688c62d$var$d($af2a7b930688c62d$var$W, {
                        onClick: ()=>i((g)=>!g),
                        children: $af2a7b930688c62d$var$d($af2a7b930688c62d$var$z, {
                            id: "configure"
                        })
                    }),
                    $af2a7b930688c62d$var$d($af2a7b930688c62d$var$W, {
                        onClick: a,
                        children: $af2a7b930688c62d$var$d($af2a7b930688c62d$var$z, {
                            id: "deny"
                        })
                    })
                ]
            }),
            o && $af2a7b930688c62d$var$d($af2a7b930688c62d$var$O, {
                children: [
                    $af2a7b930688c62d$var$d($af2a7b930688c62d$var$cr, {
                        categories: e,
                        consent: u,
                        onChange: l
                    }),
                    $af2a7b930688c62d$var$d($af2a7b930688c62d$var$W, {
                        onClick: p,
                        priority: "primary",
                        children: $af2a7b930688c62d$var$d($af2a7b930688c62d$var$z, {
                            id: "acceptSelected"
                        })
                    })
                ]
            })
        ]
    });
};
class $af2a7b930688c62d$export$e06767a507a85916 {
    constructor(t){
        this.version = "1", this.element = document.createElement("div"), this.events = new $af2a7b930688c62d$var$_e(), this.extensions = [], this.handleConsent = (s)=>{
            this.events.next({
                type: "consent-updated",
                details: s
            }), this.close();
        };
        const i = t, { extensions: e } = i, n = $af2a7b930688c62d$var$rt(i, [
            "extensions"
        ]);
        this.settings = n, this.extensions = e, this.extensions.forEach((s)=>s.init(this)), this.renderUI();
        const o = this.readCookie();
        o && o.size > 0 ? this.events.next({
            type: "consent-updated",
            details: o
        }) : this.open(), document.querySelectorAll("[data-cc-open]").forEach((s)=>{
            s.addEventListener("click", ()=>this.open());
        }), this.events.pipe($af2a7b930688c62d$var$ze((s)=>s.type === "consent-updated")).subscribe((s)=>this.writeCookie(s.details));
    }
    subscribe(t) {
        return this.events.subscribe(t);
    }
    extend(t) {
        t.init(this), this.extensions.push(t);
    }
    open() {
        document.body.appendChild(this.element);
    }
    close() {
        document.body.removeChild(this.element);
    }
    renderUI() {
        $af2a7b930688c62d$var$Ae($af2a7b930688c62d$var$d($af2a7b930688c62d$var$lr, {
            strings: this.settings.strings,
            children: $af2a7b930688c62d$var$d($af2a7b930688c62d$var$Xe, {
                customStyles: this.settings.styles || {},
                children: $af2a7b930688c62d$var$d($af2a7b930688c62d$var$_r, {
                    events: this.events,
                    defaultConsent: this.readCookie() || this.getDefaultConsent(),
                    children: $af2a7b930688c62d$var$d($af2a7b930688c62d$var$pr, {
                        heading: this.settings.heading,
                        message: this.settings.message,
                        categories: this.settings.categories,
                        onConsent: this.handleConsent
                    })
                })
            })
        }), this.element);
    }
    readCookie() {
        const t = $af2a7b930688c62d$var$R.get("cc-version"), e = $af2a7b930688c62d$var$R.get("cc-details");
        if (t !== this.version || typeof e != "string") return;
        const n = JSON.parse(e);
        return !Array.isArray(n) || n.some((i)=>typeof i != "string") ? void 0 : $af2a7b930688c62d$var$Ke(n);
    }
    writeCookie(t) {
        const e = $af2a7b930688c62d$var$fe(t);
        $af2a7b930688c62d$var$R.set("cc-version", this.version, {
            expires: 365,
            sameSite: "strict"
        }), $af2a7b930688c62d$var$R.set("cc-details", JSON.stringify(e), {
            expires: 365,
            sameSite: "strict"
        });
    }
    getDefaultConsent() {
        return $af2a7b930688c62d$var$K(this.settings.categories.map(({ id: t })=>t), [
            "necessary"
        ]);
    }
}
class $af2a7b930688c62d$var$ye {
    init(t) {
        this.consent = t, this.apply();
    }
}
class $af2a7b930688c62d$export$ba52076bce1ff2fa extends $af2a7b930688c62d$var$ye {
    constructor(t){
        super(), this.settings = t, globalThis.dataLayer = globalThis.dataLayer || [];
    }
    apply() {
        var t;
        this.sendDefault(), (t = this.consent) == null || t.subscribe((e)=>{
            e.type === "consent-updated" && this.sendUpdate(e.details);
        });
    }
    sendDefault() {
        this.gtag("consent", "default", {
            ad_user_data: "denied",
            ad_personalization: "denied",
            ad_storage: "denied",
            analytics_storage: "denied",
            wait_for_update: 500
        });
    }
    sendUpdate(t) {
        const e = this.settings.categories, n = (o)=>o && t.has(o) && t.get(o) === "allow" ? "granted" : "denied";
        this.gtag("consent", "update", {
            ad_user_data: n(e == null ? void 0 : e.ad_user_data),
            ad_personalization: n(e == null ? void 0 : e.ad_personalization),
            ad_storage: n(e == null ? void 0 : e.ad_storage),
            analytics_storage: n(e == null ? void 0 : e.analytics_storage),
            wait_for_update: 500
        });
    }
    gtag(...t) {
        dataLayer == null || dataLayer.push(t);
    }
}
const $af2a7b930688c62d$var$Yt = (r)=>r === "necessary" || r === "statistics" || r === "marketing";
class $af2a7b930688c62d$export$f29fc6f6bfb23801 extends $af2a7b930688c62d$var$ye {
    constructor(){
        super(...arguments), this.createScript = (t)=>{
            const e = document.createElement("script");
            return [
                "src",
                "async",
                "crossorigin",
                "defer",
                "integrity",
                "nonce",
                "referrerpolicy"
            ].forEach((n)=>{
                if (t.hasAttribute(n)) {
                    const o = t.getAttribute(n);
                    e.setAttribute(n, o || "");
                }
            }), t.hasAttribute("data-src") && e.setAttribute("src", t.getAttribute("data-src") || ""), t.text && (e.text = t.text), e;
        };
    }
    apply() {
        var t;
        (t = this.consent) == null || t.subscribe((e)=>{
            e.type === "consent-updated" && this.update(e.details);
        });
    }
    update(t) {
        this.updateImages(t), this.updateScripts(t);
    }
    /**
   * Update all images that have a `data-cc-category` attribute. If the consent
   * for the category is `allow`, the image will be loaded.
   */ updateImages(t) {
        document.querySelectorAll("img[data-cc-category]").forEach((n)=>{
            var i;
            const o = n.getAttribute("data-cc-category");
            $af2a7b930688c62d$var$Yt(o) && t.get(o) === "allow" && (n.setAttribute("src", n.getAttribute("data-cc-src") || ""), (i = this.consent) == null || i.events.next({
                type: "image-loaded",
                details: {
                    src: n.src,
                    id: n.id
                }
            }));
        });
    }
    /**
   * Update all scripts that have a `data-cc-category` attribute. If the consent
   * for the category is `allow`, the script will be loaded.
   */ updateScripts(t) {
        document.querySelectorAll("script[data-cc-category]").forEach((n)=>{
            var i;
            const o = n.getAttribute("data-cc-category");
            $af2a7b930688c62d$var$Yt(o) && t.get(o) === "allow" && (this.appendScript(n), (i = this.consent) == null || i.events.next({
                type: "script-loaded",
                details: {
                    src: n.src,
                    id: n.id
                }
            }));
        });
    }
    /**
   * Append a script element to the DOM. This will trigger the script to load.
   */ appendScript(t) {
        var n;
        const e = this.createScript(t);
        (n = t.parentNode) == null || n.replaceChild(e, t);
    }
}


/**
 * Get strings from the WordPress localization object.
 */ function $b20fa2b03967e457$var$resolveString(strings, path) {
    if (path.length === 0) return null;
    const [part, ...rest] = path;
    const current = strings[part];
    if (typeof current === "string") return current;
    if (current === undefined) return null;
    return $b20fa2b03967e457$var$resolveString(current, rest);
}
function $b20fa2b03967e457$export$f8963f3214707ee4(key, fallback) {
    const path = key.split(".");
    const string = $b20fa2b03967e457$var$resolveString(globalThis.shuStrings, path);
    if (string === null || string === "") return fallback;
    return string;
}


const $b17d72d7d95711db$var$cc = new (0, $af2a7b930688c62d$export$e06767a507a85916)({
    heading: (0, $b20fa2b03967e457$export$f8963f3214707ee4)("cookieHeading", "Cookie-inst\xe4llningar"),
    message: (0, $b20fa2b03967e457$export$f8963f3214707ee4)("cookieMessage", ""),
    categories: [
        {
            id: "necessary",
            title: (0, $b20fa2b03967e457$export$f8963f3214707ee4)("cookieCategories.necessaryTitle", "N\xf6dv\xe4ndiga"),
            description: (0, $b20fa2b03967e457$export$f8963f3214707ee4)("cookieCategories.necessaryDescription", "Cookies som \xe4r n\xf6dv\xe4ndiga f\xf6r webbplatsens funktionalitet.")
        },
        {
            id: "statistics",
            title: (0, $b20fa2b03967e457$export$f8963f3214707ee4)("cookieCategories.statisticsTitle", "Statistik"),
            description: (0, $b20fa2b03967e457$export$f8963f3214707ee4)("cookieCategories.statisticsDescription", "Cookies som anv\xe4nds f\xf6r att m\xe4ta hur webbplatsen anv\xe4nds.")
        },
        {
            id: "marketing",
            title: (0, $b20fa2b03967e457$export$f8963f3214707ee4)("cookieCategories.marketingTitle", "Marknadsf\xf6ring"),
            description: (0, $b20fa2b03967e457$export$f8963f3214707ee4)("cookieCategories.marketingDescription", "Cookies som anv\xe4nds i marknadsf\xf6ringssyfte.")
        }
    ],
    strings: {
        accept: (0, $b20fa2b03967e457$export$f8963f3214707ee4)("cookieActions.accept", "Acceptera alla"),
        configure: (0, $b20fa2b03967e457$export$f8963f3214707ee4)("cookieActions.configure", "Inst\xe4llningar"),
        deny: (0, $b20fa2b03967e457$export$f8963f3214707ee4)("cookieActions.deny", "Endast n\xf6dv\xe4ndiga"),
        acceptSelected: (0, $b20fa2b03967e457$export$f8963f3214707ee4)("cookieActions.acceptSelected", "Acceptera valda")
    },
    extensions: [
        new (0, $af2a7b930688c62d$export$ba52076bce1ff2fa)({
            categories: {
                ad_user_data: "marketing",
                ad_personalization: "marketing",
                ad_storage: "marketing",
                analytics_storage: "statistics"
            }
        }),
        new (0, $af2a7b930688c62d$export$f29fc6f6bfb23801)()
    ]
});






})();
//# sourceMappingURL=scripts.js.map
